import { useQuery, UseQueryOptions } from '@tanstack/react-query';
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const localProxy = "/cms";
import { DatoJsonField } from "src/types";

function fetcher<TData, TVariables>(query: string, variables?: TVariables) {
  return async (): Promise<TData> => {
    const res = await fetch(localProxy as string, {
    method: "POST",
    ...({"headers":{"Authorization":"Bearer de341be9b97d765887861a1d316179","X-Exclude-Invalid":"true","Content-Type":"application/json"}}),
      body: JSON.stringify({ query, variables }),
    });

    const json = await res.json();

    if (json.errors) {
      const { message } = json.errors[0];

      throw new Error(message);
    }

    return json.data;
  }
}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  BooleanType: { input: boolean; output: boolean; }
  CustomData: { input: any; output: any; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  FloatType: { input: number; output: number; }
  IntType: { input: number; output: number; }
  ItemId: { input: string; output: string; }
  JsonField: { input: DatoJsonField; output: DatoJsonField; }
  MetaTagAttributes: { input: any; output: any; }
  UploadId: { input: any; output: any; }
};

export type AboutModelTextBlocksField = InlineAssetRecord | InlineLinkButtonRecord | InlineModalButtonRecord;

export type AboutModelTextField = {
  __typename: 'AboutModelTextField';
  blocks: Array<AboutModelTextBlocksField>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

/** Block of type About Funk (about) */
export type AboutRecord = RecordInterface & {
  __typename: 'AboutRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  text: AboutModelTextField;
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type About Funk (about) */
export type AboutRecord_SeoMetaTagsArgs = {
  locale: InputMaybe<SiteLocale>;
};

/** Block of type [Action Teaser Section] Item (action_teaser_section_item) */
export type ActionTeaserSectionItemRecord = RecordInterface & {
  __typename: 'ActionTeaserSectionItemRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  image: FileField;
  label: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type [Action Teaser Section] Item (action_teaser_section_item) */
export type ActionTeaserSectionItemRecord_SeoMetaTagsArgs = {
  locale: InputMaybe<SiteLocale>;
};

/** Block of type [Section] Action Teaser (action_teaser_section) */
export type ActionTeaserSectionRecord = RecordInterface & {
  __typename: 'ActionTeaserSectionRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  button: InlineModalButtonRecord;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  items: Array<ActionTeaserSectionItemRecord>;
  subtitle: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type [Section] Action Teaser (action_teaser_section) */
export type ActionTeaserSectionRecord_SeoMetaTagsArgs = {
  locale: InputMaybe<SiteLocale>;
};


/** Block of type [Section] Action Teaser (action_teaser_section) */
export type ActionTeaserSectionRecordSubtitleArgs = {
  markdown: InputMaybe<Scalars['Boolean']['input']>;
};

export type AuthorModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<AuthorModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<AuthorModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _locales?: InputMaybe<LocalesFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  description?: InputMaybe<StringFilter>;
  id?: InputMaybe<ItemIdFilter>;
  image?: InputMaybe<FileFilter>;
  name?: InputMaybe<StringFilter>;
  phoneNumber?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum AuthorModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  description_ASC = 'description_ASC',
  description_DESC = 'description_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  name_ASC = 'name_ASC',
  name_DESC = 'name_DESC',
  phoneNumber_ASC = 'phoneNumber_ASC',
  phoneNumber_DESC = 'phoneNumber_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

/** Record of type Author (author) */
export type AuthorRecord = RecordInterface & {
  __typename: 'AuthorRecord';
  _allDescriptionLocales: Maybe<Array<StringMultiLocaleField>>;
  _allPhoneNumberLocales: Maybe<Array<StringNonNullMultiLocaleField>>;
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _locales: Array<SiteLocale>;
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['ItemId']['output'];
  image: FileField;
  name: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


/** Record of type Author (author) */
export type AuthorRecord_AllDescriptionLocalesArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Author (author) */
export type AuthorRecord_AllPhoneNumberLocalesArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Author (author) */
export type AuthorRecord_SeoMetaTagsArgs = {
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Author (author) */
export type AuthorRecordDescriptionArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Author (author) */
export type AuthorRecordPhoneNumberArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};

/** Block of type Benefit (benefit) */
export type BenefitRecord = RecordInterface & {
  __typename: 'BenefitRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  icon: FileField;
  id: Scalars['ItemId']['output'];
  text: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Benefit (benefit) */
export type BenefitRecord_SeoMetaTagsArgs = {
  locale: InputMaybe<SiteLocale>;
};


/** Block of type Benefit (benefit) */
export type BenefitRecordTextArgs = {
  markdown: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlogpostModelBottomContentField = AboutRecord | ContactSectionRecord | CtaSectionRecord | CustomerReviewsSectionRecord | FaqSectionRecord | ImageTextSectionRecord | LinkCardsSectionRecord | LogoWallSectionRecord | MissionRecord | MissionSliderRecord | NewsletterSectionRecord | NewsletterSignupRecord | OffersBlockRecord | PersonaRecord | ServiceBenefitRecord | TextSectionRecord | VideoCollectionRecord;

export type BlogpostModelBottomContentFieldListListNonNullMultiLocaleField = {
  __typename: 'BlogpostModelBottomContentFieldListListNonNullMultiLocaleField';
  locale: Maybe<SiteLocale>;
  value: Array<BlogpostModelBottomContentField>;
};

/** Linking fields */
export enum BlogpostModelFieldsReferencingBrandModel {
  blogpost_brands = 'blogpost_brands'
}

/** Linking fields */
export enum BlogpostModelFieldsReferencingBreadcrumbModel {
  blogpost_bottomContent = 'blogpost_bottomContent',
  blogpost_bottomContent__about_text__inlineLinkButton_internal = 'blogpost_bottomContent__about_text__inlineLinkButton_internal',
  blogpost_bottomContent__ctaSection_linkButtons__inlineLinkButton_internal = 'blogpost_bottomContent__ctaSection_linkButtons__inlineLinkButton_internal',
  blogpost_bottomContent__imageTextSection_text__inlineLinkButton_internal = 'blogpost_bottomContent__imageTextSection_text__inlineLinkButton_internal',
  blogpost_bottomContent__linkCardsSection_cards__linkCard_links__inlineLinkButton_internal = 'blogpost_bottomContent__linkCardsSection_cards__linkCard_links__inlineLinkButton_internal',
  blogpost_bottomContent__offersBlock_text__offerSingle_link__inlineLinkButton_internal = 'blogpost_bottomContent__offersBlock_text__offerSingle_link__inlineLinkButton_internal',
  blogpost_bottomContent__textSection_text__inlineLinkButton_internal = 'blogpost_bottomContent__textSection_text__inlineLinkButton_internal',
  blogpost_bottomContent__videoCollection_intro__inlineLinkButton_internal = 'blogpost_bottomContent__videoCollection_intro__inlineLinkButton_internal',
  blogpost_text = 'blogpost_text',
  blogpost_text__inlineLinkButton_internal = 'blogpost_text__inlineLinkButton_internal',
  blogpost_topContent = 'blogpost_topContent',
  blogpost_topContent__about_text__inlineLinkButton_internal = 'blogpost_topContent__about_text__inlineLinkButton_internal',
  blogpost_topContent__blogpostSection_intro__inlineLinkButton_internal = 'blogpost_topContent__blogpostSection_intro__inlineLinkButton_internal',
  blogpost_topContent__ctaSection_linkButtons__inlineLinkButton_internal = 'blogpost_topContent__ctaSection_linkButtons__inlineLinkButton_internal',
  blogpost_topContent__heroSlider_slides__hero_cta__inlineLinkButton_internal = 'blogpost_topContent__heroSlider_slides__hero_cta__inlineLinkButton_internal',
  blogpost_topContent__heroSlider_slides__hero_text__inlineLinkButton_internal = 'blogpost_topContent__heroSlider_slides__hero_text__inlineLinkButton_internal',
  blogpost_topContent__hero_cta__inlineLinkButton_internal = 'blogpost_topContent__hero_cta__inlineLinkButton_internal',
  blogpost_topContent__hero_text__inlineLinkButton_internal = 'blogpost_topContent__hero_text__inlineLinkButton_internal',
  blogpost_topContent__imageTextSection_text__inlineLinkButton_internal = 'blogpost_topContent__imageTextSection_text__inlineLinkButton_internal',
  blogpost_topContent__linkCardsSection_cards__linkCard_links__inlineLinkButton_internal = 'blogpost_topContent__linkCardsSection_cards__linkCard_links__inlineLinkButton_internal',
  blogpost_topContent__navigationSection_links__inlineLinkButton_internal = 'blogpost_topContent__navigationSection_links__inlineLinkButton_internal',
  blogpost_topContent__offersBlock_text__offerSingle_link__inlineLinkButton_internal = 'blogpost_topContent__offersBlock_text__offerSingle_link__inlineLinkButton_internal',
  blogpost_topContent__textSection_text__inlineLinkButton_internal = 'blogpost_topContent__textSection_text__inlineLinkButton_internal',
  blogpost_topContent__videoCollection_intro__inlineLinkButton_internal = 'blogpost_topContent__videoCollection_intro__inlineLinkButton_internal'
}

export type BlogpostModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<BlogpostModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BlogpostModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _locales?: InputMaybe<LocalesFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  author?: InputMaybe<LinkFilter>;
  brands?: InputMaybe<LinksFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  date?: InputMaybe<DateFilter>;
  header?: InputMaybe<LinkFilter>;
  id?: InputMaybe<ItemIdFilter>;
  position?: InputMaybe<PositionFilter>;
  readingTime?: InputMaybe<IntegerFilter>;
  seo?: InputMaybe<SeoFilter>;
  slug?: InputMaybe<SlugFilter>;
  teaserImage?: InputMaybe<FileFilter>;
  teaserText?: InputMaybe<TextFilter>;
  text?: InputMaybe<StructuredTextFilter>;
  title?: InputMaybe<StringFilter>;
  topic?: InputMaybe<LinkFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum BlogpostModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  date_ASC = 'date_ASC',
  date_DESC = 'date_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  position_ASC = 'position_ASC',
  position_DESC = 'position_DESC',
  readingTime_ASC = 'readingTime_ASC',
  readingTime_DESC = 'readingTime_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type BlogpostModelTextField = {
  __typename: 'BlogpostModelTextField';
  blocks: Array<InlineLinkButtonRecord>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

export type BlogpostModelTextFieldMultiLocaleField = {
  __typename: 'BlogpostModelTextFieldMultiLocaleField';
  locale: Maybe<SiteLocale>;
  value: Maybe<BlogpostModelTextField>;
};

export type BlogpostModelTopContentField = AboutRecord | BlogpostSectionRecord | ContactSectionRecord | CtaSectionRecord | CustomerReviewsSectionRecord | FaqSectionRecord | HeroRecord | HeroSliderRecord | ImageTextSectionRecord | LinkCardsSectionRecord | LogoWallSectionRecord | MissionRecord | MissionSliderRecord | NavigationSectionRecord | NewsletterSectionRecord | NewsletterSignupRecord | OffersBlockRecord | PersonaRecord | PremiumCalcHeroRecord | ServiceBenefitRecord | TextSectionRecord | VideoCollectionRecord;

export type BlogpostModelTopContentFieldListListNonNullMultiLocaleField = {
  __typename: 'BlogpostModelTopContentFieldListListNonNullMultiLocaleField';
  locale: Maybe<SiteLocale>;
  value: Array<BlogpostModelTopContentField>;
};

/** Record of type Blogpost (blogpost) */
export type BlogpostRecord = RecordInterface & {
  __typename: 'BlogpostRecord';
  _allBottomContentLocales: Maybe<Array<BlogpostModelBottomContentFieldListListNonNullMultiLocaleField>>;
  _allSeoLocales: Maybe<Array<SeoFieldMultiLocaleField>>;
  _allSlugLocales: Maybe<Array<StringNonNullMultiLocaleField>>;
  _allTeaserTextLocales: Maybe<Array<StringNonNullMultiLocaleField>>;
  _allTextLocales: Maybe<Array<BlogpostModelTextFieldMultiLocaleField>>;
  _allTitleLocales: Maybe<Array<StringNonNullMultiLocaleField>>;
  _allTopContentLocales: Maybe<Array<BlogpostModelTopContentFieldListListNonNullMultiLocaleField>>;
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _locales: Array<SiteLocale>;
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  author: AuthorRecord;
  bottomContent: Array<BlogpostModelBottomContentField>;
  brands: Array<BrandRecord>;
  createdAt: Scalars['DateTime']['output'];
  date: Scalars['Date']['output'];
  header: HeaderRecord;
  id: Scalars['ItemId']['output'];
  position: Maybe<Scalars['IntType']['output']>;
  readingTime: Scalars['IntType']['output'];
  seo: Maybe<SeoField>;
  slug: Scalars['String']['output'];
  teaserImage: FileField;
  teaserText: Scalars['String']['output'];
  text: Maybe<BlogpostModelTextField>;
  title: Scalars['String']['output'];
  topContent: Array<BlogpostModelTopContentField>;
  topic: InsuranceProductFamilyRecord;
  updatedAt: Scalars['DateTime']['output'];
};


/** Record of type Blogpost (blogpost) */
export type BlogpostRecord_AllBottomContentLocalesArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Blogpost (blogpost) */
export type BlogpostRecord_AllSeoLocalesArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Blogpost (blogpost) */
export type BlogpostRecord_AllSlugLocalesArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Blogpost (blogpost) */
export type BlogpostRecord_AllTeaserTextLocalesArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
  markdown: InputMaybe<Scalars['Boolean']['input']>;
};


/** Record of type Blogpost (blogpost) */
export type BlogpostRecord_AllTextLocalesArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Blogpost (blogpost) */
export type BlogpostRecord_AllTitleLocalesArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Blogpost (blogpost) */
export type BlogpostRecord_AllTopContentLocalesArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Blogpost (blogpost) */
export type BlogpostRecord_SeoMetaTagsArgs = {
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Blogpost (blogpost) */
export type BlogpostRecordBottomContentArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Blogpost (blogpost) */
export type BlogpostRecordSeoArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Blogpost (blogpost) */
export type BlogpostRecordSlugArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Blogpost (blogpost) */
export type BlogpostRecordTeaserTextArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
  markdown: InputMaybe<Scalars['Boolean']['input']>;
};


/** Record of type Blogpost (blogpost) */
export type BlogpostRecordTextArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Blogpost (blogpost) */
export type BlogpostRecordTitleArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Blogpost (blogpost) */
export type BlogpostRecordTopContentArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};

export type BlogpostSectionModelIntroField = {
  __typename: 'BlogpostSectionModelIntroField';
  blocks: Array<InlineLinkButtonRecord>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

/** Block of type Blogpost Section (blogpost_section) */
export type BlogpostSectionRecord = RecordInterface & {
  __typename: 'BlogpostSectionRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  intro: Maybe<BlogpostSectionModelIntroField>;
  topicSelector: Maybe<Scalars['BooleanType']['output']>;
  topicSelectorText: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Blogpost Section (blogpost_section) */
export type BlogpostSectionRecord_SeoMetaTagsArgs = {
  locale: InputMaybe<SiteLocale>;
};

/** Specifies how to filter Boolean fields */
export type BooleanFilter = {
  /** Search for records with an exact match */
  eq?: InputMaybe<Scalars['BooleanType']['input']>;
};

export type BrandModelBrokerPortalContentField = AboutRecord | ActionTeaserSectionRecord | ContactSectionRecord | CtaSectionRecord | CustomerReviewsSectionRecord | FaqSectionRecord | HeroRecord | ImageTextSectionRecord | LogoWallSectionRecord | MissionRecord | MissionSliderRecord | NewsletterSignupRecord | OffersBlockRecord | PersonaRecord | ProductComparisonRecord | ServiceBenefitRecord | TextSectionRecord | VideoCollectionRecord;

export type BrandModelBrokerPortalContentFieldListListNonNullMultiLocaleField = {
  __typename: 'BrandModelBrokerPortalContentFieldListListNonNullMultiLocaleField';
  locale: Maybe<SiteLocale>;
  value: Array<BrandModelBrokerPortalContentField>;
};

export type BrandModelBrokerPortalDetailContentField = ContactSectionRecord | ImageTextSectionRecord;

/** Linking fields */
export enum BrandModelFieldsReferencingBreadcrumbModel {
  brand_brokerPortalContent = 'brand_brokerPortalContent',
  brand_brokerPortalContent__about_text__inlineLinkButton_internal = 'brand_brokerPortalContent__about_text__inlineLinkButton_internal',
  brand_brokerPortalContent__ctaSection_linkButtons__inlineLinkButton_internal = 'brand_brokerPortalContent__ctaSection_linkButtons__inlineLinkButton_internal',
  brand_brokerPortalContent__hero_cta__inlineLinkButton_internal = 'brand_brokerPortalContent__hero_cta__inlineLinkButton_internal',
  brand_brokerPortalContent__hero_text__inlineLinkButton_internal = 'brand_brokerPortalContent__hero_text__inlineLinkButton_internal',
  brand_brokerPortalContent__imageTextSection_text__inlineLinkButton_internal = 'brand_brokerPortalContent__imageTextSection_text__inlineLinkButton_internal',
  brand_brokerPortalContent__offersBlock_text__offerSingle_link__inlineLinkButton_internal = 'brand_brokerPortalContent__offersBlock_text__offerSingle_link__inlineLinkButton_internal',
  brand_brokerPortalContent__productComparison_products__product_description__inlineLinkButton_internal = 'brand_brokerPortalContent__productComparison_products__product_description__inlineLinkButton_internal',
  brand_brokerPortalContent__textSection_text__inlineLinkButton_internal = 'brand_brokerPortalContent__textSection_text__inlineLinkButton_internal',
  brand_brokerPortalContent__videoCollection_intro__inlineLinkButton_internal = 'brand_brokerPortalContent__videoCollection_intro__inlineLinkButton_internal',
  brand_brokerPortalDetailContent = 'brand_brokerPortalDetailContent',
  brand_brokerPortalDetailContent__imageTextSection_text__inlineLinkButton_internal = 'brand_brokerPortalDetailContent__imageTextSection_text__inlineLinkButton_internal',
  brand_footerLeftColumn = 'brand_footerLeftColumn',
  brand_footerLeftColumn__inlineLinkButton_internal = 'brand_footerLeftColumn__inlineLinkButton_internal',
  brand_footerRightColumn = 'brand_footerRightColumn',
  brand_footerRightColumn__inlineLinkButton_internal = 'brand_footerRightColumn__inlineLinkButton_internal',
  brand_portalContent = 'brand_portalContent',
  brand_portalContent__about_text__inlineLinkButton_internal = 'brand_portalContent__about_text__inlineLinkButton_internal',
  brand_portalContent__ctaSection_linkButtons__inlineLinkButton_internal = 'brand_portalContent__ctaSection_linkButtons__inlineLinkButton_internal',
  brand_portalContent__hero_cta__inlineLinkButton_internal = 'brand_portalContent__hero_cta__inlineLinkButton_internal',
  brand_portalContent__hero_text__inlineLinkButton_internal = 'brand_portalContent__hero_text__inlineLinkButton_internal',
  brand_portalContent__imageTextSection_text__inlineLinkButton_internal = 'brand_portalContent__imageTextSection_text__inlineLinkButton_internal',
  brand_portalContent__offersBlock_text__offerSingle_link__inlineLinkButton_internal = 'brand_portalContent__offersBlock_text__offerSingle_link__inlineLinkButton_internal',
  brand_portalContent__productComparison_products__product_description__inlineLinkButton_internal = 'brand_portalContent__productComparison_products__product_description__inlineLinkButton_internal',
  brand_portalContent__textSection_text__inlineLinkButton_internal = 'brand_portalContent__textSection_text__inlineLinkButton_internal',
  brand_portalContent__videoCollection_intro__inlineLinkButton_internal = 'brand_portalContent__videoCollection_intro__inlineLinkButton_internal'
}

export type BrandModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<BrandModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BrandModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _locales?: InputMaybe<LocalesFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  brokerPortalHeader?: InputMaybe<LinkFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  favicon?: InputMaybe<FileFilter>;
  featureFlags?: InputMaybe<JsonFilter>;
  footerText?: InputMaybe<StringFilter>;
  footerTitle?: InputMaybe<StringFilter>;
  headerLogo?: InputMaybe<FileFilter>;
  id?: InputMaybe<ItemIdFilter>;
  maintenanceMode?: InputMaybe<BooleanFilter>;
  portalHeader?: InputMaybe<LinkFilter>;
  redirects?: InputMaybe<JsonFilter>;
  robotsAllowIndexing?: InputMaybe<BooleanFilter>;
  sitemapXmlAdditionalAssets?: InputMaybe<GalleryFilter>;
  slug?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export type BrandModelFooterLeftColumnField = InlineLinkButtonRecord | InlineModalButtonRecord;

export type BrandModelFooterLeftColumnFieldListListNonNullMultiLocaleField = {
  __typename: 'BrandModelFooterLeftColumnFieldListListNonNullMultiLocaleField';
  locale: Maybe<SiteLocale>;
  value: Array<BrandModelFooterLeftColumnField>;
};

export type BrandModelFooterRightColumnField = InlineLinkButtonRecord | InlineModalButtonRecord;

export type BrandModelFooterRightColumnFieldListListNonNullMultiLocaleField = {
  __typename: 'BrandModelFooterRightColumnFieldListListNonNullMultiLocaleField';
  locale: Maybe<SiteLocale>;
  value: Array<BrandModelFooterRightColumnField>;
};

export enum BrandModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  footerText_ASC = 'footerText_ASC',
  footerText_DESC = 'footerText_DESC',
  footerTitle_ASC = 'footerTitle_ASC',
  footerTitle_DESC = 'footerTitle_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  maintenanceMode_ASC = 'maintenanceMode_ASC',
  maintenanceMode_DESC = 'maintenanceMode_DESC',
  robotsAllowIndexing_ASC = 'robotsAllowIndexing_ASC',
  robotsAllowIndexing_DESC = 'robotsAllowIndexing_DESC',
  slug_ASC = 'slug_ASC',
  slug_DESC = 'slug_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type BrandModelPortalContentField = AboutRecord | ActionTeaserSectionRecord | ContactSectionRecord | CtaSectionRecord | CustomerReviewsSectionRecord | FaqSectionRecord | HeroRecord | ImageTextSectionRecord | LogoWallSectionRecord | MissionRecord | MissionSliderRecord | NewsletterSignupRecord | OffersBlockRecord | PersonaRecord | ProductComparisonRecord | ServiceBenefitRecord | TextSectionRecord | VideoCollectionRecord;

export type BrandModelPortalContentFieldListListNonNullMultiLocaleField = {
  __typename: 'BrandModelPortalContentFieldListListNonNullMultiLocaleField';
  locale: Maybe<SiteLocale>;
  value: Array<BrandModelPortalContentField>;
};

/** Record of type Site Brand (brand) */
export type BrandRecord = RecordInterface & {
  __typename: 'BrandRecord';
  _allBrokerPortalContentLocales: Maybe<Array<BrandModelBrokerPortalContentFieldListListNonNullMultiLocaleField>>;
  _allBrokerPortalOnboardingLocales: Maybe<Array<OnboardingRecordMultiLocaleField>>;
  _allDemoModalSectionLocales: Maybe<Array<DemoSectionRecordListListNonNullMultiLocaleField>>;
  _allFooterLeftColumnLocales: Maybe<Array<BrandModelFooterLeftColumnFieldListListNonNullMultiLocaleField>>;
  _allFooterRightColumnLocales: Maybe<Array<BrandModelFooterRightColumnFieldListListNonNullMultiLocaleField>>;
  _allFooterTextLocales: Maybe<Array<StringMultiLocaleField>>;
  _allFooterTitleLocales: Maybe<Array<StringNonNullMultiLocaleField>>;
  _allHeaderLogoLocales: Maybe<Array<FileFieldMultiLocaleField>>;
  _allPortalContentLocales: Maybe<Array<BrandModelPortalContentFieldListListNonNullMultiLocaleField>>;
  _allPortalOnboardingLocales: Maybe<Array<OnboardingRecordMultiLocaleField>>;
  _allReferencingBlogposts: Array<BlogpostRecord>;
  /** Returns meta information regarding a record collection */
  _allReferencingBlogpostsMeta: CollectionMetadata;
  _allReferencingInsuranceProductFamilies: Array<InsuranceProductFamilyRecord>;
  /** Returns meta information regarding a record collection */
  _allReferencingInsuranceProductFamiliesMeta: CollectionMetadata;
  _allReferencingInsuranceProducts: Array<InsuranceProductRecord>;
  /** Returns meta information regarding a record collection */
  _allReferencingInsuranceProductsMeta: CollectionMetadata;
  _allReferencingPages: Array<PageRecord>;
  /** Returns meta information regarding a record collection */
  _allReferencingPagesMeta: CollectionMetadata;
  _allReferencingTargetGroups: Array<TargetGroupRecord>;
  /** Returns meta information regarding a record collection */
  _allReferencingTargetGroupsMeta: CollectionMetadata;
  _allSitemapXmlAdditionalAssetsLocales: Maybe<Array<FileFieldListListNonNullMultiLocaleField>>;
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _locales: Array<SiteLocale>;
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  brokerPortalContent: Array<BrandModelBrokerPortalContentField>;
  brokerPortalDetailContent: Array<BrandModelBrokerPortalDetailContentField>;
  brokerPortalHeader: HeaderRecord;
  brokerPortalOnboarding: Maybe<OnboardingRecord>;
  createdAt: Scalars['DateTime']['output'];
  demoModalSection: Array<DemoSectionRecord>;
  favicon: FileField;
  featureFlags: Scalars['JsonField']['output'];
  footerLeftColumn: Array<BrandModelFooterLeftColumnField>;
  footerRightColumn: Array<BrandModelFooterRightColumnField>;
  footerText: Maybe<Scalars['String']['output']>;
  footerTitle: Scalars['String']['output'];
  headerLogo: Maybe<FileField>;
  id: Scalars['ItemId']['output'];
  maintenanceMode: Maybe<Scalars['BooleanType']['output']>;
  portalContent: Array<BrandModelPortalContentField>;
  portalHeader: HeaderRecord;
  portalOnboarding: Maybe<OnboardingRecord>;
  redirects: Maybe<Scalars['JsonField']['output']>;
  robotsAllowIndexing: Maybe<Scalars['BooleanType']['output']>;
  sitemapXmlAdditionalAssets: Array<FileField>;
  slug: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


/** Record of type Site Brand (brand) */
export type BrandRecord_AllBrokerPortalContentLocalesArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Site Brand (brand) */
export type BrandRecord_AllBrokerPortalOnboardingLocalesArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Site Brand (brand) */
export type BrandRecord_AllDemoModalSectionLocalesArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Site Brand (brand) */
export type BrandRecord_AllFooterLeftColumnLocalesArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Site Brand (brand) */
export type BrandRecord_AllFooterRightColumnLocalesArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Site Brand (brand) */
export type BrandRecord_AllFooterTextLocalesArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Site Brand (brand) */
export type BrandRecord_AllFooterTitleLocalesArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Site Brand (brand) */
export type BrandRecord_AllHeaderLogoLocalesArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Site Brand (brand) */
export type BrandRecord_AllPortalContentLocalesArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Site Brand (brand) */
export type BrandRecord_AllPortalOnboardingLocalesArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Site Brand (brand) */
export type BrandRecord_AllReferencingBlogpostsArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  filter: InputMaybe<BlogpostModelFilter>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  locale: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<BlogpostModelOrderBy>>>;
  skip: InputMaybe<Scalars['IntType']['input']>;
  through: InputMaybe<InverseRelationshipFilterBetweenBlogpostAndBrand>;
};


/** Record of type Site Brand (brand) */
export type BrandRecord_AllReferencingBlogpostsMetaArgs = {
  filter: InputMaybe<BlogpostModelFilter>;
  locale: InputMaybe<SiteLocale>;
  through: InputMaybe<InverseRelationshipFilterBetweenBlogpostAndBrand>;
};


/** Record of type Site Brand (brand) */
export type BrandRecord_AllReferencingInsuranceProductFamiliesArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  filter: InputMaybe<InsuranceProductFamilyModelFilter>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  locale: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<InsuranceProductFamilyModelOrderBy>>>;
  skip: InputMaybe<Scalars['IntType']['input']>;
  through: InputMaybe<InverseRelationshipFilterBetweenInsuranceProductFamilyAndBrand>;
};


/** Record of type Site Brand (brand) */
export type BrandRecord_AllReferencingInsuranceProductFamiliesMetaArgs = {
  filter: InputMaybe<InsuranceProductFamilyModelFilter>;
  locale: InputMaybe<SiteLocale>;
  through: InputMaybe<InverseRelationshipFilterBetweenInsuranceProductFamilyAndBrand>;
};


/** Record of type Site Brand (brand) */
export type BrandRecord_AllReferencingInsuranceProductsArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  filter: InputMaybe<InsuranceProductModelFilter>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  locale: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<InsuranceProductModelOrderBy>>>;
  skip: InputMaybe<Scalars['IntType']['input']>;
  through: InputMaybe<InverseRelationshipFilterBetweenInsuranceProductAndBrand>;
};


/** Record of type Site Brand (brand) */
export type BrandRecord_AllReferencingInsuranceProductsMetaArgs = {
  filter: InputMaybe<InsuranceProductModelFilter>;
  locale: InputMaybe<SiteLocale>;
  through: InputMaybe<InverseRelationshipFilterBetweenInsuranceProductAndBrand>;
};


/** Record of type Site Brand (brand) */
export type BrandRecord_AllReferencingPagesArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  filter: InputMaybe<PageModelFilter>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  locale: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<PageModelOrderBy>>>;
  skip: InputMaybe<Scalars['IntType']['input']>;
  through: InputMaybe<InverseRelationshipFilterBetweenPageAndBrand>;
};


/** Record of type Site Brand (brand) */
export type BrandRecord_AllReferencingPagesMetaArgs = {
  filter: InputMaybe<PageModelFilter>;
  locale: InputMaybe<SiteLocale>;
  through: InputMaybe<InverseRelationshipFilterBetweenPageAndBrand>;
};


/** Record of type Site Brand (brand) */
export type BrandRecord_AllReferencingTargetGroupsArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  filter: InputMaybe<TargetGroupModelFilter>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  locale: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<TargetGroupModelOrderBy>>>;
  skip: InputMaybe<Scalars['IntType']['input']>;
  through: InputMaybe<InverseRelationshipFilterBetweenTargetGroupAndBrand>;
};


/** Record of type Site Brand (brand) */
export type BrandRecord_AllReferencingTargetGroupsMetaArgs = {
  filter: InputMaybe<TargetGroupModelFilter>;
  locale: InputMaybe<SiteLocale>;
  through: InputMaybe<InverseRelationshipFilterBetweenTargetGroupAndBrand>;
};


/** Record of type Site Brand (brand) */
export type BrandRecord_AllSitemapXmlAdditionalAssetsLocalesArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Site Brand (brand) */
export type BrandRecord_SeoMetaTagsArgs = {
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Site Brand (brand) */
export type BrandRecordBrokerPortalContentArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Site Brand (brand) */
export type BrandRecordBrokerPortalOnboardingArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Site Brand (brand) */
export type BrandRecordDemoModalSectionArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Site Brand (brand) */
export type BrandRecordFooterLeftColumnArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Site Brand (brand) */
export type BrandRecordFooterRightColumnArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Site Brand (brand) */
export type BrandRecordFooterTextArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Site Brand (brand) */
export type BrandRecordFooterTitleArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Site Brand (brand) */
export type BrandRecordHeaderLogoArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Site Brand (brand) */
export type BrandRecordPortalContentArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Site Brand (brand) */
export type BrandRecordPortalOnboardingArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Site Brand (brand) */
export type BrandRecordSitemapXmlAdditionalAssetsArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};

export type BreadcrumbModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<BreadcrumbModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BreadcrumbModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _locales?: InputMaybe<LocalesFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  id?: InputMaybe<ItemIdFilter>;
  internalName?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  parent?: InputMaybe<ParentFilter>;
  position?: InputMaybe<PositionFilter>;
  target?: InputMaybe<LinkFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum BreadcrumbModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  internalName_ASC = 'internalName_ASC',
  internalName_DESC = 'internalName_DESC',
  name_ASC = 'name_ASC',
  name_DESC = 'name_DESC',
  position_ASC = 'position_ASC',
  position_DESC = 'position_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type BreadcrumbModelTargetField = InsuranceProductFamilyRecord | InsuranceProductRecord | PageRecord | TargetGroupRecord;

export type BreadcrumbModelTargetFieldNonNullMultiLocaleField = {
  __typename: 'BreadcrumbModelTargetFieldNonNullMultiLocaleField';
  locale: Maybe<SiteLocale>;
  value: BreadcrumbModelTargetField;
};

/** Record of type Breadcrumb (breadcrumb) */
export type BreadcrumbRecord = RecordInterface & {
  __typename: 'BreadcrumbRecord';
  _allInternalNameLocales: Maybe<Array<StringMultiLocaleField>>;
  _allNameLocales: Maybe<Array<StringNonNullMultiLocaleField>>;
  _allReferencingBlogposts: Array<BlogpostRecord>;
  /** Returns meta information regarding a record collection */
  _allReferencingBlogpostsMeta: CollectionMetadata;
  _allReferencingBrands: Array<BrandRecord>;
  /** Returns meta information regarding a record collection */
  _allReferencingBrandsMeta: CollectionMetadata;
  _allReferencingHeaders: Array<HeaderRecord>;
  /** Returns meta information regarding a record collection */
  _allReferencingHeadersMeta: CollectionMetadata;
  _allReferencingInsuranceProductFamilies: Array<InsuranceProductFamilyRecord>;
  /** Returns meta information regarding a record collection */
  _allReferencingInsuranceProductFamiliesMeta: CollectionMetadata;
  _allReferencingInsuranceProductVersions: Array<InsuranceProductVersionRecord>;
  /** Returns meta information regarding a record collection */
  _allReferencingInsuranceProductVersionsMeta: CollectionMetadata;
  _allReferencingInsuranceProducts: Array<InsuranceProductRecord>;
  /** Returns meta information regarding a record collection */
  _allReferencingInsuranceProductsMeta: CollectionMetadata;
  _allReferencingPages: Array<PageRecord>;
  /** Returns meta information regarding a record collection */
  _allReferencingPagesMeta: CollectionMetadata;
  _allReferencingTargetGroups: Array<TargetGroupRecord>;
  /** Returns meta information regarding a record collection */
  _allReferencingTargetGroupsMeta: CollectionMetadata;
  _allTargetLocales: Maybe<Array<BreadcrumbModelTargetFieldNonNullMultiLocaleField>>;
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _locales: Array<SiteLocale>;
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  children: Array<BreadcrumbRecord>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  internalName: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  parent: Maybe<BreadcrumbRecord>;
  position: Maybe<Scalars['IntType']['output']>;
  target: BreadcrumbModelTargetField;
  updatedAt: Scalars['DateTime']['output'];
};


/** Record of type Breadcrumb (breadcrumb) */
export type BreadcrumbRecord_AllInternalNameLocalesArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Breadcrumb (breadcrumb) */
export type BreadcrumbRecord_AllNameLocalesArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Breadcrumb (breadcrumb) */
export type BreadcrumbRecord_AllReferencingBlogpostsArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  filter: InputMaybe<BlogpostModelFilter>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  locale: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<BlogpostModelOrderBy>>>;
  skip: InputMaybe<Scalars['IntType']['input']>;
  through: InputMaybe<InverseRelationshipFilterBetweenBlogpostAndBreadcrumb>;
};


/** Record of type Breadcrumb (breadcrumb) */
export type BreadcrumbRecord_AllReferencingBlogpostsMetaArgs = {
  filter: InputMaybe<BlogpostModelFilter>;
  locale: InputMaybe<SiteLocale>;
  through: InputMaybe<InverseRelationshipFilterBetweenBlogpostAndBreadcrumb>;
};


/** Record of type Breadcrumb (breadcrumb) */
export type BreadcrumbRecord_AllReferencingBrandsArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  filter: InputMaybe<BrandModelFilter>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  locale: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<BrandModelOrderBy>>>;
  skip: InputMaybe<Scalars['IntType']['input']>;
  through: InputMaybe<InverseRelationshipFilterBetweenBrandAndBreadcrumb>;
};


/** Record of type Breadcrumb (breadcrumb) */
export type BreadcrumbRecord_AllReferencingBrandsMetaArgs = {
  filter: InputMaybe<BrandModelFilter>;
  locale: InputMaybe<SiteLocale>;
  through: InputMaybe<InverseRelationshipFilterBetweenBrandAndBreadcrumb>;
};


/** Record of type Breadcrumb (breadcrumb) */
export type BreadcrumbRecord_AllReferencingHeadersArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  filter: InputMaybe<HeaderModelFilter>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  locale: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<HeaderModelOrderBy>>>;
  skip: InputMaybe<Scalars['IntType']['input']>;
  through: InputMaybe<InverseRelationshipFilterBetweenHeaderAndBreadcrumb>;
};


/** Record of type Breadcrumb (breadcrumb) */
export type BreadcrumbRecord_AllReferencingHeadersMetaArgs = {
  filter: InputMaybe<HeaderModelFilter>;
  locale: InputMaybe<SiteLocale>;
  through: InputMaybe<InverseRelationshipFilterBetweenHeaderAndBreadcrumb>;
};


/** Record of type Breadcrumb (breadcrumb) */
export type BreadcrumbRecord_AllReferencingInsuranceProductFamiliesArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  filter: InputMaybe<InsuranceProductFamilyModelFilter>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  locale: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<InsuranceProductFamilyModelOrderBy>>>;
  skip: InputMaybe<Scalars['IntType']['input']>;
  through: InputMaybe<InverseRelationshipFilterBetweenInsuranceProductFamilyAndBreadcrumb>;
};


/** Record of type Breadcrumb (breadcrumb) */
export type BreadcrumbRecord_AllReferencingInsuranceProductFamiliesMetaArgs = {
  filter: InputMaybe<InsuranceProductFamilyModelFilter>;
  locale: InputMaybe<SiteLocale>;
  through: InputMaybe<InverseRelationshipFilterBetweenInsuranceProductFamilyAndBreadcrumb>;
};


/** Record of type Breadcrumb (breadcrumb) */
export type BreadcrumbRecord_AllReferencingInsuranceProductVersionsArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  filter: InputMaybe<InsuranceProductVersionModelFilter>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  locale: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<InsuranceProductVersionModelOrderBy>>>;
  skip: InputMaybe<Scalars['IntType']['input']>;
  through: InputMaybe<InverseRelationshipFilterBetweenInsuranceProductVersionAndBreadcrumb>;
};


/** Record of type Breadcrumb (breadcrumb) */
export type BreadcrumbRecord_AllReferencingInsuranceProductVersionsMetaArgs = {
  filter: InputMaybe<InsuranceProductVersionModelFilter>;
  locale: InputMaybe<SiteLocale>;
  through: InputMaybe<InverseRelationshipFilterBetweenInsuranceProductVersionAndBreadcrumb>;
};


/** Record of type Breadcrumb (breadcrumb) */
export type BreadcrumbRecord_AllReferencingInsuranceProductsArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  filter: InputMaybe<InsuranceProductModelFilter>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  locale: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<InsuranceProductModelOrderBy>>>;
  skip: InputMaybe<Scalars['IntType']['input']>;
  through: InputMaybe<InverseRelationshipFilterBetweenInsuranceProductAndBreadcrumb>;
};


/** Record of type Breadcrumb (breadcrumb) */
export type BreadcrumbRecord_AllReferencingInsuranceProductsMetaArgs = {
  filter: InputMaybe<InsuranceProductModelFilter>;
  locale: InputMaybe<SiteLocale>;
  through: InputMaybe<InverseRelationshipFilterBetweenInsuranceProductAndBreadcrumb>;
};


/** Record of type Breadcrumb (breadcrumb) */
export type BreadcrumbRecord_AllReferencingPagesArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  filter: InputMaybe<PageModelFilter>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  locale: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<PageModelOrderBy>>>;
  skip: InputMaybe<Scalars['IntType']['input']>;
  through: InputMaybe<InverseRelationshipFilterBetweenPageAndBreadcrumb>;
};


/** Record of type Breadcrumb (breadcrumb) */
export type BreadcrumbRecord_AllReferencingPagesMetaArgs = {
  filter: InputMaybe<PageModelFilter>;
  locale: InputMaybe<SiteLocale>;
  through: InputMaybe<InverseRelationshipFilterBetweenPageAndBreadcrumb>;
};


/** Record of type Breadcrumb (breadcrumb) */
export type BreadcrumbRecord_AllReferencingTargetGroupsArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  filter: InputMaybe<TargetGroupModelFilter>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  locale: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<TargetGroupModelOrderBy>>>;
  skip: InputMaybe<Scalars['IntType']['input']>;
  through: InputMaybe<InverseRelationshipFilterBetweenTargetGroupAndBreadcrumb>;
};


/** Record of type Breadcrumb (breadcrumb) */
export type BreadcrumbRecord_AllReferencingTargetGroupsMetaArgs = {
  filter: InputMaybe<TargetGroupModelFilter>;
  locale: InputMaybe<SiteLocale>;
  through: InputMaybe<InverseRelationshipFilterBetweenTargetGroupAndBreadcrumb>;
};


/** Record of type Breadcrumb (breadcrumb) */
export type BreadcrumbRecord_AllTargetLocalesArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Breadcrumb (breadcrumb) */
export type BreadcrumbRecord_SeoMetaTagsArgs = {
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Breadcrumb (breadcrumb) */
export type BreadcrumbRecordInternalNameArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Breadcrumb (breadcrumb) */
export type BreadcrumbRecordNameArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Breadcrumb (breadcrumb) */
export type BreadcrumbRecordTargetArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};

export type BreadcrumbRecordListListNonNullMultiLocaleField = {
  __typename: 'BreadcrumbRecordListListNonNullMultiLocaleField';
  locale: Maybe<SiteLocale>;
  value: Array<BreadcrumbRecord>;
};

export type BreadcrumbRecordNonNullMultiLocaleField = {
  __typename: 'BreadcrumbRecordNonNullMultiLocaleField';
  locale: Maybe<SiteLocale>;
  value: BreadcrumbRecord;
};

/** Block of type [Claim] Modal (claim_modal) */
export type ClaimModalRecord = RecordInterface & {
  __typename: 'ClaimModalRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  text: Array<ClaimTextRecord>;
  title: Maybe<Scalars['String']['output']>;
  types: Array<ClaimTypeRecord>;
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type [Claim] Modal (claim_modal) */
export type ClaimModalRecord_SeoMetaTagsArgs = {
  locale: InputMaybe<SiteLocale>;
};

export type ClaimModalRecordMultiLocaleField = {
  __typename: 'ClaimModalRecordMultiLocaleField';
  locale: Maybe<SiteLocale>;
  value: Maybe<ClaimModalRecord>;
};

export type ClaimTextModelTextBlocksField = EmailRecord | HeadingRecord;

export type ClaimTextModelTextField = {
  __typename: 'ClaimTextModelTextField';
  blocks: Array<ClaimTextModelTextBlocksField>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

/** Block of type [Claim] Text (claim_text) */
export type ClaimTextRecord = RecordInterface & {
  __typename: 'ClaimTextRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  text: ClaimTextModelTextField;
  updatedAt: Scalars['DateTime']['output'];
  variant: Maybe<Scalars['String']['output']>;
};


/** Block of type [Claim] Text (claim_text) */
export type ClaimTextRecord_SeoMetaTagsArgs = {
  locale: InputMaybe<SiteLocale>;
};

/** Block of type [Claim] Type (claim_type) */
export type ClaimTypeRecord = RecordInterface & {
  __typename: 'ClaimTypeRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  icon: IconReferenceRecord;
  id: Scalars['ItemId']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type [Claim] Type (claim_type) */
export type ClaimTypeRecord_SeoMetaTagsArgs = {
  locale: InputMaybe<SiteLocale>;
};

export type CollectionMetadata = {
  __typename: 'CollectionMetadata';
  count: Scalars['IntType']['output'];
};

export enum ColorBucketType {
  black = 'black',
  blue = 'blue',
  brown = 'brown',
  cyan = 'cyan',
  green = 'green',
  grey = 'grey',
  orange = 'orange',
  pink = 'pink',
  purple = 'purple',
  red = 'red',
  white = 'white',
  yellow = 'yellow'
}

export type ColorField = {
  __typename: 'ColorField';
  alpha: Scalars['IntType']['output'];
  blue: Scalars['IntType']['output'];
  cssRgb: Scalars['String']['output'];
  green: Scalars['IntType']['output'];
  hex: Scalars['String']['output'];
  red: Scalars['IntType']['output'];
};

/** Specifies how to filter Color fields */
export type ColorFilter = {
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
};

export type ContactModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<ContactModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<ContactModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _locales?: InputMaybe<LocalesFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  availability?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  email?: InputMaybe<StringFilter>;
  id?: InputMaybe<ItemIdFilter>;
  modalText?: InputMaybe<TextFilter>;
  name?: InputMaybe<StringFilter>;
  phoneNumber?: InputMaybe<StringFilter>;
  photo?: InputMaybe<FileFilter>;
  text?: InputMaybe<TextFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum ContactModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  availability_ASC = 'availability_ASC',
  availability_DESC = 'availability_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  email_ASC = 'email_ASC',
  email_DESC = 'email_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  name_ASC = 'name_ASC',
  name_DESC = 'name_DESC',
  phoneNumber_ASC = 'phoneNumber_ASC',
  phoneNumber_DESC = 'phoneNumber_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

/** Record of type Contact (contact) */
export type ContactRecord = RecordInterface & {
  __typename: 'ContactRecord';
  _allAvailabilityLocales: Maybe<Array<StringNonNullMultiLocaleField>>;
  _allEmailLocales: Maybe<Array<StringNonNullMultiLocaleField>>;
  _allModalTextLocales: Maybe<Array<StringMultiLocaleField>>;
  _allNameLocales: Maybe<Array<StringNonNullMultiLocaleField>>;
  _allPhoneNumberLocales: Maybe<Array<StringNonNullMultiLocaleField>>;
  _allTextLocales: Maybe<Array<StringMultiLocaleField>>;
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _locales: Array<SiteLocale>;
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  availability: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  id: Scalars['ItemId']['output'];
  modalText: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  photo: FileField;
  text: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};


/** Record of type Contact (contact) */
export type ContactRecord_AllAvailabilityLocalesArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Contact (contact) */
export type ContactRecord_AllEmailLocalesArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Contact (contact) */
export type ContactRecord_AllModalTextLocalesArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
  markdown: InputMaybe<Scalars['Boolean']['input']>;
};


/** Record of type Contact (contact) */
export type ContactRecord_AllNameLocalesArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Contact (contact) */
export type ContactRecord_AllPhoneNumberLocalesArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Contact (contact) */
export type ContactRecord_AllTextLocalesArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
  markdown: InputMaybe<Scalars['Boolean']['input']>;
};


/** Record of type Contact (contact) */
export type ContactRecord_SeoMetaTagsArgs = {
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Contact (contact) */
export type ContactRecordAvailabilityArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Contact (contact) */
export type ContactRecordEmailArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Contact (contact) */
export type ContactRecordModalTextArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
  markdown: InputMaybe<Scalars['Boolean']['input']>;
};


/** Record of type Contact (contact) */
export type ContactRecordNameArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Contact (contact) */
export type ContactRecordPhoneNumberArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Contact (contact) */
export type ContactRecordTextArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
  markdown: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContactRecordMultiLocaleField = {
  __typename: 'ContactRecordMultiLocaleField';
  locale: Maybe<SiteLocale>;
  value: Maybe<ContactRecord>;
};

export type ContactRecordNonNullMultiLocaleField = {
  __typename: 'ContactRecordNonNullMultiLocaleField';
  locale: Maybe<SiteLocale>;
  value: ContactRecord;
};

/** Block of type Contact Section (contact_section) */
export type ContactSectionRecord = RecordInterface & {
  __typename: 'ContactSectionRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  contact: ContactRecord;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  subtitle: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Contact Section (contact_section) */
export type ContactSectionRecord_SeoMetaTagsArgs = {
  locale: InputMaybe<SiteLocale>;
};

/** Specifies how to filter by creation datetime */
export type CreatedAtFilter = {
  /** Filter records with a value that's within the specified minute range. Seconds and milliseconds are truncated from the argument. */
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records with a value that's strictly greater than the one specified. Seconds and milliseconds are truncated from the argument. */
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with a value that's greater than or equal to than the one specified. Seconds and milliseconds are truncated from the argument. */
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with a value that's less than the one specified. Seconds and milliseconds are truncated from the argument. */
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with a value that's less or equal than the one specified. Seconds and milliseconds are truncated from the argument. */
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with a value that's outside the specified minute range. Seconds and milliseconds are truncated from the argument. */
  neq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CtaSectionModelLinkButtonsField = InlineLinkButtonRecord | InlineModalButtonRecord;

/** Block of type CTA Section (cta_section) */
export type CtaSectionRecord = RecordInterface & {
  __typename: 'CtaSectionRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  linkButtons: Array<CtaSectionModelLinkButtonsField>;
  text: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type CTA Section (cta_section) */
export type CtaSectionRecord_SeoMetaTagsArgs = {
  locale: InputMaybe<SiteLocale>;
};


/** Block of type CTA Section (cta_section) */
export type CtaSectionRecordTextArgs = {
  markdown: InputMaybe<Scalars['Boolean']['input']>;
};

export type CustomerReviewModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<CustomerReviewModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CustomerReviewModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _locales?: InputMaybe<LocalesFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  id?: InputMaybe<ItemIdFilter>;
  name?: InputMaybe<StringFilter>;
  photo?: InputMaybe<FileFilter>;
  quote?: InputMaybe<StringFilter>;
  role?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum CustomerReviewModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  name_ASC = 'name_ASC',
  name_DESC = 'name_DESC',
  quote_ASC = 'quote_ASC',
  quote_DESC = 'quote_DESC',
  role_ASC = 'role_ASC',
  role_DESC = 'role_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

/** Record of type Customer Review (customer_review) */
export type CustomerReviewRecord = RecordInterface & {
  __typename: 'CustomerReviewRecord';
  _allQuoteLocales: Maybe<Array<StringNonNullMultiLocaleField>>;
  _allRoleLocales: Maybe<Array<StringMultiLocaleField>>;
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _locales: Array<SiteLocale>;
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  name: Scalars['String']['output'];
  photo: FileField;
  quote: Scalars['String']['output'];
  role: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};


/** Record of type Customer Review (customer_review) */
export type CustomerReviewRecord_AllQuoteLocalesArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Customer Review (customer_review) */
export type CustomerReviewRecord_AllRoleLocalesArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Customer Review (customer_review) */
export type CustomerReviewRecord_SeoMetaTagsArgs = {
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Customer Review (customer_review) */
export type CustomerReviewRecordQuoteArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Customer Review (customer_review) */
export type CustomerReviewRecordRoleArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};

/** Block of type Customer Reviews Section (customer_reviews_section) */
export type CustomerReviewsSectionRecord = RecordInterface & {
  __typename: 'CustomerReviewsSectionRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  reviews: Array<CustomerReviewRecord>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Customer Reviews Section (customer_reviews_section) */
export type CustomerReviewsSectionRecord_SeoMetaTagsArgs = {
  locale: InputMaybe<SiteLocale>;
};

/** Specifies how to filter Date fields */
export type DateFilter = {
  /** Search for records with an exact match */
  eq?: InputMaybe<Scalars['Date']['input']>;
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records with a value that's strictly greater than the one specified */
  gt?: InputMaybe<Scalars['Date']['input']>;
  /** Filter records with a value that's greater than or equal to the one specified */
  gte?: InputMaybe<Scalars['Date']['input']>;
  /** Filter records with a value that's less than the one specified */
  lt?: InputMaybe<Scalars['Date']['input']>;
  /** Filter records with a value that's less or equal than the one specified */
  lte?: InputMaybe<Scalars['Date']['input']>;
  /** Exclude records with an exact match */
  neq?: InputMaybe<Scalars['Date']['input']>;
};

/** Block of type Demo Section (demo_section) */
export type DemoSectionRecord = RecordInterface & {
  __typename: 'DemoSectionRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  contact: ContactRecord;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  subtitle: Scalars['String']['output'];
  text: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Demo Section (demo_section) */
export type DemoSectionRecord_SeoMetaTagsArgs = {
  locale: InputMaybe<SiteLocale>;
};

export type DemoSectionRecordListListNonNullMultiLocaleField = {
  __typename: 'DemoSectionRecordListListNonNullMultiLocaleField';
  locale: Maybe<SiteLocale>;
  value: Array<DemoSectionRecord>;
};

/** Block of type [Structured Text] Email (email) */
export type EmailRecord = RecordInterface & {
  __typename: 'EmailRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  id: Scalars['ItemId']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type [Structured Text] Email (email) */
export type EmailRecord_SeoMetaTagsArgs = {
  locale: InputMaybe<SiteLocale>;
};

/** Block of type [Header] Family Header Item (family_header_item) */
export type FamilyHeaderItemRecord = RecordInterface & {
  __typename: 'FamilyHeaderItemRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  family: InsuranceProductFamilyRecord;
  id: Scalars['ItemId']['output'];
  products: Array<ProductHeaderItemRecord>;
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type [Header] Family Header Item (family_header_item) */
export type FamilyHeaderItemRecord_SeoMetaTagsArgs = {
  locale: InputMaybe<SiteLocale>;
};

export type FaqModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<FaqModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<FaqModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _locales?: InputMaybe<LocalesFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  id?: InputMaybe<ItemIdFilter>;
  insuranceProductFamilies?: InputMaybe<LinksFilter>;
  subtitle?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum FaqModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  subtitle_ASC = 'subtitle_ASC',
  subtitle_DESC = 'subtitle_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

/** Record of type FAQ (faq) */
export type FaqRecord = RecordInterface & {
  __typename: 'FaqRecord';
  _allQuestionsLocales: Maybe<Array<QuestionAnswerRecordListListNonNullMultiLocaleField>>;
  _allSubtitleLocales: Maybe<Array<StringMultiLocaleField>>;
  _allTitleLocales: Maybe<Array<StringMultiLocaleField>>;
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _locales: Array<SiteLocale>;
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  insuranceProductFamilies: Array<InsuranceProductFamilyRecord>;
  questions: Array<QuestionAnswerRecord>;
  subtitle: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};


/** Record of type FAQ (faq) */
export type FaqRecord_AllQuestionsLocalesArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type FAQ (faq) */
export type FaqRecord_AllSubtitleLocalesArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type FAQ (faq) */
export type FaqRecord_AllTitleLocalesArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type FAQ (faq) */
export type FaqRecord_SeoMetaTagsArgs = {
  locale: InputMaybe<SiteLocale>;
};


/** Record of type FAQ (faq) */
export type FaqRecordQuestionsArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type FAQ (faq) */
export type FaqRecordSubtitleArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type FAQ (faq) */
export type FaqRecordTitleArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};

/** Block of type FAQ Section (faq_section) */
export type FaqSectionRecord = RecordInterface & {
  __typename: 'FaqSectionRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  faqs: Array<FaqRecord>;
  hasSearch: Maybe<Scalars['BooleanType']['output']>;
  id: Scalars['ItemId']['output'];
  subtitle: Maybe<Scalars['String']['output']>;
  text: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type FAQ Section (faq_section) */
export type FaqSectionRecord_SeoMetaTagsArgs = {
  locale: InputMaybe<SiteLocale>;
};


/** Block of type FAQ Section (faq_section) */
export type FaqSectionRecordTextArgs = {
  markdown: InputMaybe<Scalars['Boolean']['input']>;
};

export enum FaviconType {
  appleTouchIcon = 'appleTouchIcon',
  icon = 'icon',
  msApplication = 'msApplication'
}

export type FileField = FileFieldInterface & {
  __typename: 'FileField';
  _createdAt: Scalars['DateTime']['output'];
  /** The DatoCMS URL where you can edit this entity. To use this field, you need to set a X-Base-Editing-Url header in the request */
  _editingUrl: Maybe<Scalars['String']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  alt: Maybe<Scalars['String']['output']>;
  author: Maybe<Scalars['String']['output']>;
  basename: Scalars['String']['output'];
  blurUpThumb: Maybe<Scalars['String']['output']>;
  blurhash: Maybe<Scalars['String']['output']>;
  colors: Array<ColorField>;
  copyright: Maybe<Scalars['String']['output']>;
  customData: Scalars['CustomData']['output'];
  exifInfo: Scalars['CustomData']['output'];
  filename: Scalars['String']['output'];
  focalPoint: Maybe<FocalPoint>;
  format: Scalars['String']['output'];
  height: Maybe<Scalars['IntType']['output']>;
  id: Scalars['UploadId']['output'];
  md5: Scalars['String']['output'];
  mimeType: Scalars['String']['output'];
  notes: Maybe<Scalars['String']['output']>;
  responsiveImage: Maybe<ResponsiveImage>;
  size: Scalars['IntType']['output'];
  smartTags: Array<Scalars['String']['output']>;
  tags: Array<Scalars['String']['output']>;
  thumbhash: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
  video: Maybe<UploadVideoField>;
  width: Maybe<Scalars['IntType']['output']>;
};


export type FileFieldAltArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


export type FileFieldBlurUpThumbArgs = {
  imgixParams: InputMaybe<ImgixParams>;
  punch?: Scalars['Float']['input'];
  quality?: Scalars['Int']['input'];
  size?: Scalars['Int']['input'];
};


export type FileFieldCustomDataArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


export type FileFieldFocalPointArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


export type FileFieldResponsiveImageArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  imgixParams: InputMaybe<ImgixParams>;
  locale: InputMaybe<SiteLocale>;
  sizes: InputMaybe<Scalars['String']['input']>;
};


export type FileFieldTitleArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


export type FileFieldUrlArgs = {
  imgixParams: InputMaybe<ImgixParams>;
};

export type FileFieldInterface = {
  _createdAt: Scalars['DateTime']['output'];
  /** The DatoCMS URL where you can edit this entity. To use this field, you need to set a X-Base-Editing-Url header in the request */
  _editingUrl: Maybe<Scalars['String']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  alt: Maybe<Scalars['String']['output']>;
  author: Maybe<Scalars['String']['output']>;
  basename: Scalars['String']['output'];
  blurUpThumb: Maybe<Scalars['String']['output']>;
  blurhash: Maybe<Scalars['String']['output']>;
  colors: Array<ColorField>;
  copyright: Maybe<Scalars['String']['output']>;
  customData: Scalars['CustomData']['output'];
  exifInfo: Scalars['CustomData']['output'];
  filename: Scalars['String']['output'];
  focalPoint: Maybe<FocalPoint>;
  format: Scalars['String']['output'];
  height: Maybe<Scalars['IntType']['output']>;
  id: Scalars['UploadId']['output'];
  md5: Scalars['String']['output'];
  mimeType: Scalars['String']['output'];
  notes: Maybe<Scalars['String']['output']>;
  responsiveImage: Maybe<ResponsiveImage>;
  size: Scalars['IntType']['output'];
  smartTags: Array<Scalars['String']['output']>;
  tags: Array<Scalars['String']['output']>;
  thumbhash: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
  video: Maybe<UploadVideoField>;
  width: Maybe<Scalars['IntType']['output']>;
};


export type FileFieldInterfaceAltArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


export type FileFieldInterfaceBlurUpThumbArgs = {
  imgixParams: InputMaybe<ImgixParams>;
  punch?: Scalars['Float']['input'];
  quality?: Scalars['Int']['input'];
  size?: Scalars['Int']['input'];
};


export type FileFieldInterfaceCustomDataArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


export type FileFieldInterfaceFocalPointArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


export type FileFieldInterfaceResponsiveImageArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  imgixParams: InputMaybe<ImgixParams>;
  locale: InputMaybe<SiteLocale>;
  sizes: InputMaybe<Scalars['String']['input']>;
};


export type FileFieldInterfaceTitleArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


export type FileFieldInterfaceUrlArgs = {
  imgixParams: InputMaybe<ImgixParams>;
};

export type FileFieldListListNonNullMultiLocaleField = {
  __typename: 'FileFieldListListNonNullMultiLocaleField';
  locale: Maybe<SiteLocale>;
  value: Array<FileField>;
};

export type FileFieldMultiLocaleField = {
  __typename: 'FileFieldMultiLocaleField';
  locale: Maybe<SiteLocale>;
  value: Maybe<FileField>;
};

/** Specifies how to filter Single-file/image fields */
export type FileFilter = {
  /** Search for records with an exact match. The specified value must be an Upload ID */
  eq?: InputMaybe<Scalars['UploadId']['input']>;
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records that have one of the specified uploads */
  in?: InputMaybe<Array<InputMaybe<Scalars['UploadId']['input']>>>;
  /** Exclude records with an exact match. The specified value must be an Upload ID */
  neq?: InputMaybe<Scalars['UploadId']['input']>;
  /** Filter records that do not have one of the specified uploads */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['UploadId']['input']>>>;
};

/** Block of type Flipper (flipper) */
export type FlipperRecord = RecordInterface & {
  __typename: 'FlipperRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  icon: FileField;
  id: Scalars['ItemId']['output'];
  text: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Flipper (flipper) */
export type FlipperRecord_SeoMetaTagsArgs = {
  locale: InputMaybe<SiteLocale>;
};


/** Block of type Flipper (flipper) */
export type FlipperRecordTextArgs = {
  markdown: InputMaybe<Scalars['Boolean']['input']>;
};

export type FlipperSectionModelIntroBlocksField = InlineAssetRecord | InlineLinkButtonRecord;

export type FlipperSectionModelIntroField = {
  __typename: 'FlipperSectionModelIntroField';
  blocks: Array<FlipperSectionModelIntroBlocksField>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

/** Block of type Flipper Section (flipper_section) */
export type FlipperSectionRecord = RecordInterface & {
  __typename: 'FlipperSectionRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  flippers: Array<FlipperRecord>;
  id: Scalars['ItemId']['output'];
  intro: Maybe<FlipperSectionModelIntroField>;
  pageLimitMobile: Scalars['IntType']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Flipper Section (flipper_section) */
export type FlipperSectionRecord_SeoMetaTagsArgs = {
  locale: InputMaybe<SiteLocale>;
};

/** Specifies how to filter Floating-point fields */
export type FloatFilter = {
  /** Search for records with an exact match */
  eq?: InputMaybe<Scalars['FloatType']['input']>;
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records with a value that's strictly greater than the one specified */
  gt?: InputMaybe<Scalars['FloatType']['input']>;
  /** Filter records with a value that's greater than or equal to the one specified */
  gte?: InputMaybe<Scalars['FloatType']['input']>;
  /** Filter records with a value that's less than the one specified */
  lt?: InputMaybe<Scalars['FloatType']['input']>;
  /** Filter records with a value that's less or equal than the one specified */
  lte?: InputMaybe<Scalars['FloatType']['input']>;
  /** Exclude records with an exact match */
  neq?: InputMaybe<Scalars['FloatType']['input']>;
};

/** Block of type Functionality Collection Column (functionality_collection_column) */
export type FunctionalityCollectionColumnRecord = RecordInterface & {
  __typename: 'FunctionalityCollectionColumnRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  items: Array<FunctionalityCollectionItemRecord>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Functionality Collection Column (functionality_collection_column) */
export type FunctionalityCollectionColumnRecord_SeoMetaTagsArgs = {
  locale: InputMaybe<SiteLocale>;
};

/** Block of type Functionality Collection Item (functionality_collection_item) */
export type FunctionalityCollectionItemRecord = RecordInterface & {
  __typename: 'FunctionalityCollectionItemRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  text: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Functionality Collection Item (functionality_collection_item) */
export type FunctionalityCollectionItemRecord_SeoMetaTagsArgs = {
  locale: InputMaybe<SiteLocale>;
};


/** Block of type Functionality Collection Item (functionality_collection_item) */
export type FunctionalityCollectionItemRecordTextArgs = {
  markdown: InputMaybe<Scalars['Boolean']['input']>;
};

export type FunctionalityCollectionModelIntroBlocksField = InlineAssetRecord | InlineLinkButtonRecord;

export type FunctionalityCollectionModelIntroField = {
  __typename: 'FunctionalityCollectionModelIntroField';
  blocks: Array<FunctionalityCollectionModelIntroBlocksField>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

/** Block of type Functionality Collection (functionality_collection) */
export type FunctionalityCollectionRecord = RecordInterface & {
  __typename: 'FunctionalityCollectionRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  columns: Array<FunctionalityCollectionColumnRecord>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  intro: Maybe<FunctionalityCollectionModelIntroField>;
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Functionality Collection (functionality_collection) */
export type FunctionalityCollectionRecord_SeoMetaTagsArgs = {
  locale: InputMaybe<SiteLocale>;
};

/** Specifies how to filter Multiple files/images field */
export type GalleryFilter = {
  /** Filter records that have all of the specified uploads. The specified values must be Upload IDs */
  allIn?: InputMaybe<Array<InputMaybe<Scalars['UploadId']['input']>>>;
  /** Filter records that have one of the specified uploads. The specified values must be Upload IDs */
  anyIn?: InputMaybe<Array<InputMaybe<Scalars['UploadId']['input']>>>;
  /** Search for records with an exact match. The specified values must be Upload IDs */
  eq?: InputMaybe<Array<InputMaybe<Scalars['UploadId']['input']>>>;
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records that do not have any of the specified uploads. The specified values must be Upload IDs */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['UploadId']['input']>>>;
};

export type GlobalSeoField = {
  __typename: 'GlobalSeoField';
  facebookPageUrl: Maybe<Scalars['String']['output']>;
  fallbackSeo: Maybe<SeoField>;
  siteName: Maybe<Scalars['String']['output']>;
  titleSuffix: Maybe<Scalars['String']['output']>;
  twitterAccount: Maybe<Scalars['String']['output']>;
};

/** Record of type Global Settings (global_settings_page) */
export type GlobalSettingsPageRecord = RecordInterface & {
  __typename: 'GlobalSettingsPageRecord';
  _allMandatoryInformationPageLocales: Maybe<Array<PageRecordNonNullMultiLocaleField>>;
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _locales: Array<SiteLocale>;
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  mandatoryInformationPage: PageRecord;
  updatedAt: Scalars['DateTime']['output'];
};


/** Record of type Global Settings (global_settings_page) */
export type GlobalSettingsPageRecord_AllMandatoryInformationPageLocalesArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Global Settings (global_settings_page) */
export type GlobalSettingsPageRecord_SeoMetaTagsArgs = {
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Global Settings (global_settings_page) */
export type GlobalSettingsPageRecordMandatoryInformationPageArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};

export type HeaderDropdownModelDropdownItemsField = FamilyHeaderItemRecord | HeaderItemRecord;

/** Block of type Header Dropdown (header_dropdown) */
export type HeaderDropdownRecord = RecordInterface & {
  __typename: 'HeaderDropdownRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  analyticsId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  dropdownItems: Array<HeaderDropdownModelDropdownItemsField>;
  id: Scalars['ItemId']['output'];
  label: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Header Dropdown (header_dropdown) */
export type HeaderDropdownRecord_SeoMetaTagsArgs = {
  locale: InputMaybe<SiteLocale>;
};

/** Block of type Header Item (header_item) */
export type HeaderItemRecord = RecordInterface & {
  __typename: 'HeaderItemRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  page: PageRecord;
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Header Item (header_item) */
export type HeaderItemRecord_SeoMetaTagsArgs = {
  locale: InputMaybe<SiteLocale>;
};

/** Linking fields */
export enum HeaderModelFieldsReferencingBreadcrumbModel {
  header_links = 'header_links',
  header_links__inlineLinkButton_internal = 'header_links__inlineLinkButton_internal'
}

export type HeaderModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<HeaderModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<HeaderModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _locales?: InputMaybe<LocalesFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  headerLogo?: InputMaybe<FileFilter>;
  id?: InputMaybe<ItemIdFilter>;
  internalTitle?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export type HeaderModelLinksField = HeaderDropdownRecord | InlineLinkButtonRecord | InlineModalButtonRecord;

export type HeaderModelLinksFieldListListNonNullMultiLocaleField = {
  __typename: 'HeaderModelLinksFieldListListNonNullMultiLocaleField';
  locale: Maybe<SiteLocale>;
  value: Array<HeaderModelLinksField>;
};

export enum HeaderModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  internalTitle_ASC = 'internalTitle_ASC',
  internalTitle_DESC = 'internalTitle_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

/** Record of type Header (header) */
export type HeaderRecord = RecordInterface & {
  __typename: 'HeaderRecord';
  _allHeaderLogoLocales: Maybe<Array<FileFieldMultiLocaleField>>;
  _allLinksLocales: Maybe<Array<HeaderModelLinksFieldListListNonNullMultiLocaleField>>;
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _locales: Array<SiteLocale>;
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  headerLogo: Maybe<FileField>;
  id: Scalars['ItemId']['output'];
  internalTitle: Scalars['String']['output'];
  links: Array<HeaderModelLinksField>;
  updatedAt: Scalars['DateTime']['output'];
};


/** Record of type Header (header) */
export type HeaderRecord_AllHeaderLogoLocalesArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Header (header) */
export type HeaderRecord_AllLinksLocalesArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Header (header) */
export type HeaderRecord_SeoMetaTagsArgs = {
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Header (header) */
export type HeaderRecordHeaderLogoArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Header (header) */
export type HeaderRecordLinksArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};

/** Block of type [Structured Text] Heading (heading) */
export type HeadingRecord = RecordInterface & {
  __typename: 'HeadingRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  left: Scalars['String']['output'];
  right: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type [Structured Text] Heading (heading) */
export type HeadingRecord_SeoMetaTagsArgs = {
  locale: InputMaybe<SiteLocale>;
};

export type HeroModelCtaField = InlineLinkButtonRecord | InlineModalButtonRecord;

export type HeroModelTextBlocksField = InlineLinkButtonRecord | InlineModalButtonRecord;

export type HeroModelTextField = {
  __typename: 'HeroModelTextField';
  blocks: Array<HeroModelTextBlocksField>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

/** Block of type Hero (hero) */
export type HeroRecord = RecordInterface & {
  __typename: 'HeroRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  background: FileField;
  createdAt: Scalars['DateTime']['output'];
  cta: Array<HeroModelCtaField>;
  id: Scalars['ItemId']['output'];
  priceTagText: Maybe<Scalars['String']['output']>;
  startingPrice: Maybe<Scalars['FloatType']['output']>;
  style: Scalars['String']['output'];
  subline: Maybe<Scalars['String']['output']>;
  text: Maybe<HeroModelTextField>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Hero (hero) */
export type HeroRecord_SeoMetaTagsArgs = {
  locale: InputMaybe<SiteLocale>;
};


/** Block of type Hero (hero) */
export type HeroRecordSublineArgs = {
  markdown: InputMaybe<Scalars['Boolean']['input']>;
};


/** Block of type Hero (hero) */
export type HeroRecordTitleArgs = {
  markdown: InputMaybe<Scalars['Boolean']['input']>;
};

/** Block of type Hero Slider (hero_slider) */
export type HeroSliderRecord = RecordInterface & {
  __typename: 'HeroSliderRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  slides: Array<HeroRecord>;
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Hero Slider (hero_slider) */
export type HeroSliderRecord_SeoMetaTagsArgs = {
  locale: InputMaybe<SiteLocale>;
};

export type IconReferenceModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<IconReferenceModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<IconReferenceModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  id?: InputMaybe<ItemIdFilter>;
  name?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum IconReferenceModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  name_ASC = 'name_ASC',
  name_DESC = 'name_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

/** Record of type Icon Reference (icon_reference) */
export type IconReferenceRecord = RecordInterface & {
  __typename: 'IconReferenceRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


/** Record of type Icon Reference (icon_reference) */
export type IconReferenceRecord_SeoMetaTagsArgs = {
  locale: InputMaybe<SiteLocale>;
};

export type ImageTextSectionModelTextBlocksField = InlineLinkButtonRecord | InlineModalButtonRecord;

export type ImageTextSectionModelTextField = {
  __typename: 'ImageTextSectionModelTextField';
  blocks: Array<ImageTextSectionModelTextBlocksField>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

/** Block of type Image and Text Section (image_text_section) */
export type ImageTextSectionRecord = RecordInterface & {
  __typename: 'ImageTextSectionRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  image: FileField;
  text: ImageTextSectionModelTextField;
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Image and Text Section (image_text_section) */
export type ImageTextSectionRecord_SeoMetaTagsArgs = {
  locale: InputMaybe<SiteLocale>;
};

export type ImgixParams = {
  /**
   * Aspect Ratio
   *
   * Specifies an aspect ratio to maintain when resizing and cropping the image
   *
   * Depends on: `fit=crop`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/size/aspect-ratio)
   */
  ar?: InputMaybe<Scalars['String']['input']>;
  /**
   * Automatic
   *
   * Applies automatic enhancements to images.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/automatic)
   */
  auto?: InputMaybe<Array<ImgixParamsAuto>>;
  /**
   * Background Color
   *
   * Colors the background of padded and partially-transparent images.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/background-color)
   */
  bg?: InputMaybe<Scalars['String']['input']>;
  /**
   * Background Removal
   *
   * Removes background from image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/background/background-removal)
   */
  bgRemove?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Background Removal Fallback
   *
   * Overrides default fallback behavior for bg-remove failures.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/background/background-removal-fallback)
   */
  bgRemoveFallback?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Background Removal Foreground Type
   *
   * Specifies the image foreground type for background removal.
   *
   * Depends on: `bg-remove=true`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/background/background-removal-foreground-type)
   */
  bgRemoveFgType?: InputMaybe<Array<ImgixParamsBgRemoveFgType>>;
  /**
   * Background Removal Semi Transparency
   *
   * Enables background removal while retaining semi-transparent areas.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/background/background-removal-semi-transparency)
   */
  bgRemoveSemiTransparency?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Background Replacement
   *
   * Replaces background from image using a string based prompt.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/background/background-replacement)
   */
  bgReplace?: InputMaybe<Scalars['String']['input']>;
  /**
   * Background Replace Fallback
   *
   * Overrides default fallback behavior for bg-replace failures.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/background/background-replace-fallback)
   */
  bgReplaceFallback?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Background Replacement Negative Prompt
   *
   * Provides a negative text suggestion for background replacement.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/background/background-replacement-negative-prompt)
   */
  bgReplaceNegPrompt?: InputMaybe<Scalars['String']['input']>;
  /**
   * Blend
   *
   * Specifies the location of the blend image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/blending/blend)
   */
  blend?: InputMaybe<Scalars['String']['input']>;
  /**
   * Blend Align
   *
   * Changes the blend alignment relative to the parent image.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/blending/blend-align)
   */
  blendAlign?: InputMaybe<Array<ImgixParamsBlendAlign>>;
  /**
   * Blend Alpha
   *
   * Changes the alpha of the blend image.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/blending/blend-alpha)
   */
  blendAlpha?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Blend Color
   *
   * Specifies a color to use when applying the blend.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/blending/blend-color)
   */
  blendColor?: InputMaybe<Scalars['String']['input']>;
  /**
   * Blend Crop
   *
   * Specifies the type of crop for blend images.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/blending/blend-crop)
   */
  blendCrop?: InputMaybe<Array<ImgixParamsBlendCrop>>;
  /**
   * Blend Fit
   *
   * Specifies the fit mode for blend images.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/blending/blend-fit)
   */
  blendFit?: InputMaybe<ImgixParamsBlendFit>;
  /**
   * Blend Height
   *
   * Adjusts the height of the blend image.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/blending/blend-height)
   */
  blendH?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Blend Mode
   *
   * Sets the blend mode for a blend image.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/blending/blend-mode)
   */
  blendMode?: InputMaybe<ImgixParamsBlendMode>;
  /**
   * Blend Padding
   *
   * Applies padding to the blend image.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/blending/blend-padding)
   */
  blendPad?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Blend Size
   *
   * Adjusts the size of the blend image.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/blending/blend-size)
   */
  blendSize?: InputMaybe<ImgixParamsBlendSize>;
  /**
   * Blend Width
   *
   * Adjusts the width of the blend image.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/blending/blend-width)
   */
  blendW?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Blend X Position
   *
   * Adjusts the x-offset of the blend image relative to its parent.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/blending/blend-x-position)
   */
  blendX?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Blend Y Position
   *
   * Adjusts the y-offset of the blend image relative to its parent.
   *
   * Depends on: `blend`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/blending/blend-y-position)
   */
  blendY?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Gaussian Blur
   *
   * Applies a gaussian blur to an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/stylize/gaussian-blur)
   */
  blur?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Border Size & Color
   *
   * Applies a border to an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/size)
   */
  border?: InputMaybe<Scalars['String']['input']>;
  /**
   * Border Bottom
   *
   * Sets bottom border of an image.
   *
   * Depends on: `border`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/border-and-padding/border-bottom)
   */
  borderBottom?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Border Left
   *
   * Sets left border of an image.
   *
   * Depends on: `border`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/border-and-padding/border-left)
   */
  borderLeft?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Outer Border Radius
   *
   * Sets the outer radius of the image's border in pixels.
   *
   * Depends on: `border`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/border-and-padding/outer-border-radius)
   */
  borderRadius?: InputMaybe<Scalars['String']['input']>;
  /**
   * Inner Border Radius
   *
   * Sets the inner radius of the image's border in pixels.
   *
   * Depends on: `border`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/border-and-padding/inner-border-radius)
   */
  borderRadiusInner?: InputMaybe<Scalars['String']['input']>;
  /**
   * Border Right
   *
   * Sets right border of an image.
   *
   * Depends on: `border`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/border-and-padding/border-right)
   */
  borderRight?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Border Top
   *
   * Sets top border of an image.
   *
   * Depends on: `border`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/border-and-padding/border-top)
   */
  borderTop?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Brightness
   *
   * Adjusts the brightness of the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/adjustment/brightness)
   */
  bri?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Client Hints
   *
   * Sets one or more Client-Hints headers
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/format/client-hints)
   */
  ch?: InputMaybe<Array<ImgixParamsCh>>;
  /**
   * Chroma Subsampling
   *
   * Specifies the output chroma subsampling rate.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/format/chroma-subsampling)
   */
  chromasub?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Color Quantization
   *
   * Limits the number of unique colors in an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/format/color-quantization)
   */
  colorquant?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Palette Color Count
   *
   * Specifies how many colors to include in a palette-extraction response.
   *
   * Depends on: `palette`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/color-palette/palette-color-count)
   */
  colors?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Contrast
   *
   * Adjusts the contrast of the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/adjustment/contrast)
   */
  con?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Mask Corner Radius
   *
   * Specifies the radius value for a rounded corner mask.
   *
   * Depends on: `mask=corners`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/mask-image/mask-corner-radius)
   */
  cornerRadius?: InputMaybe<Scalars['String']['input']>;
  /**
   * Crop Mode
   *
   * Specifies how to crop an image.
   *
   * Depends on: `fit=crop`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/size/crop-mode)
   */
  crop?: InputMaybe<Array<ImgixParamsCrop>>;
  /**
   * Color Space
   *
   * Specifies the color space of the output image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/format/color-space)
   */
  cs?: InputMaybe<ImgixParamsCs>;
  /**
   * Download
   *
   * Forces a URL to use send-file in its response.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/format/download)
   */
  dl?: InputMaybe<Scalars['String']['input']>;
  /**
   * Dots Per Inch
   *
   * Sets the DPI value in the EXIF header.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/format/dots-per-inch)
   */
  dpi?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Device Pixel Ratio
   *
   * Adjusts the device-pixel ratio of the output image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/device-pixel-ratio)
   */
  dpr?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Duotone
   *
   * Applies a duotone effect to the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/stylize/duotone)
   */
  duotone?: InputMaybe<Scalars['String']['input']>;
  /**
   * Duotone Alpha
   *
   * Changes the alpha of the duotone effect atop the source image.
   *
   * Depends on: `duotone`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/stylize/duotone-alpha)
   */
  duotoneAlpha?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Exposure
   *
   * Adjusts the exposure of the output image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/adjustment/exposure)
   */
  exp?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Url Expiration Timestamp
   *
   * A Unix timestamp specifying a UTC time. Requests made to this URL after that time will output a 404 status code.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/expiration)
   */
  expires?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Face Blur
   *
   * Specifies the amount of blur to apply to detected faces. Defaults to 0.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/face-detection/face-blur)
   */
  faceBlur?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Face Pixelation
   *
   * Specifies the pixelation amount of the face.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/face-detection/face-pixelation)
   */
  facePixel?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Face Index
   *
   * Selects a face to crop to.
   *
   * Depends on: `fit=facearea`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/face-detection/face-index)
   */
  faceindex?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Face Padding
   *
   * Adjusts padding around a selected face.
   *
   * Depends on: `fit=facearea`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/face-detection/face-padding)
   */
  facepad?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Json Face Data
   *
   * Specifies that face data should be included in output when combined with `fm=json`.
   *
   * Depends on: `fm=json`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/face-detection/json-face-data)
   */
  faces?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Fill Mode
   *
   * Determines how to fill in additional space created by the fit setting
   *
   * Depends on: `fit`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-mode)
   */
  fill?: InputMaybe<ImgixParamsFill>;
  /**
   * Fill Color
   *
   * Sets the fill color for images with additional space created by the fit setting
   *
   * Depends on: `fill=solid`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-color)
   */
  fillColor?: InputMaybe<Scalars['String']['input']>;
  /**
   * Fill Generative Fallback
   *
   * Sets the fallback behavior for generative fill.
   *
   * Depends on: `fit=fill`, `fill=gen`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-generative-fallback)
   */
  fillGenFallback?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Fill Generative Negative Prompt
   *
   * Provides a negative text suggestion to the generative fill parameter. Used to reduce the probability of a subject, detail, or object appearing in generative output.
   *
   * Depends on: `fit=fill`, `fill=gen`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-generative-negative-prompt)
   */
  fillGenNegPrompt?: InputMaybe<Scalars['String']['input']>;
  /**
   * Fill Generative Position
   *
   * Sets the position of the Origin Image in relation to the generative fill.
   *
   * Depends on: `fit=fill`, `fill=gen`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-generative-position)
   */
  fillGenPos?: InputMaybe<Array<ImgixParamsFillGenPos>>;
  /**
   * Fill Generative Prompt
   *
   * Provides a text suggestion to the generative fill parameter.
   *
   * Depends on: `fit=fill`, `fill=gen`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-generative-prompt)
   */
  fillGenPrompt?: InputMaybe<Scalars['String']['input']>;
  /**
   * Fill Generative Seed
   *
   * Sets the generative seed value. Used to generate similar outputs from different prompts.
   *
   * Depends on: `fit=fill`, `fill=gen`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-generative-seed)
   */
  fillGenSeed?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Fill Gradient Color Space
   *
   * Defines the color space as linear, sRGB, Oklab, HSL, or LCH for gradient color interpolation
   *
   * Depends on: `fit=fill`, `fill=gradient`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-gradient-color-space)
   */
  fillGradientCs?: InputMaybe<ImgixParamsFillGradientCs>;
  /**
   * Fill Gradient Linear
   *
   * Blends a gradient between two colors, {color1} and {color2}, along a straight path
   *
   * Depends on: `fit=fill`, `fill=gradient`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-gradient-linear)
   */
  fillGradientLinear?: InputMaybe<Scalars['String']['input']>;
  /**
   * Fill Gradient Linear Direction
   *
   * The fill-gradient-linear-direction specifies the gradient's direction, flowing towards the bottom, top, right, or left
   *
   * Depends on: `fit=fill`, `fill=gen`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-gradient-linear-direction)
   */
  fillGradientLinearDirection?: InputMaybe<Array<ImgixParamsFillGradientLinearDirection>>;
  /**
   * Fill Gradient Radial
   *
   * The fill-gradient-radial parameter creates a circular gradient transitioning from a central color (Color1) to an outer color (Color2)
   *
   * Depends on: `fit=fill`, `fill=gradient`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-gradient-radial)
   */
  fillGradientRadial?: InputMaybe<Scalars['String']['input']>;
  /**
   * Fill Gradient Radial Radius
   *
   * Parameter defines the radial gradient's radius as pixels or a percentage (0.0-1.0) of the image's smallest dimension
   *
   * Depends on: `fit=fill`, `fill=gradient`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-gradient-radial-radius)
   */
  fillGradientRadialRadius?: InputMaybe<Scalars['String']['input']>;
  /**
   * Fill Gradient Radial X
   *
   * Specifies the location of the radial gradient's center along the x-axis, using either a pixel value or a floating point percentage (ranging from 0.0 to 1.0) of the image's width
   *
   * Depends on: `fit=fill`, `fill=gradient`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-gradient-radial-x)
   */
  fillGradientRadialX?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Fill Gradient Radial Y
   *
   * Parameter sets the radial gradient's center on the y-axis, using pixels or a 0.0 to 1.0 percentage of the image's height
   *
   * Depends on: `fit=fill`, `fill=gradient`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-gradient-radial-y)
   */
  fillGradientRadialY?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Fill Gradient Type
   *
   * Specifies if a gradient is radial (circular) or linear (straight)
   *
   * Depends on: `fit=fill`, `fill=gradient`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/fill-gradient-type)
   */
  fillGradientType?: InputMaybe<ImgixParamsFillGradientType>;
  /**
   * Resize Fit Mode
   *
   * Specifies how to map the source image to the output image dimensions.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/size/resize-fit-mode)
   */
  fit?: InputMaybe<ImgixParamsFit>;
  /**
   * Flip Axis
   *
   * Flips an image on a specified axis.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/rotation/flip-axis)
   */
  flip?: InputMaybe<ImgixParamsFlip>;
  /**
   * Output Format
   *
   * Changes the format of the output image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/format/output-format)
   */
  fm?: InputMaybe<ImgixParamsFm>;
  /**
   * Focal Point Debug
   *
   * Displays crosshairs identifying the location of the set focal point
   *
   * Depends on: `fit=crop`, `crop=focalpoint`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/focal-point-crop/focal-point-debug)
   */
  fpDebug?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Focal Point X Position
   *
   * Sets the relative horizontal value for the focal point of an image
   *
   * Depends on: `fit=crop`, `crop=focalpoint`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/focal-point-crop/focal-point-x-position)
   */
  fpX?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Focal Point Y Position
   *
   * Sets the relative vertical value for the focal point of an image
   *
   * Depends on: `fit=crop`, `crop=focalpoint`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/focal-point-crop/focal-point-y-position)
   */
  fpY?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Focal Point Zoom
   *
   * Sets the relative zoom value for the focal point of an image
   *
   * Depends on: `fit=crop`, `crop=focalpoint`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/focal-point-crop/focal-point-zoom)
   */
  fpZ?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Frames Per Second
   *
   * Specifies the framerate of the generated image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/animation/frames-per-second)
   */
  fps?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Frame Selection
   *
   * Specifies the frame of an animated image to use.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/animation/frame-selection)
   */
  frame?: InputMaybe<Scalars['String']['input']>;
  /**
   * Gamma
   *
   * Adjusts the gamma of the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/adjustment/gamma)
   */
  gam?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Animated Gif Quality
   *
   * Specifies the quality of the animated gif. The higher the value, the better more compression is applied.
   *
   * Depends on: `fm=gif`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/animation/animated-gif-quality)
   */
  gifQ?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Grid Colors
   *
   * Sets grid colors for the transparency checkerboard grid.
   *
   * Depends on: `transparency`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/grid-colors)
   */
  gridColors?: InputMaybe<Scalars['String']['input']>;
  /**
   * Grid Size
   *
   * Sets grid size for the transparency checkerboard grid.
   *
   * Depends on: `transparency`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/grid-size)
   */
  gridSize?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Image Height
   *
   * Adjusts the height of the output image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/size/image-height)
   */
  h?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Highlight
   *
   * Adjusts the highlights of the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/adjustment/highlight)
   */
  high?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Halftone
   *
   * Applies a half-tone effect to the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/stylize/halftone)
   */
  htn?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Hue Shift
   *
   * Adjusts the hue of the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/adjustment/hue-shift)
   */
  hue?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Frame Interval
   *
   * Displays every Nth frame starting with the first frame.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/animation/frame-interval)
   */
  interval?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Invert
   *
   * Inverts the colors on the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/adjustment/invert)
   */
  invert?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Iptc Passthrough
   *
   * Determine if IPTC data should be passed for JPEG images.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/format/iptc-passthrough)
   */
  iptc?: InputMaybe<ImgixParamsIptc>;
  /**
   * Jpg Progressive
   *
   * Specifies whether or not a jpg/jpeg uses progressive (true) or baseline (false)
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/format/jpg-progressive)
   */
  jpgProgressive?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Animation Loop Count
   *
   * Specifies the number of times an animated image should repeat. A value of 0 means infinite looping.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/animation)
   */
  loop?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Lossless Compression
   *
   * Specifies that the output image should be a lossless variant.
   *
   * Depends on: `fm=webp`, `fm=jxr`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/format/lossless-compression)
   */
  lossless?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * License Plate Blur
   *
   * Specifies the amount of blur to apply to detected license plates. Defaults to 0.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/license-plate-detection/license-plate-blur)
   */
  lpBlur?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Watermark Image Url
   *
   * Specifies the location of the watermark image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-image-url)
   */
  mark?: InputMaybe<Scalars['String']['input']>;
  /**
   * Watermark Alignment Mode
   *
   * Changes the watermark alignment relative to the parent image.
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-alignment-mode)
   */
  markAlign?: InputMaybe<Array<ImgixParamsMarkAlign>>;
  /**
   * Watermark Alpha
   *
   * Changes the alpha of the watermark image.
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-alpha)
   */
  markAlpha?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Watermark Base Url
   *
   * Changes base URL of the watermark image.
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-base-url)
   */
  markBase?: InputMaybe<Scalars['String']['input']>;
  /**
   * Watermark Fit Mode
   *
   * Specifies the fit mode for watermark images.
   *
   * Depends on: `mark`, `markw`, `markh`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-fit-mode)
   */
  markFit?: InputMaybe<ImgixParamsMarkFit>;
  /**
   * Watermark Height
   *
   * Adjusts the height of the watermark image.
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-height)
   */
  markH?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Watermark If Minimum Height
   *
   * Displays the watermark if rendered base image pixel height is equal to or larger than the supplied value
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-if-minimum-height)
   */
  markIfMinHeight?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Watermark If Minimum Width
   *
   * Displays the watermark if rendered base image pixel width is equal to or larger than the supplied value
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-if-minimum-width)
   */
  markIfMinWidth?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Watermark Padding
   *
   * Applies padding to the watermark image.
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-padding)
   */
  markPad?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Watermark Rotation
   *
   * Rotates a watermark or tiled watermarks by a specified number of degrees.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-rotation)
   */
  markRot?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Watermark Scale
   *
   * Adjusts the scale of the watermark image.
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-scale)
   */
  markScale?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Watermark Tile
   *
   * Adds tiled watermark.
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-tile)
   */
  markTile?: InputMaybe<ImgixParamsMarkTile>;
  /**
   * Watermark Width
   *
   * Adjusts the width of the watermark image.
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-width)
   */
  markW?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Watermark X Position
   *
   * Adjusts the x-offset of the watermark image relative to its parent.
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-x-position)
   */
  markX?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Watermark Y Position
   *
   * Adjusts the y-offset of the watermark image relative to its parent.
   *
   * Depends on: `mark`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/watermark/watermark-y-position)
   */
  markY?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Mask Type
   *
   * Defines the type of mask and specifies the URL if that type is selected.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/mask-image/mask-type)
   */
  mask?: InputMaybe<Scalars['String']['input']>;
  /**
   * Mask Background Color
   *
   * Colors the background of the transparent mask area of images
   *
   * Depends on: `mask`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/mask-image/mask-background-color)
   */
  maskBg?: InputMaybe<Scalars['String']['input']>;
  /**
   * Maximum Height
   *
   * Specifies the maximum height of the output image in pixels.
   *
   * Depends on: `fit=crop`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/size/maximum-height)
   */
  maxH?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Maximum Width
   *
   * Specifies the maximum width of the output image in pixels.
   *
   * Depends on: `fit=crop`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/size/maximum-width)
   */
  maxW?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Minimum Height
   *
   * Specifies the minimum height of the output image in pixels.
   *
   * Depends on: `fit=crop`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/size/minimum-height)
   */
  minH?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Minimum Width
   *
   * Specifies the minimum width of the output image in pixels.
   *
   * Depends on: `fit=crop`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/size/minimum-width)
   */
  minW?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Monochrome
   *
   * Applies a monochrome effect to the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/stylize/monochrome)
   */
  monochrome?: InputMaybe<Scalars['String']['input']>;
  /**
   * Noise Reduction Bound
   *
   * Reduces the noise in an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/noise-reduction/noise-reduction-bound)
   */
  nr?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Noise Reduction Sharpen
   *
   * Provides a threshold by which to sharpen an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/noise-reduction/noise-reduction-sharpen)
   */
  nrs?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Object Removal Negative Prompt
   *
   * Provides a negative text suggestion to object-removal-prompt. Used to reduce the probability of a subject, detail, or object appearing in generative output.
   *
   * Depends on: `object-removal-rect`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/object-manipulation/object-removal-negative-prompt)
   */
  objectRemovalNegativePrompt?: InputMaybe<Scalars['String']['input']>;
  /**
   * Object Removal Prompt
   *
   * Suggest auto generative fill for the object-removal-rect parameter
   *
   * Depends on: `object-removal-rect`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/object-manipulation/object-removal-prompt)
   */
  objectRemovalPrompt?: InputMaybe<Scalars['String']['input']>;
  /**
   * Object Removal
   *
   * Using a specified rectangle, an object is removed from the image
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/object-manipulation/object-removal)
   */
  objectRemovalRect?: InputMaybe<Scalars['String']['input']>;
  /**
   * Object Removal Seed
   *
   * Sets the generative seed value for object-removal. Used to generate new outputs from the same prompt
   *
   * Depends on: `object-removal-rect`, `object-removal-prompt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/object-manipulation/object-removal-seed)
   */
  objectRemovalSeed?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Orientation
   *
   * Changes the image orientation.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/rotation/orientation)
   */
  orient?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Padding
   *
   * Pads an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/border-and-padding/padding)
   */
  pad?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Padding Bottom
   *
   * Sets bottom padding of an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/border-and-padding/padding-bottom)
   */
  padBottom?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Padding Left
   *
   * Sets left padding of an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/border-and-padding/padding-left)
   */
  padLeft?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Padding Right
   *
   * Sets right padding of an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/border-and-padding/padding-right)
   */
  padRight?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Padding Top
   *
   * Sets top padding of an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/border-and-padding/padding-top)
   */
  padTop?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Pdf Page Number
   *
   * Selects a page from a PDF for display.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/pdf/pdf-page-number)
   */
  page?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Color Palette Extraction
   *
   * Specifies an output format for palette-extraction.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/color-palette/color-palette-extraction)
   */
  palette?: InputMaybe<ImgixParamsPalette>;
  /**
   * Pdf Annotation
   *
   * Enables or disables PDF annotation.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/pdf/pdf-annotation)
   */
  pdfAnnotation?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Css Prefix
   *
   * Specifies a CSS prefix for all classes in palette-extraction.
   *
   * Depends on: `palette=css`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/color-palette/css-prefix)
   */
  prefix?: InputMaybe<Scalars['String']['input']>;
  /**
   * Pixellate
   *
   * Applies a pixelation effect to an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/stylize/pixellate)
   */
  px?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Output Quality
   *
   * Adjusts the quality of an output image.
   *
   * Depends on: `fm=avif`, `fm=jpg`, `fm=pjpg`, `fm=webp`, `fm=jxr`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/format/output-quality)
   */
  q?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Rasterize Bypass
   *
   * Bypasses all rendering parameters (including default parameters) and serves the original image. Works for svg+xml,x-eps,pdf, and vnd.adobe.illustrator.
   */
  rasterizeBypass?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Source Rectangle Region
   *
   * Crops an image to a specified rectangle.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/size/source-rectangle-region)
   */
  rect?: InputMaybe<Scalars['String']['input']>;
  /**
   * Reverse
   *
   * Reverses the frame order on the source animation.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/animation/reverse)
   */
  reverse?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Rotation
   *
   * Rotates an image by a specified number of degrees.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/rotation/rotation)
   */
  rot?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Rotation Type
   *
   * Changes the rotation type.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/rotation/rotation-type)
   */
  rotType?: InputMaybe<ImgixParamsRotType>;
  /**
   * Saturation
   *
   * Adjusts the saturation of an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/adjustment/saturation)
   */
  sat?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Sepia Tone
   *
   * Applies a sepia effect to an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/stylize/sepia-tone)
   */
  sepia?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Shadow
   *
   * Adjusts the highlights of the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/adjustment/shadow)
   */
  shad?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Sharpen
   *
   * Adjusts the sharpness of the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/adjustment/sharpen)
   */
  sharp?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Frame Skip
   *
   * Skips every Nth frame starting with the first frame.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/animation/frame-skip)
   */
  skip?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Bypasses any [DatoCMS Automatic Image Optimization](https://www.datocms.com/docs/cdn-settings/advanced-asset-settings) that might be set up for the project.
   *
   * Exercise caution when using this parameter, as it could significantly increase your bandwidth costs.
   */
  skipDefaultOptimizations?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Sanitize Svg
   *
   * Specifies whether to sanitize an SVG.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/format/sanitize-svg)
   */
  svgSanitize?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Transparency
   *
   * Adds checkerboard behind images which support transparency.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/fill/transparency)
   */
  transparency?: InputMaybe<ImgixParamsTransparency>;
  /**
   * Trim Image
   *
   * Trims the source image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/trim/trim-image)
   */
  trim?: InputMaybe<ImgixParamsTrim>;
  /**
   * Trim Alpha
   *
   * Specifies a trim alpha on a trim operation.
   *
   * Depends on: `trim=alpha`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/trim/trim-alpha)
   */
  trimAlpha?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Trim Color
   *
   * Specifies a trim color on a trim operation.
   *
   * Depends on: `trim=color`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/trim/trim-color)
   */
  trimColor?: InputMaybe<Scalars['String']['input']>;
  /**
   * Trim Mean Difference
   *
   * Specifies the mean difference on a trim operation.
   *
   * Depends on: `trim=auto`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/trim/trim-mean-difference)
   */
  trimMd?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Trim Padding
   *
   * Pads the area of the source image before trimming.
   *
   * Depends on: `trim`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/trim/trim-padding)
   */
  trimPad?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Trim Standard Deviation
   *
   * Specifies the standard deviation on a trim operation.
   *
   * Depends on: `trim=auto`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/trim/trim-standard-deviation)
   */
  trimSd?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Trim Tolerance
   *
   * Specifies the tolerance on a trim operation.
   *
   * Depends on: `trim=color`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/trim/trim-tolerance)
   */
  trimTol?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Text String
   *
   * Sets the text string to render.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-string)
   */
  txt?: InputMaybe<Scalars['String']['input']>;
  /**
   * Text Align
   *
   * Sets the vertical and horizontal alignment of rendered text relative to the base image.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-align)
   */
  txtAlign?: InputMaybe<Array<ImgixParamsTxtAlign>>;
  /**
   * Text Clipping Mode
   *
   * Sets the clipping properties of rendered text.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-clipping-mode)
   */
  txtClip?: InputMaybe<Array<ImgixParamsTxtClip>>;
  /**
   * Text Color
   *
   * Specifies the color of rendered text.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-color)
   */
  txtColor?: InputMaybe<Scalars['String']['input']>;
  /**
   * Text Fit Mode
   *
   * Specifies the fit approach for rendered text.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-fit-mode)
   */
  txtFit?: InputMaybe<ImgixParamsTxtFit>;
  /**
   * Text Font
   *
   * Selects a font for rendered text.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-font)
   */
  txtFont?: InputMaybe<Scalars['String']['input']>;
  /**
   * Text Leading
   *
   * Sets the leading (line spacing) for rendered text. Only works on the multi-line text endpoint.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/typesetting-endpoint/text-leading)
   */
  txtLead?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Text Outline
   *
   * Outlines the rendered text with a specified color.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-outline)
   */
  txtLine?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Text Outline Color
   *
   * Specifies a text outline color.
   *
   * Depends on: `txt`, `txtline`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-outline-color)
   */
  txtLineColor?: InputMaybe<Scalars['String']['input']>;
  /**
   * Text Padding
   *
   * Specifies the padding (in device-independent pixels) between a textbox and the edges of the base image.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-padding)
   */
  txtPad?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Text Shadow
   *
   * Applies a shadow to rendered text.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-shadow)
   */
  txtShad?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Text Font Size
   *
   * Sets the font size of rendered text.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-font-size)
   */
  txtSize?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Text Tracking
   *
   * Sets the tracking (letter spacing) for rendered text. Only works on the multi-line text endpoint.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/typesetting-endpoint/text-tracking)
   */
  txtTrack?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Text Width
   *
   * Sets the width of rendered text.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-width)
   */
  txtWidth?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Text X Position
   *
   * Sets the horizontal (x) position of the text in pixels relative to the left edge of the base image.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-x-position)
   */
  txtX?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Text Y Position
   *
   * Sets the vertical (y) position of the text in pixels relative to the top edge of the base image.
   *
   * Depends on: `txt`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/text/text-y-position)
   */
  txtY?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Super Resolution
   *
   * Uses generative AI fill to upscale low resolution images.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/super-resolution)
   */
  upscale?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Super Resolution Fallback
   *
   * Overrides default fallback behavior for super resolution failures
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/super-resolution)
   */
  upscaleFallback?: InputMaybe<Scalars['BooleanType']['input']>;
  /**
   * Unsharp Mask
   *
   * Sharpens the source image using an unsharp mask.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/adjustment/unsharp-mask)
   */
  usm?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Unsharp Mask Radius
   *
   * Specifies the radius for an unsharp mask operation.
   *
   * Depends on: `usm`
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/adjustment/unsharp-mask-radius)
   */
  usmrad?: InputMaybe<Scalars['FloatType']['input']>;
  /**
   * Vibrance
   *
   * Adjusts the vibrance of an image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/adjustment/vibrance)
   */
  vib?: InputMaybe<Scalars['IntType']['input']>;
  /**
   * Image Width
   *
   * Adjusts the width of the output image.
   *
   * [Open Imgix reference »](https://docs.imgix.com/apis/rendering/size/image-width)
   */
  w?: InputMaybe<Scalars['FloatType']['input']>;
};

export enum ImgixParamsAuto {
  compress = 'compress',
  enhance = 'enhance',
  format = 'format',
  redeye = 'redeye'
}

export enum ImgixParamsBgRemoveFgType {
  auto = 'auto',
  car = 'car'
}

export enum ImgixParamsBlendAlign {
  bottom = 'bottom',
  center = 'center',
  left = 'left',
  middle = 'middle',
  right = 'right',
  top = 'top'
}

export enum ImgixParamsBlendCrop {
  bottom = 'bottom',
  faces = 'faces',
  left = 'left',
  right = 'right',
  top = 'top'
}

export enum ImgixParamsBlendFit {
  clamp = 'clamp',
  clip = 'clip',
  crop = 'crop',
  max = 'max',
  scale = 'scale'
}

export enum ImgixParamsBlendMode {
  burn = 'burn',
  color = 'color',
  darken = 'darken',
  difference = 'difference',
  dodge = 'dodge',
  exclusion = 'exclusion',
  hardlight = 'hardlight',
  hue = 'hue',
  lighten = 'lighten',
  luminosity = 'luminosity',
  multiply = 'multiply',
  normal = 'normal',
  overlay = 'overlay',
  saturation = 'saturation',
  screen = 'screen',
  softlight = 'softlight'
}

export enum ImgixParamsBlendSize {
  inherit = 'inherit'
}

export enum ImgixParamsCh {
  dpr = 'dpr',
  saveData = 'saveData',
  width = 'width'
}

export enum ImgixParamsCrop {
  bottom = 'bottom',
  edges = 'edges',
  entropy = 'entropy',
  faces = 'faces',
  focalpoint = 'focalpoint',
  left = 'left',
  right = 'right',
  top = 'top'
}

export enum ImgixParamsCs {
  adobergb1998 = 'adobergb1998',
  origin = 'origin',
  srgb = 'srgb',
  strip = 'strip',
  tinysrgb = 'tinysrgb'
}

export enum ImgixParamsFill {
  blur = 'blur',
  gen = 'gen',
  generative = 'generative',
  gradient = 'gradient',
  solid = 'solid'
}

export enum ImgixParamsFillGenPos {
  bottom = 'bottom',
  center = 'center',
  left = 'left',
  middle = 'middle',
  right = 'right',
  top = 'top'
}

export enum ImgixParamsFillGradientCs {
  hsl = 'hsl',
  lch = 'lch',
  linear = 'linear',
  oklab = 'oklab',
  srgb = 'srgb'
}

export enum ImgixParamsFillGradientLinearDirection {
  bottom = 'bottom',
  left = 'left',
  right = 'right',
  top = 'top'
}

export enum ImgixParamsFillGradientType {
  linear = 'linear',
  radial = 'radial'
}

export enum ImgixParamsFit {
  clamp = 'clamp',
  clip = 'clip',
  crop = 'crop',
  facearea = 'facearea',
  fill = 'fill',
  fillmax = 'fillmax',
  max = 'max',
  min = 'min',
  scale = 'scale'
}

export enum ImgixParamsFlip {
  h = 'h',
  hv = 'hv',
  v = 'v'
}

export enum ImgixParamsFm {
  avif = 'avif',
  blurhash = 'blurhash',
  gif = 'gif',
  jp2 = 'jp2',
  jpg = 'jpg',
  json = 'json',
  jxr = 'jxr',
  mp4 = 'mp4',
  pjpg = 'pjpg',
  png = 'png',
  png8 = 'png8',
  png32 = 'png32',
  webm = 'webm',
  webp = 'webp'
}

export enum ImgixParamsIptc {
  allow = 'allow',
  block = 'block'
}

export enum ImgixParamsMarkAlign {
  bottom = 'bottom',
  center = 'center',
  left = 'left',
  middle = 'middle',
  right = 'right',
  top = 'top'
}

export enum ImgixParamsMarkFit {
  clip = 'clip',
  crop = 'crop',
  fill = 'fill',
  max = 'max',
  scale = 'scale'
}

export enum ImgixParamsMarkTile {
  grid = 'grid'
}

export enum ImgixParamsPalette {
  css = 'css',
  json = 'json'
}

export enum ImgixParamsRotType {
  pivot = 'pivot',
  straighten = 'straighten'
}

export enum ImgixParamsTransparency {
  grid = 'grid'
}

export enum ImgixParamsTrim {
  alpha = 'alpha',
  auto = 'auto',
  color = 'color'
}

export enum ImgixParamsTxtAlign {
  bottom = 'bottom',
  center = 'center',
  left = 'left',
  middle = 'middle',
  right = 'right',
  top = 'top'
}

export enum ImgixParamsTxtClip {
  ellipsis = 'ellipsis',
  end = 'end',
  middle = 'middle',
  start = 'start'
}

export enum ImgixParamsTxtFit {
  max = 'max'
}

/** Specifies how to filter by usage */
export type InUseFilter = {
  /** Search uploads that are currently used by some record or not */
  eq?: InputMaybe<Scalars['BooleanType']['input']>;
};

/** Block of type Inline Asset Gallery (inline_asset_gallery) */
export type InlineAssetGalleryRecord = RecordInterface & {
  __typename: 'InlineAssetGalleryRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  assets: Array<FileField>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  internalTitle: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Inline Asset Gallery (inline_asset_gallery) */
export type InlineAssetGalleryRecord_SeoMetaTagsArgs = {
  locale: InputMaybe<SiteLocale>;
};

/** Block of type Inline Asset (inline_asset) */
export type InlineAssetRecord = RecordInterface & {
  __typename: 'InlineAssetRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  asset: FileField;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  internalTitle: Maybe<Scalars['String']['output']>;
  limitWidth: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Inline Asset (inline_asset) */
export type InlineAssetRecord_SeoMetaTagsArgs = {
  locale: InputMaybe<SiteLocale>;
};

export type InlineLinkButtonModelInternalField = BreadcrumbRecord | PageRecord;

/** Block of type Link Button (inline_link_button) */
export type InlineLinkButtonRecord = RecordInterface & {
  __typename: 'InlineLinkButtonRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  analyticsId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  internal: Maybe<InlineLinkButtonModelInternalField>;
  jumpMark: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  leftIcon: Maybe<IconReferenceRecord>;
  linkStyle: Scalars['String']['output'];
  linkType: Scalars['String']['output'];
  rightIcon: Maybe<IconReferenceRecord>;
  text: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  url: Maybe<Scalars['String']['output']>;
};


/** Block of type Link Button (inline_link_button) */
export type InlineLinkButtonRecord_SeoMetaTagsArgs = {
  locale: InputMaybe<SiteLocale>;
};


/** Block of type Link Button (inline_link_button) */
export type InlineLinkButtonRecordTextArgs = {
  markdown: InputMaybe<Scalars['Boolean']['input']>;
};

/** Block of type Modal Button (inline_modal_button) */
export type InlineModalButtonRecord = RecordInterface & {
  __typename: 'InlineModalButtonRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  analyticsId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  enablePrefill: Maybe<Scalars['BooleanType']['output']>;
  id: Scalars['ItemId']['output'];
  label: Scalars['String']['output'];
  leftIcon: Maybe<IconReferenceRecord>;
  linkStyle: Scalars['String']['output'];
  modalName: Scalars['String']['output'];
  product: Maybe<InsuranceProductRecord>;
  rightIcon: Maybe<IconReferenceRecord>;
  text: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Modal Button (inline_modal_button) */
export type InlineModalButtonRecord_SeoMetaTagsArgs = {
  locale: InputMaybe<SiteLocale>;
};


/** Block of type Modal Button (inline_modal_button) */
export type InlineModalButtonRecordTextArgs = {
  markdown: InputMaybe<Scalars['Boolean']['input']>;
};

export type InsuranceProductFamilyModelBottomContentField = AboutRecord | BlogpostSectionRecord | ContactSectionRecord | CtaSectionRecord | CustomerReviewsSectionRecord | FaqSectionRecord | ImageTextSectionRecord | LinkCardsSectionRecord | LogoWallSectionRecord | MissionRecord | MissionSliderRecord | NewsletterSectionRecord | NewsletterSignupRecord | OffersBlockRecord | PersonaRecord | ServiceBenefitRecord | TextSectionRecord | UserActionSectionRecord | VideoCollectionRecord;

export type InsuranceProductFamilyModelBottomContentFieldListListNonNullMultiLocaleField = {
  __typename: 'InsuranceProductFamilyModelBottomContentFieldListListNonNullMultiLocaleField';
  locale: Maybe<SiteLocale>;
  value: Array<InsuranceProductFamilyModelBottomContentField>;
};

/** Linking fields */
export enum InsuranceProductFamilyModelFieldsReferencingBrandModel {
  insuranceProductFamily_brands = 'insuranceProductFamily_brands'
}

/** Linking fields */
export enum InsuranceProductFamilyModelFieldsReferencingBreadcrumbModel {
  insuranceProductFamily_bottomContent = 'insuranceProductFamily_bottomContent',
  insuranceProductFamily_bottomContent__about_text__inlineLinkButton_internal = 'insuranceProductFamily_bottomContent__about_text__inlineLinkButton_internal',
  insuranceProductFamily_bottomContent__blogpostSection_intro__inlineLinkButton_internal = 'insuranceProductFamily_bottomContent__blogpostSection_intro__inlineLinkButton_internal',
  insuranceProductFamily_bottomContent__ctaSection_linkButtons__inlineLinkButton_internal = 'insuranceProductFamily_bottomContent__ctaSection_linkButtons__inlineLinkButton_internal',
  insuranceProductFamily_bottomContent__imageTextSection_text__inlineLinkButton_internal = 'insuranceProductFamily_bottomContent__imageTextSection_text__inlineLinkButton_internal',
  insuranceProductFamily_bottomContent__linkCardsSection_cards__linkCard_links__inlineLinkButton_internal = 'insuranceProductFamily_bottomContent__linkCardsSection_cards__linkCard_links__inlineLinkButton_internal',
  insuranceProductFamily_bottomContent__offersBlock_text__offerSingle_link__inlineLinkButton_internal = 'insuranceProductFamily_bottomContent__offersBlock_text__offerSingle_link__inlineLinkButton_internal',
  insuranceProductFamily_bottomContent__textSection_text__inlineLinkButton_internal = 'insuranceProductFamily_bottomContent__textSection_text__inlineLinkButton_internal',
  insuranceProductFamily_bottomContent__userActionSection_userActions__inlineLinkButton_internal = 'insuranceProductFamily_bottomContent__userActionSection_userActions__inlineLinkButton_internal',
  insuranceProductFamily_bottomContent__videoCollection_intro__inlineLinkButton_internal = 'insuranceProductFamily_bottomContent__videoCollection_intro__inlineLinkButton_internal',
  insuranceProductFamily_breadcrumb = 'insuranceProductFamily_breadcrumb',
  insuranceProductFamily_topContent = 'insuranceProductFamily_topContent',
  insuranceProductFamily_topContent__about_text__inlineLinkButton_internal = 'insuranceProductFamily_topContent__about_text__inlineLinkButton_internal',
  insuranceProductFamily_topContent__blogpostSection_intro__inlineLinkButton_internal = 'insuranceProductFamily_topContent__blogpostSection_intro__inlineLinkButton_internal',
  insuranceProductFamily_topContent__ctaSection_linkButtons__inlineLinkButton_internal = 'insuranceProductFamily_topContent__ctaSection_linkButtons__inlineLinkButton_internal',
  insuranceProductFamily_topContent__heroSlider_slides__hero_cta__inlineLinkButton_internal = 'insuranceProductFamily_topContent__heroSlider_slides__hero_cta__inlineLinkButton_internal',
  insuranceProductFamily_topContent__heroSlider_slides__hero_text__inlineLinkButton_internal = 'insuranceProductFamily_topContent__heroSlider_slides__hero_text__inlineLinkButton_internal',
  insuranceProductFamily_topContent__hero_cta__inlineLinkButton_internal = 'insuranceProductFamily_topContent__hero_cta__inlineLinkButton_internal',
  insuranceProductFamily_topContent__hero_text__inlineLinkButton_internal = 'insuranceProductFamily_topContent__hero_text__inlineLinkButton_internal',
  insuranceProductFamily_topContent__imageTextSection_text__inlineLinkButton_internal = 'insuranceProductFamily_topContent__imageTextSection_text__inlineLinkButton_internal',
  insuranceProductFamily_topContent__linkCardsSection_cards__linkCard_links__inlineLinkButton_internal = 'insuranceProductFamily_topContent__linkCardsSection_cards__linkCard_links__inlineLinkButton_internal',
  insuranceProductFamily_topContent__navigationSection_links__inlineLinkButton_internal = 'insuranceProductFamily_topContent__navigationSection_links__inlineLinkButton_internal',
  insuranceProductFamily_topContent__offersBlock_text__offerSingle_link__inlineLinkButton_internal = 'insuranceProductFamily_topContent__offersBlock_text__offerSingle_link__inlineLinkButton_internal',
  insuranceProductFamily_topContent__textSection_text__inlineLinkButton_internal = 'insuranceProductFamily_topContent__textSection_text__inlineLinkButton_internal',
  insuranceProductFamily_topContent__userActionSection_userActions__inlineLinkButton_internal = 'insuranceProductFamily_topContent__userActionSection_userActions__inlineLinkButton_internal',
  insuranceProductFamily_topContent__videoCollection_intro__inlineLinkButton_internal = 'insuranceProductFamily_topContent__videoCollection_intro__inlineLinkButton_internal'
}

export type InsuranceProductFamilyModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<InsuranceProductFamilyModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<InsuranceProductFamilyModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _locales?: InputMaybe<LocalesFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  brands?: InputMaybe<LinksFilter>;
  breadcrumb?: InputMaybe<LinkFilter>;
  color?: InputMaybe<ColorFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  customProductOrder?: InputMaybe<LinksFilter>;
  header?: InputMaybe<LinkFilter>;
  id?: InputMaybe<ItemIdFilter>;
  name?: InputMaybe<StringFilter>;
  seo?: InputMaybe<SeoFilter>;
  slug?: InputMaybe<SlugFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum InsuranceProductFamilyModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  name_ASC = 'name_ASC',
  name_DESC = 'name_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type InsuranceProductFamilyModelTopContentField = AboutRecord | BlogpostSectionRecord | ContactSectionRecord | CtaSectionRecord | CustomerReviewsSectionRecord | FaqSectionRecord | HeroRecord | HeroSliderRecord | ImageTextSectionRecord | LinkCardsSectionRecord | LogoWallSectionRecord | MissionRecord | MissionSliderRecord | NavigationSectionRecord | NewsletterSectionRecord | NewsletterSignupRecord | OffersBlockRecord | PersonaRecord | PremiumCalcHeroRecord | ServiceBenefitRecord | TextSectionRecord | UserActionSectionRecord | VideoCollectionRecord;

export type InsuranceProductFamilyModelTopContentFieldListListNonNullMultiLocaleField = {
  __typename: 'InsuranceProductFamilyModelTopContentFieldListListNonNullMultiLocaleField';
  locale: Maybe<SiteLocale>;
  value: Array<InsuranceProductFamilyModelTopContentField>;
};

/** Record of type Insurance Product Family (insurance_product_family) */
export type InsuranceProductFamilyRecord = RecordInterface & {
  __typename: 'InsuranceProductFamilyRecord';
  _allBottomContentLocales: Maybe<Array<InsuranceProductFamilyModelBottomContentFieldListListNonNullMultiLocaleField>>;
  _allBreadcrumbLocales: Maybe<Array<BreadcrumbRecordNonNullMultiLocaleField>>;
  _allNameLocales: Maybe<Array<StringNonNullMultiLocaleField>>;
  _allSeoLocales: Maybe<Array<SeoFieldMultiLocaleField>>;
  _allSlugLocales: Maybe<Array<StringNonNullMultiLocaleField>>;
  _allTopContentLocales: Maybe<Array<InsuranceProductFamilyModelTopContentFieldListListNonNullMultiLocaleField>>;
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _locales: Array<SiteLocale>;
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  bottomContent: Array<InsuranceProductFamilyModelBottomContentField>;
  brands: Array<BrandRecord>;
  breadcrumb: BreadcrumbRecord;
  color: ColorField;
  createdAt: Scalars['DateTime']['output'];
  customProductOrder: Array<InsuranceProductRecord>;
  header: Maybe<HeaderRecord>;
  id: Scalars['ItemId']['output'];
  name: Scalars['String']['output'];
  seo: Maybe<SeoField>;
  slug: Scalars['String']['output'];
  topContent: Array<InsuranceProductFamilyModelTopContentField>;
  updatedAt: Scalars['DateTime']['output'];
};


/** Record of type Insurance Product Family (insurance_product_family) */
export type InsuranceProductFamilyRecord_AllBottomContentLocalesArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Insurance Product Family (insurance_product_family) */
export type InsuranceProductFamilyRecord_AllBreadcrumbLocalesArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Insurance Product Family (insurance_product_family) */
export type InsuranceProductFamilyRecord_AllNameLocalesArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Insurance Product Family (insurance_product_family) */
export type InsuranceProductFamilyRecord_AllSeoLocalesArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Insurance Product Family (insurance_product_family) */
export type InsuranceProductFamilyRecord_AllSlugLocalesArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Insurance Product Family (insurance_product_family) */
export type InsuranceProductFamilyRecord_AllTopContentLocalesArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Insurance Product Family (insurance_product_family) */
export type InsuranceProductFamilyRecord_SeoMetaTagsArgs = {
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Insurance Product Family (insurance_product_family) */
export type InsuranceProductFamilyRecordBottomContentArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Insurance Product Family (insurance_product_family) */
export type InsuranceProductFamilyRecordBreadcrumbArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Insurance Product Family (insurance_product_family) */
export type InsuranceProductFamilyRecordNameArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Insurance Product Family (insurance_product_family) */
export type InsuranceProductFamilyRecordSeoArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Insurance Product Family (insurance_product_family) */
export type InsuranceProductFamilyRecordSlugArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Insurance Product Family (insurance_product_family) */
export type InsuranceProductFamilyRecordTopContentArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};

export type InsuranceProductFamilyRecordNonNullMultiLocaleField = {
  __typename: 'InsuranceProductFamilyRecordNonNullMultiLocaleField';
  locale: Maybe<SiteLocale>;
  value: InsuranceProductFamilyRecord;
};

export type InsuranceProductModelBottomContentField = AboutRecord | BlogpostSectionRecord | ContactSectionRecord | CtaSectionRecord | CustomerReviewsSectionRecord | FaqSectionRecord | ImageTextSectionRecord | LinkCardsSectionRecord | LogoWallSectionRecord | MissionRecord | MissionSliderRecord | NewsletterSectionRecord | NewsletterSignupRecord | OffersBlockRecord | PersonaRecord | ProductComparisonRecord | ServiceBenefitRecord | ServiceOverviewSectionRecord | TextSectionRecord | UserActionSectionRecord | VideoCollectionRecord | VideoSectionRecord;

export type InsuranceProductModelBottomContentFieldListListNonNullMultiLocaleField = {
  __typename: 'InsuranceProductModelBottomContentFieldListListNonNullMultiLocaleField';
  locale: Maybe<SiteLocale>;
  value: Array<InsuranceProductModelBottomContentField>;
};

/** Linking fields */
export enum InsuranceProductModelFieldsReferencingBrandModel {
  insuranceProduct_brands = 'insuranceProduct_brands'
}

/** Linking fields */
export enum InsuranceProductModelFieldsReferencingBreadcrumbModel {
  insuranceProduct_bottomContent = 'insuranceProduct_bottomContent',
  insuranceProduct_bottomContent__about_text__inlineLinkButton_internal = 'insuranceProduct_bottomContent__about_text__inlineLinkButton_internal',
  insuranceProduct_bottomContent__blogpostSection_intro__inlineLinkButton_internal = 'insuranceProduct_bottomContent__blogpostSection_intro__inlineLinkButton_internal',
  insuranceProduct_bottomContent__ctaSection_linkButtons__inlineLinkButton_internal = 'insuranceProduct_bottomContent__ctaSection_linkButtons__inlineLinkButton_internal',
  insuranceProduct_bottomContent__imageTextSection_text__inlineLinkButton_internal = 'insuranceProduct_bottomContent__imageTextSection_text__inlineLinkButton_internal',
  insuranceProduct_bottomContent__linkCardsSection_cards__linkCard_links__inlineLinkButton_internal = 'insuranceProduct_bottomContent__linkCardsSection_cards__linkCard_links__inlineLinkButton_internal',
  insuranceProduct_bottomContent__offersBlock_text__offerSingle_link__inlineLinkButton_internal = 'insuranceProduct_bottomContent__offersBlock_text__offerSingle_link__inlineLinkButton_internal',
  insuranceProduct_bottomContent__productComparison_products__product_description__inlineLinkButton_internal = 'insuranceProduct_bottomContent__productComparison_products__product_description__inlineLinkButton_internal',
  insuranceProduct_bottomContent__textSection_text__inlineLinkButton_internal = 'insuranceProduct_bottomContent__textSection_text__inlineLinkButton_internal',
  insuranceProduct_bottomContent__userActionSection_userActions__inlineLinkButton_internal = 'insuranceProduct_bottomContent__userActionSection_userActions__inlineLinkButton_internal',
  insuranceProduct_bottomContent__videoCollection_intro__inlineLinkButton_internal = 'insuranceProduct_bottomContent__videoCollection_intro__inlineLinkButton_internal',
  insuranceProduct_bottomContent__videoSection_button__inlineLinkButton_internal = 'insuranceProduct_bottomContent__videoSection_button__inlineLinkButton_internal',
  insuranceProduct_bottomContent__videoSection_persona__videoSectionPersona_text__inlineLinkButton_internal = 'insuranceProduct_bottomContent__videoSection_persona__videoSectionPersona_text__inlineLinkButton_internal',
  insuranceProduct_bottomContent__videoSection_text__inlineLinkButton_internal = 'insuranceProduct_bottomContent__videoSection_text__inlineLinkButton_internal',
  insuranceProduct_bottomContent__videoSection_topicSubline__inlineLinkButton_internal = 'insuranceProduct_bottomContent__videoSection_topicSubline__inlineLinkButton_internal',
  insuranceProduct_breadcrumb = 'insuranceProduct_breadcrumb',
  insuranceProduct_targetGroupBottomContent = 'insuranceProduct_targetGroupBottomContent',
  insuranceProduct_targetGroupBottomContent__about_text__inlineLinkButton_internal = 'insuranceProduct_targetGroupBottomContent__about_text__inlineLinkButton_internal',
  insuranceProduct_targetGroupBottomContent__ctaSection_linkButtons__inlineLinkButton_internal = 'insuranceProduct_targetGroupBottomContent__ctaSection_linkButtons__inlineLinkButton_internal',
  insuranceProduct_targetGroupBottomContent__imageTextSection_text__inlineLinkButton_internal = 'insuranceProduct_targetGroupBottomContent__imageTextSection_text__inlineLinkButton_internal',
  insuranceProduct_targetGroupBottomContent__linkCardsSection_cards__linkCard_links__inlineLinkButton_internal = 'insuranceProduct_targetGroupBottomContent__linkCardsSection_cards__linkCard_links__inlineLinkButton_internal',
  insuranceProduct_targetGroupBottomContent__offersBlock_text__offerSingle_link__inlineLinkButton_internal = 'insuranceProduct_targetGroupBottomContent__offersBlock_text__offerSingle_link__inlineLinkButton_internal',
  insuranceProduct_targetGroupBottomContent__productComparison_products__product_description__inlineLinkButton_internal = 'insuranceProduct_targetGroupBottomContent__productComparison_products__product_description__inlineLinkButton_internal',
  insuranceProduct_targetGroupBottomContent__textSection_text__inlineLinkButton_internal = 'insuranceProduct_targetGroupBottomContent__textSection_text__inlineLinkButton_internal',
  insuranceProduct_targetGroupBottomContent__userActionSection_userActions__inlineLinkButton_internal = 'insuranceProduct_targetGroupBottomContent__userActionSection_userActions__inlineLinkButton_internal',
  insuranceProduct_targetGroupBottomContent__videoCollection_intro__inlineLinkButton_internal = 'insuranceProduct_targetGroupBottomContent__videoCollection_intro__inlineLinkButton_internal',
  insuranceProduct_targetGroupBottomContent__videoSection_button__inlineLinkButton_internal = 'insuranceProduct_targetGroupBottomContent__videoSection_button__inlineLinkButton_internal',
  insuranceProduct_targetGroupBottomContent__videoSection_persona__videoSectionPersona_text__inlineLinkButton_internal = 'insuranceProduct_targetGroupBottomContent__videoSection_persona__videoSectionPersona_text__inlineLinkButton_internal',
  insuranceProduct_targetGroupBottomContent__videoSection_text__inlineLinkButton_internal = 'insuranceProduct_targetGroupBottomContent__videoSection_text__inlineLinkButton_internal',
  insuranceProduct_targetGroupBottomContent__videoSection_topicSubline__inlineLinkButton_internal = 'insuranceProduct_targetGroupBottomContent__videoSection_topicSubline__inlineLinkButton_internal',
  insuranceProduct_targetGroupTopContent = 'insuranceProduct_targetGroupTopContent',
  insuranceProduct_targetGroupTopContent__about_text__inlineLinkButton_internal = 'insuranceProduct_targetGroupTopContent__about_text__inlineLinkButton_internal',
  insuranceProduct_targetGroupTopContent__ctaSection_linkButtons__inlineLinkButton_internal = 'insuranceProduct_targetGroupTopContent__ctaSection_linkButtons__inlineLinkButton_internal',
  insuranceProduct_targetGroupTopContent__heroSlider_slides__hero_cta__inlineLinkButton_internal = 'insuranceProduct_targetGroupTopContent__heroSlider_slides__hero_cta__inlineLinkButton_internal',
  insuranceProduct_targetGroupTopContent__heroSlider_slides__hero_text__inlineLinkButton_internal = 'insuranceProduct_targetGroupTopContent__heroSlider_slides__hero_text__inlineLinkButton_internal',
  insuranceProduct_targetGroupTopContent__hero_cta__inlineLinkButton_internal = 'insuranceProduct_targetGroupTopContent__hero_cta__inlineLinkButton_internal',
  insuranceProduct_targetGroupTopContent__hero_text__inlineLinkButton_internal = 'insuranceProduct_targetGroupTopContent__hero_text__inlineLinkButton_internal',
  insuranceProduct_targetGroupTopContent__imageTextSection_text__inlineLinkButton_internal = 'insuranceProduct_targetGroupTopContent__imageTextSection_text__inlineLinkButton_internal',
  insuranceProduct_targetGroupTopContent__linkCardsSection_cards__linkCard_links__inlineLinkButton_internal = 'insuranceProduct_targetGroupTopContent__linkCardsSection_cards__linkCard_links__inlineLinkButton_internal',
  insuranceProduct_targetGroupTopContent__navigationSection_links__inlineLinkButton_internal = 'insuranceProduct_targetGroupTopContent__navigationSection_links__inlineLinkButton_internal',
  insuranceProduct_targetGroupTopContent__offersBlock_text__offerSingle_link__inlineLinkButton_internal = 'insuranceProduct_targetGroupTopContent__offersBlock_text__offerSingle_link__inlineLinkButton_internal',
  insuranceProduct_targetGroupTopContent__productComparison_products__product_description__inlineLinkButton_internal = 'insuranceProduct_targetGroupTopContent__productComparison_products__product_description__inlineLinkButton_internal',
  insuranceProduct_targetGroupTopContent__textSection_text__inlineLinkButton_internal = 'insuranceProduct_targetGroupTopContent__textSection_text__inlineLinkButton_internal',
  insuranceProduct_targetGroupTopContent__userActionSection_userActions__inlineLinkButton_internal = 'insuranceProduct_targetGroupTopContent__userActionSection_userActions__inlineLinkButton_internal',
  insuranceProduct_targetGroupTopContent__videoCollection_intro__inlineLinkButton_internal = 'insuranceProduct_targetGroupTopContent__videoCollection_intro__inlineLinkButton_internal',
  insuranceProduct_targetGroupTopContent__videoSection_button__inlineLinkButton_internal = 'insuranceProduct_targetGroupTopContent__videoSection_button__inlineLinkButton_internal',
  insuranceProduct_targetGroupTopContent__videoSection_persona__videoSectionPersona_text__inlineLinkButton_internal = 'insuranceProduct_targetGroupTopContent__videoSection_persona__videoSectionPersona_text__inlineLinkButton_internal',
  insuranceProduct_targetGroupTopContent__videoSection_text__inlineLinkButton_internal = 'insuranceProduct_targetGroupTopContent__videoSection_text__inlineLinkButton_internal',
  insuranceProduct_targetGroupTopContent__videoSection_topicSubline__inlineLinkButton_internal = 'insuranceProduct_targetGroupTopContent__videoSection_topicSubline__inlineLinkButton_internal',
  insuranceProduct_topContent = 'insuranceProduct_topContent',
  insuranceProduct_topContent__about_text__inlineLinkButton_internal = 'insuranceProduct_topContent__about_text__inlineLinkButton_internal',
  insuranceProduct_topContent__blogpostSection_intro__inlineLinkButton_internal = 'insuranceProduct_topContent__blogpostSection_intro__inlineLinkButton_internal',
  insuranceProduct_topContent__ctaSection_linkButtons__inlineLinkButton_internal = 'insuranceProduct_topContent__ctaSection_linkButtons__inlineLinkButton_internal',
  insuranceProduct_topContent__heroSlider_slides__hero_cta__inlineLinkButton_internal = 'insuranceProduct_topContent__heroSlider_slides__hero_cta__inlineLinkButton_internal',
  insuranceProduct_topContent__heroSlider_slides__hero_text__inlineLinkButton_internal = 'insuranceProduct_topContent__heroSlider_slides__hero_text__inlineLinkButton_internal',
  insuranceProduct_topContent__hero_cta__inlineLinkButton_internal = 'insuranceProduct_topContent__hero_cta__inlineLinkButton_internal',
  insuranceProduct_topContent__hero_text__inlineLinkButton_internal = 'insuranceProduct_topContent__hero_text__inlineLinkButton_internal',
  insuranceProduct_topContent__imageTextSection_text__inlineLinkButton_internal = 'insuranceProduct_topContent__imageTextSection_text__inlineLinkButton_internal',
  insuranceProduct_topContent__linkCardsSection_cards__linkCard_links__inlineLinkButton_internal = 'insuranceProduct_topContent__linkCardsSection_cards__linkCard_links__inlineLinkButton_internal',
  insuranceProduct_topContent__navigationSection_links__inlineLinkButton_internal = 'insuranceProduct_topContent__navigationSection_links__inlineLinkButton_internal',
  insuranceProduct_topContent__offersBlock_text__offerSingle_link__inlineLinkButton_internal = 'insuranceProduct_topContent__offersBlock_text__offerSingle_link__inlineLinkButton_internal',
  insuranceProduct_topContent__productComparison_products__product_description__inlineLinkButton_internal = 'insuranceProduct_topContent__productComparison_products__product_description__inlineLinkButton_internal',
  insuranceProduct_topContent__textSection_text__inlineLinkButton_internal = 'insuranceProduct_topContent__textSection_text__inlineLinkButton_internal',
  insuranceProduct_topContent__userActionSection_userActions__inlineLinkButton_internal = 'insuranceProduct_topContent__userActionSection_userActions__inlineLinkButton_internal',
  insuranceProduct_topContent__videoCollection_intro__inlineLinkButton_internal = 'insuranceProduct_topContent__videoCollection_intro__inlineLinkButton_internal',
  insuranceProduct_topContent__videoSection_button__inlineLinkButton_internal = 'insuranceProduct_topContent__videoSection_button__inlineLinkButton_internal',
  insuranceProduct_topContent__videoSection_persona__videoSectionPersona_text__inlineLinkButton_internal = 'insuranceProduct_topContent__videoSection_persona__videoSectionPersona_text__inlineLinkButton_internal',
  insuranceProduct_topContent__videoSection_text__inlineLinkButton_internal = 'insuranceProduct_topContent__videoSection_text__inlineLinkButton_internal',
  insuranceProduct_topContent__videoSection_topicSubline__inlineLinkButton_internal = 'insuranceProduct_topContent__videoSection_topicSubline__inlineLinkButton_internal'
}

export type InsuranceProductModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<InsuranceProductModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<InsuranceProductModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _locales?: InputMaybe<LocalesFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  brands?: InputMaybe<LinksFilter>;
  breadcrumb?: InputMaybe<LinkFilter>;
  callbackFormSlug?: InputMaybe<StringFilter>;
  cancelPolicyModal?: InputMaybe<TextFilter>;
  contact?: InputMaybe<LinkFilter>;
  createClaimModal?: InputMaybe<TextFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  currentVersion?: InputMaybe<LinkFilter>;
  demoFormSlug?: InputMaybe<StringFilter>;
  disabled?: InputMaybe<BooleanFilter>;
  embedUrl?: InputMaybe<JsonFilter>;
  externalProvider?: InputMaybe<StringFilter>;
  header?: InputMaybe<LinkFilter>;
  icon?: InputMaybe<FileFilter>;
  id?: InputMaybe<ItemIdFilter>;
  image?: InputMaybe<FileFilter>;
  insurer?: InputMaybe<StringFilter>;
  isOnlineApplication?: InputMaybe<BooleanFilter>;
  messageFormSlug?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  productCode?: InputMaybe<JsonFilter>;
  productFamily?: InputMaybe<LinkFilter>;
  productGroupDescription?: InputMaybe<TextFilter>;
  productGroupName?: InputMaybe<StringFilter>;
  productName?: InputMaybe<JsonFilter>;
  sendinblueFormUrl?: InputMaybe<StringFilter>;
  seo?: InputMaybe<SeoFilter>;
  showContactForm?: InputMaybe<BooleanFilter>;
  showMenu?: InputMaybe<BooleanFilter>;
  showPage?: InputMaybe<BooleanFilter>;
  showProduct?: InputMaybe<BooleanFilter>;
  showTariffCalculator?: InputMaybe<BooleanFilter>;
  slug?: InputMaybe<SlugFilter>;
  targetGroup?: InputMaybe<LinkFilter>;
  updatePaymentIntervalModal?: InputMaybe<TextFilter>;
  updatePolicyModal?: InputMaybe<TextFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
  userActions?: InputMaybe<JsonFilter>;
  versions?: InputMaybe<LinksFilter>;
  withdrawPolicyModal?: InputMaybe<TextFilter>;
};

export enum InsuranceProductModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  callbackFormSlug_ASC = 'callbackFormSlug_ASC',
  callbackFormSlug_DESC = 'callbackFormSlug_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  demoFormSlug_ASC = 'demoFormSlug_ASC',
  demoFormSlug_DESC = 'demoFormSlug_DESC',
  disabled_ASC = 'disabled_ASC',
  disabled_DESC = 'disabled_DESC',
  externalProvider_ASC = 'externalProvider_ASC',
  externalProvider_DESC = 'externalProvider_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  insurer_ASC = 'insurer_ASC',
  insurer_DESC = 'insurer_DESC',
  isOnlineApplication_ASC = 'isOnlineApplication_ASC',
  isOnlineApplication_DESC = 'isOnlineApplication_DESC',
  messageFormSlug_ASC = 'messageFormSlug_ASC',
  messageFormSlug_DESC = 'messageFormSlug_DESC',
  name_ASC = 'name_ASC',
  name_DESC = 'name_DESC',
  productGroupName_ASC = 'productGroupName_ASC',
  productGroupName_DESC = 'productGroupName_DESC',
  sendinblueFormUrl_ASC = 'sendinblueFormUrl_ASC',
  sendinblueFormUrl_DESC = 'sendinblueFormUrl_DESC',
  showContactForm_ASC = 'showContactForm_ASC',
  showContactForm_DESC = 'showContactForm_DESC',
  showMenu_ASC = 'showMenu_ASC',
  showMenu_DESC = 'showMenu_DESC',
  showPage_ASC = 'showPage_ASC',
  showPage_DESC = 'showPage_DESC',
  showProduct_ASC = 'showProduct_ASC',
  showProduct_DESC = 'showProduct_DESC',
  showTariffCalculator_ASC = 'showTariffCalculator_ASC',
  showTariffCalculator_DESC = 'showTariffCalculator_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type InsuranceProductModelTargetGroupBottomContentField = AboutRecord | ContactSectionRecord | CtaSectionRecord | CustomerReviewsSectionRecord | FaqSectionRecord | ImageTextSectionRecord | LinkCardsSectionRecord | LogoWallSectionRecord | MissionRecord | MissionSliderRecord | NewsletterSectionRecord | NewsletterSignupRecord | OffersBlockRecord | PersonaRecord | ProductComparisonRecord | ServiceBenefitRecord | ServiceOverviewSectionRecord | TextSectionRecord | UserActionSectionRecord | VideoCollectionRecord | VideoSectionRecord;

export type InsuranceProductModelTargetGroupBottomContentFieldListListNonNullMultiLocaleField = {
  __typename: 'InsuranceProductModelTargetGroupBottomContentFieldListListNonNullMultiLocaleField';
  locale: Maybe<SiteLocale>;
  value: Array<InsuranceProductModelTargetGroupBottomContentField>;
};

export type InsuranceProductModelTargetGroupTopContentField = AboutRecord | ContactSectionRecord | CtaSectionRecord | CustomerReviewsSectionRecord | FaqSectionRecord | HeroRecord | HeroSliderRecord | ImageTextSectionRecord | LinkCardsSectionRecord | LogoWallSectionRecord | MissionRecord | MissionSliderRecord | NavigationSectionRecord | NewsletterSectionRecord | NewsletterSignupRecord | OffersBlockRecord | PersonaRecord | PremiumCalcHeroRecord | ProductComparisonRecord | ServiceBenefitRecord | ServiceOverviewSectionRecord | TextSectionRecord | UserActionSectionRecord | VideoCollectionRecord | VideoSectionRecord;

export type InsuranceProductModelTargetGroupTopContentFieldListListNonNullMultiLocaleField = {
  __typename: 'InsuranceProductModelTargetGroupTopContentFieldListListNonNullMultiLocaleField';
  locale: Maybe<SiteLocale>;
  value: Array<InsuranceProductModelTargetGroupTopContentField>;
};

export type InsuranceProductModelTopContentField = AboutRecord | BlogpostSectionRecord | ContactSectionRecord | CtaSectionRecord | CustomerReviewsSectionRecord | FaqSectionRecord | HeroRecord | HeroSliderRecord | ImageTextSectionRecord | LinkCardsSectionRecord | LogoWallSectionRecord | MissionRecord | MissionSliderRecord | NavigationSectionRecord | NewsletterSectionRecord | NewsletterSignupRecord | OffersBlockRecord | PersonaRecord | PremiumCalcHeroRecord | ProductComparisonRecord | ServiceBenefitRecord | ServiceOverviewSectionRecord | TextSectionRecord | UserActionSectionRecord | VideoCollectionRecord | VideoSectionRecord;

export type InsuranceProductModelTopContentFieldListListNonNullMultiLocaleField = {
  __typename: 'InsuranceProductModelTopContentFieldListListNonNullMultiLocaleField';
  locale: Maybe<SiteLocale>;
  value: Array<InsuranceProductModelTopContentField>;
};

/** Record of type Insurance Product (insurance_product) */
export type InsuranceProductRecord = RecordInterface & {
  __typename: 'InsuranceProductRecord';
  _allBottomContentLocales: Maybe<Array<InsuranceProductModelBottomContentFieldListListNonNullMultiLocaleField>>;
  _allBreadcrumbLocales: Maybe<Array<BreadcrumbRecordNonNullMultiLocaleField>>;
  _allCancelPolicyModalLocales: Maybe<Array<StringMultiLocaleField>>;
  _allClaimModalLocales: Maybe<Array<ClaimModalRecordMultiLocaleField>>;
  _allContactLocales: Maybe<Array<ContactRecordMultiLocaleField>>;
  _allCreateClaimModalLocales: Maybe<Array<StringMultiLocaleField>>;
  _allInsurerLocales: Maybe<Array<StringNonNullMultiLocaleField>>;
  _allNameLocales: Maybe<Array<StringNonNullMultiLocaleField>>;
  _allProductFamilyLocales: Maybe<Array<InsuranceProductFamilyRecordNonNullMultiLocaleField>>;
  _allProductGroupDescriptionLocales: Maybe<Array<StringMultiLocaleField>>;
  _allProductGroupNameLocales: Maybe<Array<StringMultiLocaleField>>;
  _allSeoLocales: Maybe<Array<SeoFieldMultiLocaleField>>;
  _allSlugLocales: Maybe<Array<StringNonNullMultiLocaleField>>;
  _allTargetGroupBottomContentLocales: Maybe<Array<InsuranceProductModelTargetGroupBottomContentFieldListListNonNullMultiLocaleField>>;
  _allTargetGroupTopContentLocales: Maybe<Array<InsuranceProductModelTargetGroupTopContentFieldListListNonNullMultiLocaleField>>;
  _allTopContentLocales: Maybe<Array<InsuranceProductModelTopContentFieldListListNonNullMultiLocaleField>>;
  _allUpdatePaymentIntervalModalLocales: Maybe<Array<StringMultiLocaleField>>;
  _allUpdatePolicyModalLocales: Maybe<Array<StringMultiLocaleField>>;
  _allWithdrawPolicyModalLocales: Maybe<Array<StringMultiLocaleField>>;
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _locales: Array<SiteLocale>;
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  bottomContent: Array<InsuranceProductModelBottomContentField>;
  brands: Array<BrandRecord>;
  breadcrumb: BreadcrumbRecord;
  callbackFormSlug: Maybe<Scalars['String']['output']>;
  cancelPolicyModal: Maybe<Scalars['String']['output']>;
  claimModal: Maybe<ClaimModalRecord>;
  contact: Maybe<ContactRecord>;
  createClaimModal: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currentVersion: InsuranceProductVersionRecord;
  demoFormSlug: Maybe<Scalars['String']['output']>;
  disabled: Maybe<Scalars['BooleanType']['output']>;
  embedUrl: Scalars['JsonField']['output'];
  externalProvider: Maybe<Scalars['String']['output']>;
  header: Maybe<HeaderRecord>;
  icon: Maybe<FileField>;
  id: Scalars['ItemId']['output'];
  image: Maybe<FileField>;
  insurer: Scalars['String']['output'];
  isOnlineApplication: Maybe<Scalars['BooleanType']['output']>;
  messageFormSlug: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  productCode: Scalars['JsonField']['output'];
  productFamily: InsuranceProductFamilyRecord;
  productGroupDescription: Maybe<Scalars['String']['output']>;
  productGroupName: Maybe<Scalars['String']['output']>;
  productName: Scalars['JsonField']['output'];
  sendinblueFormUrl: Maybe<Scalars['String']['output']>;
  seo: Maybe<SeoField>;
  showContactForm: Maybe<Scalars['BooleanType']['output']>;
  showMenu: Maybe<Scalars['BooleanType']['output']>;
  showPage: Maybe<Scalars['BooleanType']['output']>;
  showProduct: Maybe<Scalars['BooleanType']['output']>;
  showTariffCalculator: Maybe<Scalars['BooleanType']['output']>;
  slug: Scalars['String']['output'];
  targetGroup: Maybe<TargetGroupRecord>;
  targetGroupBottomContent: Array<InsuranceProductModelTargetGroupBottomContentField>;
  targetGroupTopContent: Array<InsuranceProductModelTargetGroupTopContentField>;
  topContent: Array<InsuranceProductModelTopContentField>;
  updatePaymentIntervalModal: Maybe<Scalars['String']['output']>;
  updatePolicyModal: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  userActions: Scalars['JsonField']['output'];
  versions: Array<InsuranceProductVersionRecord>;
  withdrawPolicyModal: Maybe<Scalars['String']['output']>;
};


/** Record of type Insurance Product (insurance_product) */
export type InsuranceProductRecord_AllBottomContentLocalesArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Insurance Product (insurance_product) */
export type InsuranceProductRecord_AllBreadcrumbLocalesArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Insurance Product (insurance_product) */
export type InsuranceProductRecord_AllCancelPolicyModalLocalesArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
  markdown: InputMaybe<Scalars['Boolean']['input']>;
};


/** Record of type Insurance Product (insurance_product) */
export type InsuranceProductRecord_AllClaimModalLocalesArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Insurance Product (insurance_product) */
export type InsuranceProductRecord_AllContactLocalesArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Insurance Product (insurance_product) */
export type InsuranceProductRecord_AllCreateClaimModalLocalesArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
  markdown: InputMaybe<Scalars['Boolean']['input']>;
};


/** Record of type Insurance Product (insurance_product) */
export type InsuranceProductRecord_AllInsurerLocalesArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Insurance Product (insurance_product) */
export type InsuranceProductRecord_AllNameLocalesArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Insurance Product (insurance_product) */
export type InsuranceProductRecord_AllProductFamilyLocalesArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Insurance Product (insurance_product) */
export type InsuranceProductRecord_AllProductGroupDescriptionLocalesArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
  markdown: InputMaybe<Scalars['Boolean']['input']>;
};


/** Record of type Insurance Product (insurance_product) */
export type InsuranceProductRecord_AllProductGroupNameLocalesArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Insurance Product (insurance_product) */
export type InsuranceProductRecord_AllSeoLocalesArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Insurance Product (insurance_product) */
export type InsuranceProductRecord_AllSlugLocalesArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Insurance Product (insurance_product) */
export type InsuranceProductRecord_AllTargetGroupBottomContentLocalesArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Insurance Product (insurance_product) */
export type InsuranceProductRecord_AllTargetGroupTopContentLocalesArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Insurance Product (insurance_product) */
export type InsuranceProductRecord_AllTopContentLocalesArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Insurance Product (insurance_product) */
export type InsuranceProductRecord_AllUpdatePaymentIntervalModalLocalesArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
  markdown: InputMaybe<Scalars['Boolean']['input']>;
};


/** Record of type Insurance Product (insurance_product) */
export type InsuranceProductRecord_AllUpdatePolicyModalLocalesArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
  markdown: InputMaybe<Scalars['Boolean']['input']>;
};


/** Record of type Insurance Product (insurance_product) */
export type InsuranceProductRecord_AllWithdrawPolicyModalLocalesArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
  markdown: InputMaybe<Scalars['Boolean']['input']>;
};


/** Record of type Insurance Product (insurance_product) */
export type InsuranceProductRecord_SeoMetaTagsArgs = {
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Insurance Product (insurance_product) */
export type InsuranceProductRecordBottomContentArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Insurance Product (insurance_product) */
export type InsuranceProductRecordBreadcrumbArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Insurance Product (insurance_product) */
export type InsuranceProductRecordCancelPolicyModalArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
  markdown: InputMaybe<Scalars['Boolean']['input']>;
};


/** Record of type Insurance Product (insurance_product) */
export type InsuranceProductRecordClaimModalArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Insurance Product (insurance_product) */
export type InsuranceProductRecordContactArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Insurance Product (insurance_product) */
export type InsuranceProductRecordCreateClaimModalArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
  markdown: InputMaybe<Scalars['Boolean']['input']>;
};


/** Record of type Insurance Product (insurance_product) */
export type InsuranceProductRecordInsurerArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Insurance Product (insurance_product) */
export type InsuranceProductRecordNameArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Insurance Product (insurance_product) */
export type InsuranceProductRecordProductFamilyArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Insurance Product (insurance_product) */
export type InsuranceProductRecordProductGroupDescriptionArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
  markdown: InputMaybe<Scalars['Boolean']['input']>;
};


/** Record of type Insurance Product (insurance_product) */
export type InsuranceProductRecordProductGroupNameArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Insurance Product (insurance_product) */
export type InsuranceProductRecordSeoArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Insurance Product (insurance_product) */
export type InsuranceProductRecordSlugArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Insurance Product (insurance_product) */
export type InsuranceProductRecordTargetGroupBottomContentArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Insurance Product (insurance_product) */
export type InsuranceProductRecordTargetGroupTopContentArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Insurance Product (insurance_product) */
export type InsuranceProductRecordTopContentArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Insurance Product (insurance_product) */
export type InsuranceProductRecordUpdatePaymentIntervalModalArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
  markdown: InputMaybe<Scalars['Boolean']['input']>;
};


/** Record of type Insurance Product (insurance_product) */
export type InsuranceProductRecordUpdatePolicyModalArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
  markdown: InputMaybe<Scalars['Boolean']['input']>;
};


/** Record of type Insurance Product (insurance_product) */
export type InsuranceProductRecordWithdrawPolicyModalArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
  markdown: InputMaybe<Scalars['Boolean']['input']>;
};

export type InsuranceProductVersionModelCoverageTextBlocksField = InlineAssetRecord | InlineLinkButtonRecord | InlineModalButtonRecord;

export type InsuranceProductVersionModelCoverageTextField = {
  __typename: 'InsuranceProductVersionModelCoverageTextField';
  blocks: Array<InsuranceProductVersionModelCoverageTextBlocksField>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

export type InsuranceProductVersionModelCoverageTextFieldNonNullMultiLocaleField = {
  __typename: 'InsuranceProductVersionModelCoverageTextFieldNonNullMultiLocaleField';
  locale: Maybe<SiteLocale>;
  value: InsuranceProductVersionModelCoverageTextField;
};

/** Linking fields */
export enum InsuranceProductVersionModelFieldsReferencingBreadcrumbModel {
  insuranceProductVersion_coverageText = 'insuranceProductVersion_coverageText',
  insuranceProductVersion_coverageText__inlineLinkButton_internal = 'insuranceProductVersion_coverageText__inlineLinkButton_internal'
}

export type InsuranceProductVersionModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<InsuranceProductVersionModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<InsuranceProductVersionModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _locales?: InputMaybe<LocalesFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  coverageText?: InputMaybe<StructuredTextFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  externalClaimLink?: InputMaybe<StringFilter>;
  externalLink?: InputMaybe<StringFilter>;
  externalLinkText?: InputMaybe<StringFilter>;
  id?: InputMaybe<ItemIdFilter>;
  overviewFacts?: InputMaybe<StructuredTextFilter>;
  price?: InputMaybe<FloatFilter>;
  priceDescription?: InputMaybe<StringFilter>;
  product?: InputMaybe<LinkFilter>;
  productDescription?: InputMaybe<TextFilter>;
  uid?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum InsuranceProductVersionModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  externalClaimLink_ASC = 'externalClaimLink_ASC',
  externalClaimLink_DESC = 'externalClaimLink_DESC',
  externalLinkText_ASC = 'externalLinkText_ASC',
  externalLinkText_DESC = 'externalLinkText_DESC',
  externalLink_ASC = 'externalLink_ASC',
  externalLink_DESC = 'externalLink_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  priceDescription_ASC = 'priceDescription_ASC',
  priceDescription_DESC = 'priceDescription_DESC',
  price_ASC = 'price_ASC',
  price_DESC = 'price_DESC',
  uid_ASC = 'uid_ASC',
  uid_DESC = 'uid_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type InsuranceProductVersionModelOverviewFactsField = {
  __typename: 'InsuranceProductVersionModelOverviewFactsField';
  blocks: Array<Scalars['String']['output']>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

export type InsuranceProductVersionModelOverviewFactsFieldMultiLocaleField = {
  __typename: 'InsuranceProductVersionModelOverviewFactsFieldMultiLocaleField';
  locale: Maybe<SiteLocale>;
  value: Maybe<InsuranceProductVersionModelOverviewFactsField>;
};

/** Record of type Insurance Product Version (insurance_product_version) */
export type InsuranceProductVersionRecord = RecordInterface & {
  __typename: 'InsuranceProductVersionRecord';
  _allCoverageTextLocales: Maybe<Array<InsuranceProductVersionModelCoverageTextFieldNonNullMultiLocaleField>>;
  _allExternalClaimLinkLocales: Maybe<Array<StringMultiLocaleField>>;
  _allExternalLinkTextLocales: Maybe<Array<StringMultiLocaleField>>;
  _allOverviewFactsLocales: Maybe<Array<InsuranceProductVersionModelOverviewFactsFieldMultiLocaleField>>;
  _allPriceDescriptionLocales: Maybe<Array<StringMultiLocaleField>>;
  _allProductDescriptionLocales: Maybe<Array<StringNonNullMultiLocaleField>>;
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _locales: Array<SiteLocale>;
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  coverageText: InsuranceProductVersionModelCoverageTextField;
  createdAt: Scalars['DateTime']['output'];
  externalClaimLink: Maybe<Scalars['String']['output']>;
  externalLink: Maybe<Scalars['String']['output']>;
  externalLinkText: Maybe<Scalars['String']['output']>;
  id: Scalars['ItemId']['output'];
  overviewFacts: Maybe<InsuranceProductVersionModelOverviewFactsField>;
  price: Maybe<Scalars['FloatType']['output']>;
  priceDescription: Maybe<Scalars['String']['output']>;
  product: InsuranceProductRecord;
  productDescription: Scalars['String']['output'];
  uid: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


/** Record of type Insurance Product Version (insurance_product_version) */
export type InsuranceProductVersionRecord_AllCoverageTextLocalesArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Insurance Product Version (insurance_product_version) */
export type InsuranceProductVersionRecord_AllExternalClaimLinkLocalesArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Insurance Product Version (insurance_product_version) */
export type InsuranceProductVersionRecord_AllExternalLinkTextLocalesArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Insurance Product Version (insurance_product_version) */
export type InsuranceProductVersionRecord_AllOverviewFactsLocalesArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Insurance Product Version (insurance_product_version) */
export type InsuranceProductVersionRecord_AllPriceDescriptionLocalesArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Insurance Product Version (insurance_product_version) */
export type InsuranceProductVersionRecord_AllProductDescriptionLocalesArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
  markdown: InputMaybe<Scalars['Boolean']['input']>;
};


/** Record of type Insurance Product Version (insurance_product_version) */
export type InsuranceProductVersionRecord_SeoMetaTagsArgs = {
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Insurance Product Version (insurance_product_version) */
export type InsuranceProductVersionRecordCoverageTextArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Insurance Product Version (insurance_product_version) */
export type InsuranceProductVersionRecordExternalClaimLinkArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Insurance Product Version (insurance_product_version) */
export type InsuranceProductVersionRecordExternalLinkTextArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Insurance Product Version (insurance_product_version) */
export type InsuranceProductVersionRecordOverviewFactsArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Insurance Product Version (insurance_product_version) */
export type InsuranceProductVersionRecordPriceDescriptionArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Insurance Product Version (insurance_product_version) */
export type InsuranceProductVersionRecordProductDescriptionArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
  markdown: InputMaybe<Scalars['Boolean']['input']>;
};

/** Specifies how to filter Integer fields */
export type IntegerFilter = {
  /** Search for records with an exact match */
  eq?: InputMaybe<Scalars['IntType']['input']>;
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records with a value that's strictly greater than the one specified */
  gt?: InputMaybe<Scalars['IntType']['input']>;
  /** Filter records with a value that's greater than or equal to the one specified */
  gte?: InputMaybe<Scalars['IntType']['input']>;
  /** Filter records with a value that's less than the one specified */
  lt?: InputMaybe<Scalars['IntType']['input']>;
  /** Filter records with a value that's less or equal than the one specified */
  lte?: InputMaybe<Scalars['IntType']['input']>;
  /** Exclude records with an exact match */
  neq?: InputMaybe<Scalars['IntType']['input']>;
};

/** Specifies how to filter by linking fields */
export type InverseRelationshipFieldFilterBetweenBlogpostAndBrand = {
  /** Filter linking records that reference current record in at least one of the specified fields */
  anyIn?: InputMaybe<Array<BlogpostModelFieldsReferencingBrandModel>>;
  /** Filter linking records that do not reference current record in any of the specified fields */
  notIn?: InputMaybe<Array<BlogpostModelFieldsReferencingBrandModel>>;
};

/** Specifies how to filter by linking fields */
export type InverseRelationshipFieldFilterBetweenBlogpostAndBreadcrumb = {
  /** Filter linking records that reference current record in at least one of the specified fields */
  anyIn?: InputMaybe<Array<BlogpostModelFieldsReferencingBreadcrumbModel>>;
  /** Filter linking records that do not reference current record in any of the specified fields */
  notIn?: InputMaybe<Array<BlogpostModelFieldsReferencingBreadcrumbModel>>;
};

/** Specifies how to filter by linking fields */
export type InverseRelationshipFieldFilterBetweenBrandAndBreadcrumb = {
  /** Filter linking records that reference current record in at least one of the specified fields */
  anyIn?: InputMaybe<Array<BrandModelFieldsReferencingBreadcrumbModel>>;
  /** Filter linking records that do not reference current record in any of the specified fields */
  notIn?: InputMaybe<Array<BrandModelFieldsReferencingBreadcrumbModel>>;
};

/** Specifies how to filter by linking fields */
export type InverseRelationshipFieldFilterBetweenHeaderAndBreadcrumb = {
  /** Filter linking records that reference current record in at least one of the specified fields */
  anyIn?: InputMaybe<Array<HeaderModelFieldsReferencingBreadcrumbModel>>;
  /** Filter linking records that do not reference current record in any of the specified fields */
  notIn?: InputMaybe<Array<HeaderModelFieldsReferencingBreadcrumbModel>>;
};

/** Specifies how to filter by linking fields */
export type InverseRelationshipFieldFilterBetweenInsuranceProductAndBrand = {
  /** Filter linking records that reference current record in at least one of the specified fields */
  anyIn?: InputMaybe<Array<InsuranceProductModelFieldsReferencingBrandModel>>;
  /** Filter linking records that do not reference current record in any of the specified fields */
  notIn?: InputMaybe<Array<InsuranceProductModelFieldsReferencingBrandModel>>;
};

/** Specifies how to filter by linking fields */
export type InverseRelationshipFieldFilterBetweenInsuranceProductAndBreadcrumb = {
  /** Filter linking records that reference current record in at least one of the specified fields */
  anyIn?: InputMaybe<Array<InsuranceProductModelFieldsReferencingBreadcrumbModel>>;
  /** Filter linking records that do not reference current record in any of the specified fields */
  notIn?: InputMaybe<Array<InsuranceProductModelFieldsReferencingBreadcrumbModel>>;
};

/** Specifies how to filter by linking fields */
export type InverseRelationshipFieldFilterBetweenInsuranceProductFamilyAndBrand = {
  /** Filter linking records that reference current record in at least one of the specified fields */
  anyIn?: InputMaybe<Array<InsuranceProductFamilyModelFieldsReferencingBrandModel>>;
  /** Filter linking records that do not reference current record in any of the specified fields */
  notIn?: InputMaybe<Array<InsuranceProductFamilyModelFieldsReferencingBrandModel>>;
};

/** Specifies how to filter by linking fields */
export type InverseRelationshipFieldFilterBetweenInsuranceProductFamilyAndBreadcrumb = {
  /** Filter linking records that reference current record in at least one of the specified fields */
  anyIn?: InputMaybe<Array<InsuranceProductFamilyModelFieldsReferencingBreadcrumbModel>>;
  /** Filter linking records that do not reference current record in any of the specified fields */
  notIn?: InputMaybe<Array<InsuranceProductFamilyModelFieldsReferencingBreadcrumbModel>>;
};

/** Specifies how to filter by linking fields */
export type InverseRelationshipFieldFilterBetweenInsuranceProductVersionAndBreadcrumb = {
  /** Filter linking records that reference current record in at least one of the specified fields */
  anyIn?: InputMaybe<Array<InsuranceProductVersionModelFieldsReferencingBreadcrumbModel>>;
  /** Filter linking records that do not reference current record in any of the specified fields */
  notIn?: InputMaybe<Array<InsuranceProductVersionModelFieldsReferencingBreadcrumbModel>>;
};

/** Specifies how to filter by linking fields */
export type InverseRelationshipFieldFilterBetweenPageAndBrand = {
  /** Filter linking records that reference current record in at least one of the specified fields */
  anyIn?: InputMaybe<Array<PageModelFieldsReferencingBrandModel>>;
  /** Filter linking records that do not reference current record in any of the specified fields */
  notIn?: InputMaybe<Array<PageModelFieldsReferencingBrandModel>>;
};

/** Specifies how to filter by linking fields */
export type InverseRelationshipFieldFilterBetweenPageAndBreadcrumb = {
  /** Filter linking records that reference current record in at least one of the specified fields */
  anyIn?: InputMaybe<Array<PageModelFieldsReferencingBreadcrumbModel>>;
  /** Filter linking records that do not reference current record in any of the specified fields */
  notIn?: InputMaybe<Array<PageModelFieldsReferencingBreadcrumbModel>>;
};

/** Specifies how to filter by linking fields */
export type InverseRelationshipFieldFilterBetweenTargetGroupAndBrand = {
  /** Filter linking records that reference current record in at least one of the specified fields */
  anyIn?: InputMaybe<Array<TargetGroupModelFieldsReferencingBrandModel>>;
  /** Filter linking records that do not reference current record in any of the specified fields */
  notIn?: InputMaybe<Array<TargetGroupModelFieldsReferencingBrandModel>>;
};

/** Specifies how to filter by linking fields */
export type InverseRelationshipFieldFilterBetweenTargetGroupAndBreadcrumb = {
  /** Filter linking records that reference current record in at least one of the specified fields */
  anyIn?: InputMaybe<Array<TargetGroupModelFieldsReferencingBreadcrumbModel>>;
  /** Filter linking records that do not reference current record in any of the specified fields */
  notIn?: InputMaybe<Array<TargetGroupModelFieldsReferencingBreadcrumbModel>>;
};

/** Specifies how to filter linking records */
export type InverseRelationshipFilterBetweenBlogpostAndBrand = {
  /** Specifies how to filter by linking fields */
  fields?: InputMaybe<InverseRelationshipFieldFilterBetweenBlogpostAndBrand>;
  /** Specifies how to filter by linking locales */
  locales?: InputMaybe<LinkingLocalesFilter>;
};

/** Specifies how to filter linking records */
export type InverseRelationshipFilterBetweenBlogpostAndBreadcrumb = {
  /** Specifies how to filter by linking fields */
  fields?: InputMaybe<InverseRelationshipFieldFilterBetweenBlogpostAndBreadcrumb>;
  /** Specifies how to filter by linking locales */
  locales?: InputMaybe<LinkingLocalesFilter>;
};

/** Specifies how to filter linking records */
export type InverseRelationshipFilterBetweenBrandAndBreadcrumb = {
  /** Specifies how to filter by linking fields */
  fields?: InputMaybe<InverseRelationshipFieldFilterBetweenBrandAndBreadcrumb>;
  /** Specifies how to filter by linking locales */
  locales?: InputMaybe<LinkingLocalesFilter>;
};

/** Specifies how to filter linking records */
export type InverseRelationshipFilterBetweenHeaderAndBreadcrumb = {
  /** Specifies how to filter by linking fields */
  fields?: InputMaybe<InverseRelationshipFieldFilterBetweenHeaderAndBreadcrumb>;
  /** Specifies how to filter by linking locales */
  locales?: InputMaybe<LinkingLocalesFilter>;
};

/** Specifies how to filter linking records */
export type InverseRelationshipFilterBetweenInsuranceProductAndBrand = {
  /** Specifies how to filter by linking fields */
  fields?: InputMaybe<InverseRelationshipFieldFilterBetweenInsuranceProductAndBrand>;
  /** Specifies how to filter by linking locales */
  locales?: InputMaybe<LinkingLocalesFilter>;
};

/** Specifies how to filter linking records */
export type InverseRelationshipFilterBetweenInsuranceProductAndBreadcrumb = {
  /** Specifies how to filter by linking fields */
  fields?: InputMaybe<InverseRelationshipFieldFilterBetweenInsuranceProductAndBreadcrumb>;
  /** Specifies how to filter by linking locales */
  locales?: InputMaybe<LinkingLocalesFilter>;
};

/** Specifies how to filter linking records */
export type InverseRelationshipFilterBetweenInsuranceProductFamilyAndBrand = {
  /** Specifies how to filter by linking fields */
  fields?: InputMaybe<InverseRelationshipFieldFilterBetweenInsuranceProductFamilyAndBrand>;
  /** Specifies how to filter by linking locales */
  locales?: InputMaybe<LinkingLocalesFilter>;
};

/** Specifies how to filter linking records */
export type InverseRelationshipFilterBetweenInsuranceProductFamilyAndBreadcrumb = {
  /** Specifies how to filter by linking fields */
  fields?: InputMaybe<InverseRelationshipFieldFilterBetweenInsuranceProductFamilyAndBreadcrumb>;
  /** Specifies how to filter by linking locales */
  locales?: InputMaybe<LinkingLocalesFilter>;
};

/** Specifies how to filter linking records */
export type InverseRelationshipFilterBetweenInsuranceProductVersionAndBreadcrumb = {
  /** Specifies how to filter by linking fields */
  fields?: InputMaybe<InverseRelationshipFieldFilterBetweenInsuranceProductVersionAndBreadcrumb>;
  /** Specifies how to filter by linking locales */
  locales?: InputMaybe<LinkingLocalesFilter>;
};

/** Specifies how to filter linking records */
export type InverseRelationshipFilterBetweenPageAndBrand = {
  /** Specifies how to filter by linking fields */
  fields?: InputMaybe<InverseRelationshipFieldFilterBetweenPageAndBrand>;
  /** Specifies how to filter by linking locales */
  locales?: InputMaybe<LinkingLocalesFilter>;
};

/** Specifies how to filter linking records */
export type InverseRelationshipFilterBetweenPageAndBreadcrumb = {
  /** Specifies how to filter by linking fields */
  fields?: InputMaybe<InverseRelationshipFieldFilterBetweenPageAndBreadcrumb>;
  /** Specifies how to filter by linking locales */
  locales?: InputMaybe<LinkingLocalesFilter>;
};

/** Specifies how to filter linking records */
export type InverseRelationshipFilterBetweenTargetGroupAndBrand = {
  /** Specifies how to filter by linking fields */
  fields?: InputMaybe<InverseRelationshipFieldFilterBetweenTargetGroupAndBrand>;
  /** Specifies how to filter by linking locales */
  locales?: InputMaybe<LinkingLocalesFilter>;
};

/** Specifies how to filter linking records */
export type InverseRelationshipFilterBetweenTargetGroupAndBreadcrumb = {
  /** Specifies how to filter by linking fields */
  fields?: InputMaybe<InverseRelationshipFieldFilterBetweenTargetGroupAndBreadcrumb>;
  /** Specifies how to filter by linking locales */
  locales?: InputMaybe<LinkingLocalesFilter>;
};

/** Specifies how to filter by ID */
export type ItemIdFilter = {
  /** Search the record with the specified ID */
  eq?: InputMaybe<Scalars['ItemId']['input']>;
  /** Search records with the specified IDs */
  in?: InputMaybe<Array<InputMaybe<Scalars['ItemId']['input']>>>;
  /** Exclude the record with the specified ID */
  neq?: InputMaybe<Scalars['ItemId']['input']>;
  /** Search records that do not have the specified IDs */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ItemId']['input']>>>;
};

export enum ItemStatus {
  draft = 'draft',
  published = 'published',
  updated = 'updated'
}

export type JsonFieldMultiLocaleField = {
  __typename: 'JsonFieldMultiLocaleField';
  locale: Maybe<SiteLocale>;
  value: Maybe<Scalars['JsonField']['output']>;
};

/** Specifies how to filter JSON fields */
export type JsonFilter = {
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
};

/** Block of type Link Card (link_card) */
export type LinkCardRecord = RecordInterface & {
  __typename: 'LinkCardRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  image: FileField;
  links: Array<InlineLinkButtonRecord>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  variant: Scalars['String']['output'];
};


/** Block of type Link Card (link_card) */
export type LinkCardRecord_SeoMetaTagsArgs = {
  locale: InputMaybe<SiteLocale>;
};

/** Block of type [Section] Link Cards (link_cards_section) */
export type LinkCardsSectionRecord = RecordInterface & {
  __typename: 'LinkCardsSectionRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  cards: Array<LinkCardRecord>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type [Section] Link Cards (link_cards_section) */
export type LinkCardsSectionRecord_SeoMetaTagsArgs = {
  locale: InputMaybe<SiteLocale>;
};

/** Specifies how to filter Single-link fields */
export type LinkFilter = {
  /** Search for records with an exact match. The specified value must be a Record ID */
  eq?: InputMaybe<Scalars['ItemId']['input']>;
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records linked to one of the specified records */
  in?: InputMaybe<Array<InputMaybe<Scalars['ItemId']['input']>>>;
  /** Exclude records with an exact match. The specified value must be a Record ID */
  neq?: InputMaybe<Scalars['ItemId']['input']>;
  /** Filter records not linked to one of the specified records */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ItemId']['input']>>>;
};

/** Linking locales */
export enum LinkingLocale {
  _nonLocalized = '_nonLocalized',
  de = 'de',
  en = 'en'
}

/** Specifies how to filter by linking locales */
export type LinkingLocalesFilter = {
  /** Filter linking records that link to current record in at least one of the specified locales */
  anyIn?: InputMaybe<Array<LinkingLocale>>;
  /** Filter linking records that do not link to current record in any of the specified locales */
  notIn?: InputMaybe<Array<LinkingLocale>>;
};

/** Specifies how to filter Multiple-links fields */
export type LinksFilter = {
  /** Filter records linked to all of the specified records. The specified values must be Record IDs */
  allIn?: InputMaybe<Array<InputMaybe<Scalars['ItemId']['input']>>>;
  /** Filter records linked to at least one of the specified records. The specified values must be Record IDs */
  anyIn?: InputMaybe<Array<InputMaybe<Scalars['ItemId']['input']>>>;
  /** Search for records with an exact match. The specified values must be Record IDs */
  eq?: InputMaybe<Array<InputMaybe<Scalars['ItemId']['input']>>>;
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records not linked to any of the specified records. The specified values must be Record IDs */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ItemId']['input']>>>;
};

/** Specifies how to filter by locale */
export type LocalesFilter = {
  /** Filter records that are localized in all the specified locales */
  allIn?: InputMaybe<Array<SiteLocale>>;
  /** Filter records that are localized in at least one of the specified locales */
  anyIn?: InputMaybe<Array<SiteLocale>>;
  /** Filter records that are not localized in any of the specified locales */
  notIn?: InputMaybe<Array<SiteLocale>>;
};

/** Block of type Logo Wall Section (logo_wall_section) */
export type LogoWallSectionRecord = RecordInterface & {
  __typename: 'LogoWallSectionRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  logos: Array<FileField>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Logo Wall Section (logo_wall_section) */
export type LogoWallSectionRecord_SeoMetaTagsArgs = {
  locale: InputMaybe<SiteLocale>;
};

export type MissionModelTextField = {
  __typename: 'MissionModelTextField';
  blocks: Array<Scalars['String']['output']>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

/** Block of type Mission (mission) */
export type MissionRecord = RecordInterface & {
  __typename: 'MissionRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  image: Maybe<FileField>;
  style: Scalars['String']['output'];
  text: Maybe<MissionModelTextField>;
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Mission (mission) */
export type MissionRecord_SeoMetaTagsArgs = {
  locale: InputMaybe<SiteLocale>;
};

/** Block of type Mission Slider (mission_slider) */
export type MissionSliderRecord = RecordInterface & {
  __typename: 'MissionSliderRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  slides: Array<MissionRecord>;
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Mission Slider (mission_slider) */
export type MissionSliderRecord_SeoMetaTagsArgs = {
  locale: InputMaybe<SiteLocale>;
};

export enum MuxThumbnailFormatType {
  gif = 'gif',
  jpg = 'jpg',
  png = 'png'
}

/** Block of type Navigation Section (navigation_section) */
export type NavigationSectionRecord = RecordInterface & {
  __typename: 'NavigationSectionRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  links: Array<InlineLinkButtonRecord>;
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Navigation Section (navigation_section) */
export type NavigationSectionRecord_SeoMetaTagsArgs = {
  locale: InputMaybe<SiteLocale>;
};

export type NewsletterSectionModelBottomContentField = {
  __typename: 'NewsletterSectionModelBottomContentField';
  blocks: Array<Scalars['String']['output']>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

export type NewsletterSectionModelTopContentField = {
  __typename: 'NewsletterSectionModelTopContentField';
  blocks: Array<Scalars['String']['output']>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

/** Block of type Newsletter Section (newsletter_section) */
export type NewsletterSectionRecord = RecordInterface & {
  __typename: 'NewsletterSectionRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  bottomContent: NewsletterSectionModelBottomContentField;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  topContent: NewsletterSectionModelTopContentField;
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Newsletter Section (newsletter_section) */
export type NewsletterSectionRecord_SeoMetaTagsArgs = {
  locale: InputMaybe<SiteLocale>;
};

/** Block of type Newsletter Signup (newsletter_signup) */
export type NewsletterSignupRecord = RecordInterface & {
  __typename: 'NewsletterSignupRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  action: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  intro: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Newsletter Signup (newsletter_signup) */
export type NewsletterSignupRecord_SeoMetaTagsArgs = {
  locale: InputMaybe<SiteLocale>;
};


/** Block of type Newsletter Signup (newsletter_signup) */
export type NewsletterSignupRecordIntroArgs = {
  markdown: InputMaybe<Scalars['Boolean']['input']>;
};

/** Block of type Offer (single) (offer_single) */
export type OfferSingleRecord = RecordInterface & {
  __typename: 'OfferSingleRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  icon: FileField;
  id: Scalars['ItemId']['output'];
  link: Array<InlineLinkButtonRecord>;
  text: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Offer (single) (offer_single) */
export type OfferSingleRecord_SeoMetaTagsArgs = {
  locale: InputMaybe<SiteLocale>;
};


/** Block of type Offer (single) (offer_single) */
export type OfferSingleRecordTextArgs = {
  markdown: InputMaybe<Scalars['Boolean']['input']>;
};

export type OffersBlockModelTextField = {
  __typename: 'OffersBlockModelTextField';
  blocks: Array<OfferSingleRecord>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

/** Block of type Offers (offers_block) */
export type OffersBlockRecord = RecordInterface & {
  __typename: 'OffersBlockRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  text: OffersBlockModelTextField;
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Offers (offers_block) */
export type OffersBlockRecord_SeoMetaTagsArgs = {
  locale: InputMaybe<SiteLocale>;
};

/** Block of type Onboarding (onboarding) */
export type OnboardingRecord = RecordInterface & {
  __typename: 'OnboardingRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  slides: Array<OnboardingSlideRecord>;
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Onboarding (onboarding) */
export type OnboardingRecord_SeoMetaTagsArgs = {
  locale: InputMaybe<SiteLocale>;
};

export type OnboardingRecordMultiLocaleField = {
  __typename: 'OnboardingRecordMultiLocaleField';
  locale: Maybe<SiteLocale>;
  value: Maybe<OnboardingRecord>;
};

/** Block of type Onboarding Slide (onboarding_slide) */
export type OnboardingSlideRecord = RecordInterface & {
  __typename: 'OnboardingSlideRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  image: FileField;
  text: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Onboarding Slide (onboarding_slide) */
export type OnboardingSlideRecord_SeoMetaTagsArgs = {
  locale: InputMaybe<SiteLocale>;
};


/** Block of type Onboarding Slide (onboarding_slide) */
export type OnboardingSlideRecordTextArgs = {
  markdown: InputMaybe<Scalars['Boolean']['input']>;
};

/** Specifies how to filter by image orientation */
export type OrientationFilter = {
  /** Search uploads with the specified orientation */
  eq?: InputMaybe<UploadOrientation>;
  /** Exclude uploads with the specified orientation */
  neq?: InputMaybe<UploadOrientation>;
};

export type PageModelContentField = AboutRecord | ActionTeaserSectionRecord | BlogpostSectionRecord | ContactSectionRecord | CtaSectionRecord | CustomerReviewsSectionRecord | DemoSectionRecord | FaqSectionRecord | FlipperSectionRecord | FunctionalityCollectionRecord | HeroRecord | HeroSliderRecord | ImageTextSectionRecord | LinkCardsSectionRecord | LogoWallSectionRecord | MissionRecord | MissionSliderRecord | NavigationSectionRecord | NewsletterSectionRecord | NewsletterSignupRecord | OffersBlockRecord | PersonaRecord | PremiumCalcHeroRecord | ProductComparisonRecord | ServiceBenefitRecord | ServiceOverviewSectionRecord | TextSectionRecord | UserActionSectionRecord | VideoCollectionRecord | VideoSectionRecord;

export type PageModelContentFieldListListNonNullMultiLocaleField = {
  __typename: 'PageModelContentFieldListListNonNullMultiLocaleField';
  locale: Maybe<SiteLocale>;
  value: Array<PageModelContentField>;
};

/** Linking fields */
export enum PageModelFieldsReferencingBrandModel {
  page_brands = 'page_brands'
}

/** Linking fields */
export enum PageModelFieldsReferencingBreadcrumbModel {
  page_breadcrumb = 'page_breadcrumb',
  page_content = 'page_content',
  page_content__about_text__inlineLinkButton_internal = 'page_content__about_text__inlineLinkButton_internal',
  page_content__blogpostSection_intro__inlineLinkButton_internal = 'page_content__blogpostSection_intro__inlineLinkButton_internal',
  page_content__ctaSection_linkButtons__inlineLinkButton_internal = 'page_content__ctaSection_linkButtons__inlineLinkButton_internal',
  page_content__flipperSection_intro__inlineLinkButton_internal = 'page_content__flipperSection_intro__inlineLinkButton_internal',
  page_content__functionalityCollection_intro__inlineLinkButton_internal = 'page_content__functionalityCollection_intro__inlineLinkButton_internal',
  page_content__heroSlider_slides__hero_cta__inlineLinkButton_internal = 'page_content__heroSlider_slides__hero_cta__inlineLinkButton_internal',
  page_content__heroSlider_slides__hero_text__inlineLinkButton_internal = 'page_content__heroSlider_slides__hero_text__inlineLinkButton_internal',
  page_content__hero_cta__inlineLinkButton_internal = 'page_content__hero_cta__inlineLinkButton_internal',
  page_content__hero_text__inlineLinkButton_internal = 'page_content__hero_text__inlineLinkButton_internal',
  page_content__imageTextSection_text__inlineLinkButton_internal = 'page_content__imageTextSection_text__inlineLinkButton_internal',
  page_content__linkCardsSection_cards__linkCard_links__inlineLinkButton_internal = 'page_content__linkCardsSection_cards__linkCard_links__inlineLinkButton_internal',
  page_content__navigationSection_links__inlineLinkButton_internal = 'page_content__navigationSection_links__inlineLinkButton_internal',
  page_content__offersBlock_text__offerSingle_link__inlineLinkButton_internal = 'page_content__offersBlock_text__offerSingle_link__inlineLinkButton_internal',
  page_content__productComparison_products__product_description__inlineLinkButton_internal = 'page_content__productComparison_products__product_description__inlineLinkButton_internal',
  page_content__textSection_text__inlineLinkButton_internal = 'page_content__textSection_text__inlineLinkButton_internal',
  page_content__userActionSection_userActions__inlineLinkButton_internal = 'page_content__userActionSection_userActions__inlineLinkButton_internal',
  page_content__videoCollection_intro__inlineLinkButton_internal = 'page_content__videoCollection_intro__inlineLinkButton_internal',
  page_content__videoSection_button__inlineLinkButton_internal = 'page_content__videoSection_button__inlineLinkButton_internal',
  page_content__videoSection_persona__videoSectionPersona_text__inlineLinkButton_internal = 'page_content__videoSection_persona__videoSectionPersona_text__inlineLinkButton_internal',
  page_content__videoSection_text__inlineLinkButton_internal = 'page_content__videoSection_text__inlineLinkButton_internal',
  page_content__videoSection_topicSubline__inlineLinkButton_internal = 'page_content__videoSection_topicSubline__inlineLinkButton_internal'
}

export type PageModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<PageModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<PageModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _locales?: InputMaybe<LocalesFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  brands?: InputMaybe<LinksFilter>;
  breadcrumb?: InputMaybe<LinkFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  id?: InputMaybe<ItemIdFilter>;
  name?: InputMaybe<StringFilter>;
  rolePermission?: InputMaybe<StringFilter>;
  seo?: InputMaybe<SeoFilter>;
  slug?: InputMaybe<SlugFilter>;
  targetGroup?: InputMaybe<LinkFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum PageModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  name_ASC = 'name_ASC',
  name_DESC = 'name_DESC',
  rolePermission_ASC = 'rolePermission_ASC',
  rolePermission_DESC = 'rolePermission_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

/** Record of type Page (page) */
export type PageRecord = RecordInterface & {
  __typename: 'PageRecord';
  _allContentLocales: Maybe<Array<PageModelContentFieldListListNonNullMultiLocaleField>>;
  _allNameLocales: Maybe<Array<StringNonNullMultiLocaleField>>;
  _allSeoLocales: Maybe<Array<SeoFieldMultiLocaleField>>;
  _allSlugLocales: Maybe<Array<StringNonNullMultiLocaleField>>;
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _locales: Array<SiteLocale>;
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  brands: Array<BrandRecord>;
  breadcrumb: Maybe<BreadcrumbRecord>;
  content: Array<PageModelContentField>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  name: Scalars['String']['output'];
  rolePermission: Maybe<Scalars['String']['output']>;
  seo: Maybe<SeoField>;
  slug: Scalars['String']['output'];
  targetGroup: Maybe<TargetGroupRecord>;
  updatedAt: Scalars['DateTime']['output'];
};


/** Record of type Page (page) */
export type PageRecord_AllContentLocalesArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Page (page) */
export type PageRecord_AllNameLocalesArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Page (page) */
export type PageRecord_AllSeoLocalesArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Page (page) */
export type PageRecord_AllSlugLocalesArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Page (page) */
export type PageRecord_SeoMetaTagsArgs = {
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Page (page) */
export type PageRecordContentArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Page (page) */
export type PageRecordNameArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Page (page) */
export type PageRecordSeoArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Page (page) */
export type PageRecordSlugArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};

export type PageRecordNonNullMultiLocaleField = {
  __typename: 'PageRecordNonNullMultiLocaleField';
  locale: Maybe<SiteLocale>;
  value: PageRecord;
};

/** Specifies how to filter by parent (tree-like collections only) */
export type ParentFilter = {
  /** Filter records children of the specified record. Value must be a Record ID */
  eq?: InputMaybe<Scalars['ItemId']['input']>;
  /** Filter records with a parent record or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
};

/** Block of type Persona Fact (persona_fact) */
export type PersonaFactRecord = RecordInterface & {
  __typename: 'PersonaFactRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  value: Scalars['String']['output'];
};


/** Block of type Persona Fact (persona_fact) */
export type PersonaFactRecord_SeoMetaTagsArgs = {
  locale: InputMaybe<SiteLocale>;
};

export type PersonaModelContentField = {
  __typename: 'PersonaModelContentField';
  blocks: Array<PersonaFactRecord>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

/** Block of type Persona (persona) */
export type PersonaRecord = RecordInterface & {
  __typename: 'PersonaRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  content: PersonaModelContentField;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  recommendationIcon: FileField;
  updatedAt: Scalars['DateTime']['output'];
  video: VideoFileField;
};


/** Block of type Persona (persona) */
export type PersonaRecord_SeoMetaTagsArgs = {
  locale: InputMaybe<SiteLocale>;
};

/** Specifies how to filter by position (sorted and tree-like collections) */
export type PositionFilter = {
  /** Search for records with an exact match */
  eq?: InputMaybe<Scalars['IntType']['input']>;
  /** Filter records with a value that's strictly greater than the one specified */
  gt?: InputMaybe<Scalars['IntType']['input']>;
  /** Filter records with a value that's greater than or equal to the one specified */
  gte?: InputMaybe<Scalars['IntType']['input']>;
  /** Filter records with a value that's less than the one specified */
  lt?: InputMaybe<Scalars['IntType']['input']>;
  /** Filter records with a value that's less or equal than the one specified */
  lte?: InputMaybe<Scalars['IntType']['input']>;
  /** Exclude records with an exact match */
  neq?: InputMaybe<Scalars['IntType']['input']>;
};

/** Block of type Premium Calc Hero (premium_calc_hero) */
export type PremiumCalcHeroRecord = RecordInterface & {
  __typename: 'PremiumCalcHeroRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  subline: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  video: VideoFileField;
};


/** Block of type Premium Calc Hero (premium_calc_hero) */
export type PremiumCalcHeroRecord_SeoMetaTagsArgs = {
  locale: InputMaybe<SiteLocale>;
};


/** Block of type Premium Calc Hero (premium_calc_hero) */
export type PremiumCalcHeroRecordSublineArgs = {
  markdown: InputMaybe<Scalars['Boolean']['input']>;
};


/** Block of type Premium Calc Hero (premium_calc_hero) */
export type PremiumCalcHeroRecordTitleArgs = {
  markdown: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProductComparisonModelProductsField = {
  __typename: 'ProductComparisonModelProductsField';
  blocks: Array<ProductRecord>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

/** Block of type Product Comparison (product_comparison) */
export type ProductComparisonRecord = RecordInterface & {
  __typename: 'ProductComparisonRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  introAlignment: Scalars['String']['output'];
  products: ProductComparisonModelProductsField;
  topicSelector: Maybe<Scalars['BooleanType']['output']>;
  topicSelectorText: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Product Comparison (product_comparison) */
export type ProductComparisonRecord_SeoMetaTagsArgs = {
  locale: InputMaybe<SiteLocale>;
};

export type ProductHeaderItemModelLinkField = InsuranceProductFamilyRecord | InsuranceProductRecord | PageRecord;

/** Block of type [Header] Product Header Item (product_header_item) */
export type ProductHeaderItemRecord = RecordInterface & {
  __typename: 'ProductHeaderItemRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  label: Maybe<Scalars['String']['output']>;
  link: ProductHeaderItemModelLinkField;
  targetGroups: Array<TargetGroupHeaderItemRecord>;
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type [Header] Product Header Item (product_header_item) */
export type ProductHeaderItemRecord_SeoMetaTagsArgs = {
  locale: InputMaybe<SiteLocale>;
};

export type ProductModelDescriptionBlocksField = InlineLinkButtonRecord | InlineModalButtonRecord;

export type ProductModelDescriptionField = {
  __typename: 'ProductModelDescriptionField';
  blocks: Array<ProductModelDescriptionBlocksField>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

/** Block of type Product (product) */
export type ProductRecord = RecordInterface & {
  __typename: 'ProductRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  description: ProductModelDescriptionField;
  headerAlignment: Scalars['String']['output'];
  icon: Maybe<FileField>;
  id: Scalars['ItemId']['output'];
  linkedProduct: Maybe<InsuranceProductRecord>;
  priceDescription: Maybe<Scalars['String']['output']>;
  startingPrice: Maybe<Scalars['FloatType']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Product (product) */
export type ProductRecord_SeoMetaTagsArgs = {
  locale: InputMaybe<SiteLocale>;
};

/** Specifies how to filter by publication datetime */
export type PublishedAtFilter = {
  /** Filter records with a value that's within the specified minute range. Seconds and milliseconds are truncated from the argument. */
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records with a value that's strictly greater than the one specified. Seconds and milliseconds are truncated from the argument. */
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with a value that's greater than or equal to than the one specified. Seconds and milliseconds are truncated from the argument. */
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with a value that's less than the one specified. Seconds and milliseconds are truncated from the argument. */
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with a value that's less or equal than the one specified. Seconds and milliseconds are truncated from the argument. */
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with a value that's outside the specified minute range. Seconds and milliseconds are truncated from the argument. */
  neq?: InputMaybe<Scalars['DateTime']['input']>;
};

/** The query root for this schema */
export type Query = {
  __typename: 'Query';
  /** Returns meta information regarding a record collection */
  _allAuthorsMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allBlogpostsMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allBrandsMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allBreadcrumbsMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allContactsMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allCustomerReviewsMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allFaqsMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allHeadersMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allIconReferencesMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allInsuranceProductFamiliesMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allInsuranceProductVersionsMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allInsuranceProductsMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allPagesMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allSchemaMigrationsMeta: CollectionMetadata;
  /** Returns meta information regarding a record collection */
  _allTargetGroupsMeta: CollectionMetadata;
  /** Returns meta information regarding an assets collection */
  _allUploadsMeta: CollectionMetadata;
  /** Returns the single instance record */
  _site: Site;
  /** Returns a collection of records */
  allAuthors: Array<AuthorRecord>;
  /** Returns a collection of records */
  allBlogposts: Array<BlogpostRecord>;
  /** Returns a collection of records */
  allBrands: Array<BrandRecord>;
  /** Returns a collection of records */
  allBreadcrumbs: Array<BreadcrumbRecord>;
  /** Returns a collection of records */
  allContacts: Array<ContactRecord>;
  /** Returns a collection of records */
  allCustomerReviews: Array<CustomerReviewRecord>;
  /** Returns a collection of records */
  allFaqs: Array<FaqRecord>;
  /** Returns a collection of records */
  allHeaders: Array<HeaderRecord>;
  /** Returns a collection of records */
  allIconReferences: Array<IconReferenceRecord>;
  /** Returns a collection of records */
  allInsuranceProductFamilies: Array<InsuranceProductFamilyRecord>;
  /** Returns a collection of records */
  allInsuranceProductVersions: Array<InsuranceProductVersionRecord>;
  /** Returns a collection of records */
  allInsuranceProducts: Array<InsuranceProductRecord>;
  /** Returns a collection of records */
  allPages: Array<PageRecord>;
  /** Returns a collection of records */
  allSchemaMigrations: Array<SchemaMigrationRecord>;
  /** Returns a collection of records */
  allTargetGroups: Array<TargetGroupRecord>;
  /** Returns a collection of assets */
  allUploads: Array<FileField>;
  /** Returns a specific record */
  author: Maybe<AuthorRecord>;
  /** Returns a specific record */
  blogpost: Maybe<BlogpostRecord>;
  /** Returns a specific record */
  brand: Maybe<BrandRecord>;
  /** Returns a specific record */
  breadcrumb: Maybe<BreadcrumbRecord>;
  /** Returns a specific record */
  contact: Maybe<ContactRecord>;
  /** Returns a specific record */
  customerReview: Maybe<CustomerReviewRecord>;
  /** Returns a specific record */
  faq: Maybe<FaqRecord>;
  /** Returns the single instance record */
  globalSettingsPage: Maybe<GlobalSettingsPageRecord>;
  /** Returns a specific record */
  header: Maybe<HeaderRecord>;
  /** Returns a specific record */
  iconReference: Maybe<IconReferenceRecord>;
  /** Returns a specific record */
  insuranceProduct: Maybe<InsuranceProductRecord>;
  /** Returns a specific record */
  insuranceProductFamily: Maybe<InsuranceProductFamilyRecord>;
  /** Returns a specific record */
  insuranceProductVersion: Maybe<InsuranceProductVersionRecord>;
  /** Returns a specific record */
  page: Maybe<PageRecord>;
  /** Returns a specific record */
  schemaMigration: Maybe<SchemaMigrationRecord>;
  /** Returns a specific record */
  targetGroup: Maybe<TargetGroupRecord>;
  /** Returns the single instance record */
  translationsSetting: Maybe<TranslationsSettingRecord>;
  /** Returns a specific asset */
  upload: Maybe<FileField>;
};


/** The query root for this schema */
export type Query_AllAuthorsMetaArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  filter: InputMaybe<AuthorModelFilter>;
  locale: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllBlogpostsMetaArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  filter: InputMaybe<BlogpostModelFilter>;
  locale: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllBrandsMetaArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  filter: InputMaybe<BrandModelFilter>;
  locale: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllBreadcrumbsMetaArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  filter: InputMaybe<BreadcrumbModelFilter>;
  locale: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllContactsMetaArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  filter: InputMaybe<ContactModelFilter>;
  locale: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllCustomerReviewsMetaArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  filter: InputMaybe<CustomerReviewModelFilter>;
  locale: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllFaqsMetaArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  filter: InputMaybe<FaqModelFilter>;
  locale: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllHeadersMetaArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  filter: InputMaybe<HeaderModelFilter>;
  locale: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllIconReferencesMetaArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  filter: InputMaybe<IconReferenceModelFilter>;
  locale: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllInsuranceProductFamiliesMetaArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  filter: InputMaybe<InsuranceProductFamilyModelFilter>;
  locale: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllInsuranceProductVersionsMetaArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  filter: InputMaybe<InsuranceProductVersionModelFilter>;
  locale: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllInsuranceProductsMetaArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  filter: InputMaybe<InsuranceProductModelFilter>;
  locale: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllPagesMetaArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  filter: InputMaybe<PageModelFilter>;
  locale: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllSchemaMigrationsMetaArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  filter: InputMaybe<SchemaMigrationModelFilter>;
  locale: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllTargetGroupsMetaArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  filter: InputMaybe<TargetGroupModelFilter>;
  locale: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_AllUploadsMetaArgs = {
  filter: InputMaybe<UploadFilter>;
  locale: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type Query_SiteArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type QueryAllAuthorsArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  filter: InputMaybe<AuthorModelFilter>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  locale: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<AuthorModelOrderBy>>>;
  skip: InputMaybe<Scalars['IntType']['input']>;
};


/** The query root for this schema */
export type QueryAllBlogpostsArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  filter: InputMaybe<BlogpostModelFilter>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  locale: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<BlogpostModelOrderBy>>>;
  skip: InputMaybe<Scalars['IntType']['input']>;
};


/** The query root for this schema */
export type QueryAllBrandsArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  filter: InputMaybe<BrandModelFilter>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  locale: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<BrandModelOrderBy>>>;
  skip: InputMaybe<Scalars['IntType']['input']>;
};


/** The query root for this schema */
export type QueryAllBreadcrumbsArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  filter: InputMaybe<BreadcrumbModelFilter>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  locale: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<BreadcrumbModelOrderBy>>>;
  skip: InputMaybe<Scalars['IntType']['input']>;
};


/** The query root for this schema */
export type QueryAllContactsArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  filter: InputMaybe<ContactModelFilter>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  locale: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<ContactModelOrderBy>>>;
  skip: InputMaybe<Scalars['IntType']['input']>;
};


/** The query root for this schema */
export type QueryAllCustomerReviewsArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  filter: InputMaybe<CustomerReviewModelFilter>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  locale: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<CustomerReviewModelOrderBy>>>;
  skip: InputMaybe<Scalars['IntType']['input']>;
};


/** The query root for this schema */
export type QueryAllFaqsArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  filter: InputMaybe<FaqModelFilter>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  locale: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<FaqModelOrderBy>>>;
  skip: InputMaybe<Scalars['IntType']['input']>;
};


/** The query root for this schema */
export type QueryAllHeadersArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  filter: InputMaybe<HeaderModelFilter>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  locale: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<HeaderModelOrderBy>>>;
  skip: InputMaybe<Scalars['IntType']['input']>;
};


/** The query root for this schema */
export type QueryAllIconReferencesArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  filter: InputMaybe<IconReferenceModelFilter>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  locale: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<IconReferenceModelOrderBy>>>;
  skip: InputMaybe<Scalars['IntType']['input']>;
};


/** The query root for this schema */
export type QueryAllInsuranceProductFamiliesArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  filter: InputMaybe<InsuranceProductFamilyModelFilter>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  locale: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<InsuranceProductFamilyModelOrderBy>>>;
  skip: InputMaybe<Scalars['IntType']['input']>;
};


/** The query root for this schema */
export type QueryAllInsuranceProductVersionsArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  filter: InputMaybe<InsuranceProductVersionModelFilter>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  locale: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<InsuranceProductVersionModelOrderBy>>>;
  skip: InputMaybe<Scalars['IntType']['input']>;
};


/** The query root for this schema */
export type QueryAllInsuranceProductsArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  filter: InputMaybe<InsuranceProductModelFilter>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  locale: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<InsuranceProductModelOrderBy>>>;
  skip: InputMaybe<Scalars['IntType']['input']>;
};


/** The query root for this schema */
export type QueryAllPagesArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  filter: InputMaybe<PageModelFilter>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  locale: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<PageModelOrderBy>>>;
  skip: InputMaybe<Scalars['IntType']['input']>;
};


/** The query root for this schema */
export type QueryAllSchemaMigrationsArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  filter: InputMaybe<SchemaMigrationModelFilter>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  locale: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<SchemaMigrationModelOrderBy>>>;
  skip: InputMaybe<Scalars['IntType']['input']>;
};


/** The query root for this schema */
export type QueryAllTargetGroupsArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  filter: InputMaybe<TargetGroupModelFilter>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  locale: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<TargetGroupModelOrderBy>>>;
  skip: InputMaybe<Scalars['IntType']['input']>;
};


/** The query root for this schema */
export type QueryAllUploadsArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  filter: InputMaybe<UploadFilter>;
  first?: InputMaybe<Scalars['IntType']['input']>;
  locale: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<UploadOrderBy>>>;
  skip: InputMaybe<Scalars['IntType']['input']>;
};


/** The query root for this schema */
export type QueryAuthorArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  filter: InputMaybe<AuthorModelFilter>;
  locale: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<AuthorModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryBlogpostArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  filter: InputMaybe<BlogpostModelFilter>;
  locale: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<BlogpostModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryBrandArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  filter: InputMaybe<BrandModelFilter>;
  locale: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<BrandModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryBreadcrumbArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  filter: InputMaybe<BreadcrumbModelFilter>;
  locale: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<BreadcrumbModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryContactArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  filter: InputMaybe<ContactModelFilter>;
  locale: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<ContactModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryCustomerReviewArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  filter: InputMaybe<CustomerReviewModelFilter>;
  locale: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<CustomerReviewModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryFaqArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  filter: InputMaybe<FaqModelFilter>;
  locale: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<FaqModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryGlobalSettingsPageArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type QueryHeaderArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  filter: InputMaybe<HeaderModelFilter>;
  locale: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<HeaderModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryIconReferenceArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  filter: InputMaybe<IconReferenceModelFilter>;
  locale: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<IconReferenceModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryInsuranceProductArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  filter: InputMaybe<InsuranceProductModelFilter>;
  locale: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<InsuranceProductModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryInsuranceProductFamilyArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  filter: InputMaybe<InsuranceProductFamilyModelFilter>;
  locale: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<InsuranceProductFamilyModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryInsuranceProductVersionArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  filter: InputMaybe<InsuranceProductVersionModelFilter>;
  locale: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<InsuranceProductVersionModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryPageArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  filter: InputMaybe<PageModelFilter>;
  locale: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<PageModelOrderBy>>>;
};


/** The query root for this schema */
export type QuerySchemaMigrationArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  filter: InputMaybe<SchemaMigrationModelFilter>;
  locale: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<SchemaMigrationModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryTargetGroupArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  filter: InputMaybe<TargetGroupModelFilter>;
  locale: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<TargetGroupModelOrderBy>>>;
};


/** The query root for this schema */
export type QueryTranslationsSettingArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** The query root for this schema */
export type QueryUploadArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  filter: InputMaybe<UploadFilter>;
  locale: InputMaybe<SiteLocale>;
  orderBy?: InputMaybe<Array<InputMaybe<UploadOrderBy>>>;
};

/** Block of type Question and Answer (question_answer) */
export type QuestionAnswerRecord = RecordInterface & {
  __typename: 'QuestionAnswerRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  answer: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  number: Maybe<Scalars['String']['output']>;
  question: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Question and Answer (question_answer) */
export type QuestionAnswerRecord_SeoMetaTagsArgs = {
  locale: InputMaybe<SiteLocale>;
};


/** Block of type Question and Answer (question_answer) */
export type QuestionAnswerRecordAnswerArgs = {
  markdown: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuestionAnswerRecordListListNonNullMultiLocaleField = {
  __typename: 'QuestionAnswerRecordListListNonNullMultiLocaleField';
  locale: Maybe<SiteLocale>;
  value: Array<QuestionAnswerRecord>;
};

export type RecordInterface = {
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
};


export type RecordInterface_SeoMetaTagsArgs = {
  locale: InputMaybe<SiteLocale>;
};

/** Specifies how to filter by upload type */
export type ResolutionFilter = {
  /** Search uploads with the specified resolution */
  eq?: InputMaybe<ResolutionType>;
  /** Search uploads with the specified resolutions */
  in?: InputMaybe<Array<InputMaybe<ResolutionType>>>;
  /** Exclude uploads with the specified resolution */
  neq?: InputMaybe<ResolutionType>;
  /** Search uploads without the specified resolutions */
  notIn?: InputMaybe<Array<InputMaybe<ResolutionType>>>;
};

export enum ResolutionType {
  icon = 'icon',
  large = 'large',
  medium = 'medium',
  small = 'small'
}

export type ResponsiveImage = {
  __typename: 'ResponsiveImage';
  alt: Maybe<Scalars['String']['output']>;
  aspectRatio: Scalars['FloatType']['output'];
  base64: Maybe<Scalars['String']['output']>;
  bgColor: Maybe<Scalars['String']['output']>;
  height: Scalars['IntType']['output'];
  sizes: Scalars['String']['output'];
  src: Scalars['String']['output'];
  srcSet: Scalars['String']['output'];
  title: Maybe<Scalars['String']['output']>;
  webpSrcSet: Scalars['String']['output'];
  width: Scalars['IntType']['output'];
};

/** Block of type Responsive SVG (responsive_svg) */
export type ResponsiveSvgRecord = RecordInterface & {
  __typename: 'ResponsiveSvgRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  alternativeText: Scalars['String']['output'];
  baseAsset: FileField;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  steps: Array<ResponsiveSvgStepRecord>;
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Responsive SVG (responsive_svg) */
export type ResponsiveSvgRecord_SeoMetaTagsArgs = {
  locale: InputMaybe<SiteLocale>;
};


/** Block of type Responsive SVG (responsive_svg) */
export type ResponsiveSvgRecordAlternativeTextArgs = {
  markdown: InputMaybe<Scalars['Boolean']['input']>;
};

/** Block of type Responsive SVG Step (responsive_svg_step) */
export type ResponsiveSvgStepRecord = RecordInterface & {
  __typename: 'ResponsiveSvgStepRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  asset: FileField;
  breakpoint: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Responsive SVG Step (responsive_svg_step) */
export type ResponsiveSvgStepRecord_SeoMetaTagsArgs = {
  locale: InputMaybe<SiteLocale>;
};

export type SchemaMigrationModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<SchemaMigrationModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<SchemaMigrationModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  id?: InputMaybe<ItemIdFilter>;
  name?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum SchemaMigrationModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  name_ASC = 'name_ASC',
  name_DESC = 'name_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

/** Record of type Schema migration (schema_migration) */
export type SchemaMigrationRecord = RecordInterface & {
  __typename: 'SchemaMigrationRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


/** Record of type Schema migration (schema_migration) */
export type SchemaMigrationRecord_SeoMetaTagsArgs = {
  locale: InputMaybe<SiteLocale>;
};

export type SeoField = {
  __typename: 'SeoField';
  description: Maybe<Scalars['String']['output']>;
  image: Maybe<FileField>;
  noIndex: Maybe<Scalars['BooleanType']['output']>;
  title: Maybe<Scalars['String']['output']>;
  twitterCard: Maybe<Scalars['String']['output']>;
};

export type SeoFieldMultiLocaleField = {
  __typename: 'SeoFieldMultiLocaleField';
  locale: Maybe<SiteLocale>;
  value: Maybe<SeoField>;
};

/** Specifies how to filter SEO meta tags fields */
export type SeoFilter = {
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
};

/** Block of type Service Benefit (service_benefit) */
export type ServiceBenefitRecord = RecordInterface & {
  __typename: 'ServiceBenefitRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  benefits: Array<BenefitRecord>;
  createdAt: Scalars['DateTime']['output'];
  iconPosition: Scalars['String']['output'];
  id: Scalars['ItemId']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Service Benefit (service_benefit) */
export type ServiceBenefitRecord_SeoMetaTagsArgs = {
  locale: InputMaybe<SiteLocale>;
};

export type ServiceOverviewSectionItemModelDescriptionField = {
  __typename: 'ServiceOverviewSectionItemModelDescriptionField';
  blocks: Array<Scalars['String']['output']>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

/** Block of type [Service Overview Section] Item (service_overview_section_item) */
export type ServiceOverviewSectionItemRecord = RecordInterface & {
  __typename: 'ServiceOverviewSectionItemRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  description: ServiceOverviewSectionItemModelDescriptionField;
  id: Scalars['ItemId']['output'];
  service: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type [Service Overview Section] Item (service_overview_section_item) */
export type ServiceOverviewSectionItemRecord_SeoMetaTagsArgs = {
  locale: InputMaybe<SiteLocale>;
};

/** Block of type [Section] Service Overview (service_overview_section) */
export type ServiceOverviewSectionRecord = RecordInterface & {
  __typename: 'ServiceOverviewSectionRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  items: Array<ServiceOverviewSectionItemRecord>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type [Section] Service Overview (service_overview_section) */
export type ServiceOverviewSectionRecord_SeoMetaTagsArgs = {
  locale: InputMaybe<SiteLocale>;
};

export type Site = {
  __typename: 'Site';
  favicon: Maybe<FileField>;
  faviconMetaTags: Array<Tag>;
  globalSeo: Maybe<GlobalSeoField>;
  locales: Array<SiteLocale>;
  noIndex: Maybe<Scalars['BooleanType']['output']>;
};


export type SiteFaviconMetaTagsArgs = {
  variants?: InputMaybe<Array<InputMaybe<FaviconType>>>;
};


export type SiteGlobalSeoArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};

export enum SiteLocale {
  de = 'de',
  en = 'en'
}

/** Specifies how to filter Slug fields */
export type SlugFilter = {
  /** Search for records with an exact match */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Filter records that have one of the specified slugs */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Exclude records with an exact match */
  neq?: InputMaybe<Scalars['String']['input']>;
  /** Filter records that do have one of the specified slugs */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** Specifies how to filter by status */
export type StatusFilter = {
  /** Search the record with the specified status */
  eq?: InputMaybe<ItemStatus>;
  /** Search records with the specified statuses */
  in?: InputMaybe<Array<InputMaybe<ItemStatus>>>;
  /** Exclude the record with the specified status */
  neq?: InputMaybe<ItemStatus>;
  /** Search records without the specified statuses */
  notIn?: InputMaybe<Array<InputMaybe<ItemStatus>>>;
};

/** Specifies how to filter Single-line string fields */
export type StringFilter = {
  /** Search for records with an exact match */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Filter records with the specified field defined (i.e. with any value) or not [DEPRECATED] */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records that equal one of the specified values */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Filter records with the specified field set as blank (null or empty string) */
  isBlank?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records with the specified field present (neither null, nor empty string) */
  isPresent?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records based on a regular expression */
  matches?: InputMaybe<StringMatchesFilter>;
  /** Exclude records with an exact match */
  neq?: InputMaybe<Scalars['String']['input']>;
  /** Filter records that do not equal one of the specified values */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Exclude records based on a regular expression */
  notMatches?: InputMaybe<StringMatchesFilter>;
};

export type StringMatchesFilter = {
  caseSensitive?: InputMaybe<Scalars['BooleanType']['input']>;
  pattern: Scalars['String']['input'];
  regexp?: InputMaybe<Scalars['BooleanType']['input']>;
};

export type StringMultiLocaleField = {
  __typename: 'StringMultiLocaleField';
  locale: Maybe<SiteLocale>;
  value: Maybe<Scalars['String']['output']>;
};

export type StringNonNullMultiLocaleField = {
  __typename: 'StringNonNullMultiLocaleField';
  locale: Maybe<SiteLocale>;
  value: Scalars['String']['output'];
};

/** Specifies how to filter Structured Text fields values */
export type StructuredTextFilter = {
  /** Filter records with the specified field defined (i.e. with any value) or not [DEPRECATED] */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records with the specified field set as blank (null or single empty paragraph) */
  isBlank?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records with the specified field present (neither null, nor empty string) */
  isPresent?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records based on a regular expression */
  matches?: InputMaybe<StringMatchesFilter>;
  /** Exclude records based on a regular expression */
  notMatches?: InputMaybe<StringMatchesFilter>;
};

export type Tag = {
  __typename: 'Tag';
  attributes: Maybe<Scalars['MetaTagAttributes']['output']>;
  content: Maybe<Scalars['String']['output']>;
  tag: Scalars['String']['output'];
};

export type TargetGroupHeaderItemModelLinkField = InsuranceProductFamilyRecord | PageRecord | TargetGroupRecord;

/** Block of type [Header] Target Group Header Item (target_group_header_item) */
export type TargetGroupHeaderItemRecord = RecordInterface & {
  __typename: 'TargetGroupHeaderItemRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  label: Maybe<Scalars['String']['output']>;
  link: TargetGroupHeaderItemModelLinkField;
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type [Header] Target Group Header Item (target_group_header_item) */
export type TargetGroupHeaderItemRecord_SeoMetaTagsArgs = {
  locale: InputMaybe<SiteLocale>;
};

export type TargetGroupModelBottomContentField = AboutRecord | ContactSectionRecord | CtaSectionRecord | CustomerReviewsSectionRecord | FaqSectionRecord | HeroRecord | ImageTextSectionRecord | LogoWallSectionRecord | MissionRecord | MissionSliderRecord | NewsletterSectionRecord | NewsletterSignupRecord | OffersBlockRecord | PersonaRecord | ServiceBenefitRecord | TextSectionRecord | VideoCollectionRecord;

export type TargetGroupModelBottomContentFieldListListNonNullMultiLocaleField = {
  __typename: 'TargetGroupModelBottomContentFieldListListNonNullMultiLocaleField';
  locale: Maybe<SiteLocale>;
  value: Array<TargetGroupModelBottomContentField>;
};

/** Linking fields */
export enum TargetGroupModelFieldsReferencingBrandModel {
  targetGroup_brands = 'targetGroup_brands'
}

/** Linking fields */
export enum TargetGroupModelFieldsReferencingBreadcrumbModel {
  targetGroup_bottomContent = 'targetGroup_bottomContent',
  targetGroup_bottomContent__about_text__inlineLinkButton_internal = 'targetGroup_bottomContent__about_text__inlineLinkButton_internal',
  targetGroup_bottomContent__ctaSection_linkButtons__inlineLinkButton_internal = 'targetGroup_bottomContent__ctaSection_linkButtons__inlineLinkButton_internal',
  targetGroup_bottomContent__hero_cta__inlineLinkButton_internal = 'targetGroup_bottomContent__hero_cta__inlineLinkButton_internal',
  targetGroup_bottomContent__hero_text__inlineLinkButton_internal = 'targetGroup_bottomContent__hero_text__inlineLinkButton_internal',
  targetGroup_bottomContent__imageTextSection_text__inlineLinkButton_internal = 'targetGroup_bottomContent__imageTextSection_text__inlineLinkButton_internal',
  targetGroup_bottomContent__offersBlock_text__offerSingle_link__inlineLinkButton_internal = 'targetGroup_bottomContent__offersBlock_text__offerSingle_link__inlineLinkButton_internal',
  targetGroup_bottomContent__textSection_text__inlineLinkButton_internal = 'targetGroup_bottomContent__textSection_text__inlineLinkButton_internal',
  targetGroup_bottomContent__videoCollection_intro__inlineLinkButton_internal = 'targetGroup_bottomContent__videoCollection_intro__inlineLinkButton_internal',
  targetGroup_breadcrumbs = 'targetGroup_breadcrumbs',
  targetGroup_topContent = 'targetGroup_topContent',
  targetGroup_topContent__about_text__inlineLinkButton_internal = 'targetGroup_topContent__about_text__inlineLinkButton_internal',
  targetGroup_topContent__ctaSection_linkButtons__inlineLinkButton_internal = 'targetGroup_topContent__ctaSection_linkButtons__inlineLinkButton_internal',
  targetGroup_topContent__hero_cta__inlineLinkButton_internal = 'targetGroup_topContent__hero_cta__inlineLinkButton_internal',
  targetGroup_topContent__hero_text__inlineLinkButton_internal = 'targetGroup_topContent__hero_text__inlineLinkButton_internal',
  targetGroup_topContent__imageTextSection_text__inlineLinkButton_internal = 'targetGroup_topContent__imageTextSection_text__inlineLinkButton_internal',
  targetGroup_topContent__offersBlock_text__offerSingle_link__inlineLinkButton_internal = 'targetGroup_topContent__offersBlock_text__offerSingle_link__inlineLinkButton_internal',
  targetGroup_topContent__textSection_text__inlineLinkButton_internal = 'targetGroup_topContent__textSection_text__inlineLinkButton_internal',
  targetGroup_topContent__videoCollection_intro__inlineLinkButton_internal = 'targetGroup_topContent__videoCollection_intro__inlineLinkButton_internal'
}

export type TargetGroupModelFilter = {
  AND?: InputMaybe<Array<InputMaybe<TargetGroupModelFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<TargetGroupModelFilter>>>;
  _createdAt?: InputMaybe<CreatedAtFilter>;
  _firstPublishedAt?: InputMaybe<PublishedAtFilter>;
  _isValid?: InputMaybe<BooleanFilter>;
  _locales?: InputMaybe<LocalesFilter>;
  _publicationScheduledAt?: InputMaybe<PublishedAtFilter>;
  _publishedAt?: InputMaybe<PublishedAtFilter>;
  _status?: InputMaybe<StatusFilter>;
  _unpublishingScheduledAt?: InputMaybe<PublishedAtFilter>;
  _updatedAt?: InputMaybe<UpdatedAtFilter>;
  brands?: InputMaybe<LinksFilter>;
  breadcrumbs?: InputMaybe<LinksFilter>;
  callbackFormSlug?: InputMaybe<StringFilter>;
  contact?: InputMaybe<LinkFilter>;
  createdAt?: InputMaybe<CreatedAtFilter>;
  demoFormSlug?: InputMaybe<StringFilter>;
  footerLogo?: InputMaybe<FileFilter>;
  header?: InputMaybe<LinkFilter>;
  id?: InputMaybe<ItemIdFilter>;
  messageFormSlug?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  sendinblueFormUrl?: InputMaybe<StringFilter>;
  seo?: InputMaybe<SeoFilter>;
  showContactForm?: InputMaybe<BooleanFilter>;
  slug?: InputMaybe<SlugFilter>;
  tagline?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<UpdatedAtFilter>;
};

export enum TargetGroupModelOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _firstPublishedAt_ASC = '_firstPublishedAt_ASC',
  _firstPublishedAt_DESC = '_firstPublishedAt_DESC',
  _isValid_ASC = '_isValid_ASC',
  _isValid_DESC = '_isValid_DESC',
  _publicationScheduledAt_ASC = '_publicationScheduledAt_ASC',
  _publicationScheduledAt_DESC = '_publicationScheduledAt_DESC',
  _publishedAt_ASC = '_publishedAt_ASC',
  _publishedAt_DESC = '_publishedAt_DESC',
  _status_ASC = '_status_ASC',
  _status_DESC = '_status_DESC',
  _unpublishingScheduledAt_ASC = '_unpublishingScheduledAt_ASC',
  _unpublishingScheduledAt_DESC = '_unpublishingScheduledAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  callbackFormSlug_ASC = 'callbackFormSlug_ASC',
  callbackFormSlug_DESC = 'callbackFormSlug_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  demoFormSlug_ASC = 'demoFormSlug_ASC',
  demoFormSlug_DESC = 'demoFormSlug_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  messageFormSlug_ASC = 'messageFormSlug_ASC',
  messageFormSlug_DESC = 'messageFormSlug_DESC',
  name_ASC = 'name_ASC',
  name_DESC = 'name_DESC',
  sendinblueFormUrl_ASC = 'sendinblueFormUrl_ASC',
  sendinblueFormUrl_DESC = 'sendinblueFormUrl_DESC',
  showContactForm_ASC = 'showContactForm_ASC',
  showContactForm_DESC = 'showContactForm_DESC',
  tagline_ASC = 'tagline_ASC',
  tagline_DESC = 'tagline_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type TargetGroupModelTopContentField = AboutRecord | ContactSectionRecord | CtaSectionRecord | CustomerReviewsSectionRecord | FaqSectionRecord | HeroRecord | ImageTextSectionRecord | LogoWallSectionRecord | MissionRecord | MissionSliderRecord | NewsletterSectionRecord | NewsletterSignupRecord | OffersBlockRecord | PersonaRecord | ServiceBenefitRecord | TextSectionRecord | VideoCollectionRecord;

export type TargetGroupModelTopContentFieldListListNonNullMultiLocaleField = {
  __typename: 'TargetGroupModelTopContentFieldListListNonNullMultiLocaleField';
  locale: Maybe<SiteLocale>;
  value: Array<TargetGroupModelTopContentField>;
};

/** Record of type Target Group (target_group) */
export type TargetGroupRecord = RecordInterface & {
  __typename: 'TargetGroupRecord';
  _allBottomContentLocales: Maybe<Array<TargetGroupModelBottomContentFieldListListNonNullMultiLocaleField>>;
  _allBreadcrumbsLocales: Maybe<Array<BreadcrumbRecordListListNonNullMultiLocaleField>>;
  _allContactLocales: Maybe<Array<ContactRecordNonNullMultiLocaleField>>;
  _allNameLocales: Maybe<Array<StringNonNullMultiLocaleField>>;
  _allSeoLocales: Maybe<Array<SeoFieldMultiLocaleField>>;
  _allSlugLocales: Maybe<Array<StringNonNullMultiLocaleField>>;
  _allTaglineLocales: Maybe<Array<StringMultiLocaleField>>;
  _allTopContentLocales: Maybe<Array<TargetGroupModelTopContentFieldListListNonNullMultiLocaleField>>;
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _locales: Array<SiteLocale>;
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  bottomContent: Array<TargetGroupModelBottomContentField>;
  brands: Array<BrandRecord>;
  breadcrumbs: Array<BreadcrumbRecord>;
  callbackFormSlug: Maybe<Scalars['String']['output']>;
  contact: ContactRecord;
  createdAt: Scalars['DateTime']['output'];
  demoFormSlug: Maybe<Scalars['String']['output']>;
  footerLogo: Maybe<FileField>;
  header: Maybe<HeaderRecord>;
  id: Scalars['ItemId']['output'];
  messageFormSlug: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  sendinblueFormUrl: Maybe<Scalars['String']['output']>;
  seo: Maybe<SeoField>;
  showContactForm: Maybe<Scalars['BooleanType']['output']>;
  slug: Scalars['String']['output'];
  tagline: Maybe<Scalars['String']['output']>;
  topContent: Array<TargetGroupModelTopContentField>;
  updatedAt: Scalars['DateTime']['output'];
};


/** Record of type Target Group (target_group) */
export type TargetGroupRecord_AllBottomContentLocalesArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Target Group (target_group) */
export type TargetGroupRecord_AllBreadcrumbsLocalesArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Target Group (target_group) */
export type TargetGroupRecord_AllContactLocalesArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Target Group (target_group) */
export type TargetGroupRecord_AllNameLocalesArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Target Group (target_group) */
export type TargetGroupRecord_AllSeoLocalesArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Target Group (target_group) */
export type TargetGroupRecord_AllSlugLocalesArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Target Group (target_group) */
export type TargetGroupRecord_AllTaglineLocalesArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Target Group (target_group) */
export type TargetGroupRecord_AllTopContentLocalesArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Target Group (target_group) */
export type TargetGroupRecord_SeoMetaTagsArgs = {
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Target Group (target_group) */
export type TargetGroupRecordBottomContentArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Target Group (target_group) */
export type TargetGroupRecordBreadcrumbsArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Target Group (target_group) */
export type TargetGroupRecordContactArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Target Group (target_group) */
export type TargetGroupRecordNameArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Target Group (target_group) */
export type TargetGroupRecordSeoArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Target Group (target_group) */
export type TargetGroupRecordSlugArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Target Group (target_group) */
export type TargetGroupRecordTaglineArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Target Group (target_group) */
export type TargetGroupRecordTopContentArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};

/** Specifies how to filter text fields */
export type TextFilter = {
  /** Filter records with the specified field defined (i.e. with any value) or not [DEPRECATED] */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records with the specified field set as blank (null or empty string) */
  isBlank?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records with the specified field present (neither null, nor empty string) */
  isPresent?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records based on a regular expression */
  matches?: InputMaybe<StringMatchesFilter>;
  /** Exclude records based on a regular expression */
  notMatches?: InputMaybe<StringMatchesFilter>;
};

export type TextSectionModelTextBlocksField = InlineAssetGalleryRecord | InlineAssetRecord | InlineLinkButtonRecord | InlineModalButtonRecord | ResponsiveSvgRecord | TextSectionTableRecord;

export type TextSectionModelTextField = {
  __typename: 'TextSectionModelTextField';
  blocks: Array<TextSectionModelTextBlocksField>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

/** Block of type Text Section (text_section) */
export type TextSectionRecord = RecordInterface & {
  __typename: 'TextSectionRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  backgroundColor: ColorField;
  createdAt: Scalars['DateTime']['output'];
  fontColor: ColorField;
  id: Scalars['ItemId']['output'];
  showArrow: Maybe<Scalars['BooleanType']['output']>;
  style: Scalars['String']['output'];
  text: TextSectionModelTextField;
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Text Section (text_section) */
export type TextSectionRecord_SeoMetaTagsArgs = {
  locale: InputMaybe<SiteLocale>;
};

/** Block of type [Text Section] Table Column (text_section_table_column) */
export type TextSectionTableColumnRecord = RecordInterface & {
  __typename: 'TextSectionTableColumnRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  heading: Scalars['String']['output'];
  icon: Maybe<FileField>;
  id: Scalars['ItemId']['output'];
  items: Array<TextSectionTableItemRecord>;
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type [Text Section] Table Column (text_section_table_column) */
export type TextSectionTableColumnRecord_SeoMetaTagsArgs = {
  locale: InputMaybe<SiteLocale>;
};

/** Block of type [Text Section] Table Item (text_section_table_item) */
export type TextSectionTableItemRecord = RecordInterface & {
  __typename: 'TextSectionTableItemRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  icon: IconReferenceRecord;
  id: Scalars['ItemId']['output'];
  text: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type [Text Section] Table Item (text_section_table_item) */
export type TextSectionTableItemRecord_SeoMetaTagsArgs = {
  locale: InputMaybe<SiteLocale>;
};


/** Block of type [Text Section] Table Item (text_section_table_item) */
export type TextSectionTableItemRecordTextArgs = {
  markdown: InputMaybe<Scalars['Boolean']['input']>;
};

/** Block of type [Text Section] Table (text_section_table) */
export type TextSectionTableRecord = RecordInterface & {
  __typename: 'TextSectionTableRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  columns: Array<TextSectionTableColumnRecord>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type [Text Section] Table (text_section_table) */
export type TextSectionTableRecord_SeoMetaTagsArgs = {
  locale: InputMaybe<SiteLocale>;
};

/** Block of type Translation String (translation_string) */
export type TranslationStringRecord = RecordInterface & {
  __typename: 'TranslationStringRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  slug: Scalars['String']['output'];
  translation: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Translation String (translation_string) */
export type TranslationStringRecord_SeoMetaTagsArgs = {
  locale: InputMaybe<SiteLocale>;
};

/** Record of type Translations (translations_setting) */
export type TranslationsSettingRecord = RecordInterface & {
  __typename: 'TranslationsSettingRecord';
  _allUiTranslationsLocales: Maybe<Array<JsonFieldMultiLocaleField>>;
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  uiTranslations: Maybe<Scalars['JsonField']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};


/** Record of type Translations (translations_setting) */
export type TranslationsSettingRecord_AllUiTranslationsLocalesArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Translations (translations_setting) */
export type TranslationsSettingRecord_SeoMetaTagsArgs = {
  locale: InputMaybe<SiteLocale>;
};


/** Record of type Translations (translations_setting) */
export type TranslationsSettingRecordUiTranslationsArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};

/** Specifies how to filter by upload type */
export type TypeFilter = {
  /** Search uploads with the specified type */
  eq?: InputMaybe<UploadType>;
  /** Search uploads with the specified types */
  in?: InputMaybe<Array<InputMaybe<UploadType>>>;
  /** Exclude uploads with the specified type */
  neq?: InputMaybe<UploadType>;
  /** Search uploads without the specified types */
  notIn?: InputMaybe<Array<InputMaybe<UploadType>>>;
};

/** Specifies how to filter by update datetime */
export type UpdatedAtFilter = {
  /** Filter records with a value that's within the specified minute range. Seconds and milliseconds are truncated from the argument. */
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter records with a value that's strictly greater than the one specified. Seconds and milliseconds are truncated from the argument. */
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with a value that's greater than or equal to than the one specified. Seconds and milliseconds are truncated from the argument. */
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with a value that's less than the one specified. Seconds and milliseconds are truncated from the argument. */
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with a value that's less or equal than the one specified. Seconds and milliseconds are truncated from the argument. */
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter records with a value that's outside the specified minute range. Seconds and milliseconds are truncated from the argument. */
  neq?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Specifies how to filter by default alt */
export type UploadAltFilter = {
  /** Search the uploads with the specified alt */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Filter uploads with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Search uploads with the specified values as default alt */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Filter uploads based on a regular expression */
  matches?: InputMaybe<StringMatchesFilter>;
  /** Exclude the uploads with the specified alt */
  neq?: InputMaybe<Scalars['String']['input']>;
  /** Search uploads that do not have the specified values as default alt */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Exclude uploads based on a regular expression */
  notMatches?: InputMaybe<StringMatchesFilter>;
};

/** Specifies how to filter by auhtor */
export type UploadAuthorFilter = {
  /** Filter uploads with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter uploads based on a regular expression */
  matches?: InputMaybe<StringMatchesFilter>;
  /** Exclude uploads based on a regular expression */
  notMatches?: InputMaybe<StringMatchesFilter>;
};

/** Specifies how to filter by basename */
export type UploadBasenameFilter = {
  /** Filter uploads based on a regular expression */
  matches?: InputMaybe<StringMatchesFilter>;
  /** Exclude uploads based on a regular expression */
  notMatches?: InputMaybe<StringMatchesFilter>;
};

/** Specifies how to filter by colors */
export type UploadColorsFilter = {
  /** Filter uploads that have all of the specified colors */
  allIn?: InputMaybe<Array<InputMaybe<ColorBucketType>>>;
  /** Filter uploads that have at least one of the specified colors */
  anyIn?: InputMaybe<Array<InputMaybe<ColorBucketType>>>;
  /** Filter uploads that have the specified colors */
  contains?: InputMaybe<ColorBucketType>;
  /** Search for uploads with an exact match */
  eq?: InputMaybe<Array<InputMaybe<ColorBucketType>>>;
  /** Filter uploads that do not have any of the specified colors */
  notIn?: InputMaybe<Array<InputMaybe<ColorBucketType>>>;
};

/** Specifies how to filter by copyright */
export type UploadCopyrightFilter = {
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter uploads based on a regular expression */
  matches?: InputMaybe<StringMatchesFilter>;
  /** Exclude uploads based on a regular expression */
  notMatches?: InputMaybe<StringMatchesFilter>;
};

/** Specifies how to filter by creation datetime */
export type UploadCreatedAtFilter = {
  /** Search for uploads with an exact match */
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter uploads with a value that's strictly greater than the one specified */
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter uploads with a value that's greater than or equal to the one specified */
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter uploads with a value that's less than the one specified */
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter uploads with a value that's less or equal than the one specified */
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Exclude uploads with an exact match */
  neq?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Specifies how to filter by filename */
export type UploadFilenameFilter = {
  /** Filter uploads based on a regular expression */
  matches?: InputMaybe<StringMatchesFilter>;
  /** Exclude uploads based on a regular expression */
  notMatches?: InputMaybe<StringMatchesFilter>;
};

export type UploadFilter = {
  AND?: InputMaybe<Array<InputMaybe<UploadFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<UploadFilter>>>;
  _createdAt?: InputMaybe<UploadCreatedAtFilter>;
  _updatedAt?: InputMaybe<UploadUpdatedAtFilter>;
  alt?: InputMaybe<UploadAltFilter>;
  author?: InputMaybe<UploadAuthorFilter>;
  basename?: InputMaybe<UploadBasenameFilter>;
  colors?: InputMaybe<UploadColorsFilter>;
  copyright?: InputMaybe<UploadCopyrightFilter>;
  filename?: InputMaybe<UploadFilenameFilter>;
  format?: InputMaybe<UploadFormatFilter>;
  height?: InputMaybe<UploadHeightFilter>;
  id?: InputMaybe<UploadIdFilter>;
  inUse?: InputMaybe<InUseFilter>;
  md5?: InputMaybe<UploadMd5Filter>;
  mimeType?: InputMaybe<UploadMimeTypeFilter>;
  notes?: InputMaybe<UploadNotesFilter>;
  orientation?: InputMaybe<OrientationFilter>;
  resolution?: InputMaybe<ResolutionFilter>;
  size?: InputMaybe<UploadSizeFilter>;
  smartTags?: InputMaybe<UploadTagsFilter>;
  tags?: InputMaybe<UploadTagsFilter>;
  title?: InputMaybe<UploadTitleFilter>;
  type?: InputMaybe<TypeFilter>;
  width?: InputMaybe<UploadWidthFilter>;
};

/** Specifies how to filter by format */
export type UploadFormatFilter = {
  /** Search the asset with the specified format */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Search assets with the specified formats */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Exclude the asset with the specified format */
  neq?: InputMaybe<Scalars['String']['input']>;
  /** Search assets that do not have the specified formats */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** Specifies how to filter by height */
export type UploadHeightFilter = {
  /** Search assets with the specified height */
  eq?: InputMaybe<Scalars['IntType']['input']>;
  /** Search all assets larger than the specified height */
  gt?: InputMaybe<Scalars['IntType']['input']>;
  /** Search all assets larger or equal to the specified height */
  gte?: InputMaybe<Scalars['IntType']['input']>;
  /** Search all assets smaller than the specified height */
  lt?: InputMaybe<Scalars['IntType']['input']>;
  /** Search all assets larger or equal to the specified height */
  lte?: InputMaybe<Scalars['IntType']['input']>;
  /** Search assets that do not have the specified height */
  neq?: InputMaybe<Scalars['IntType']['input']>;
};

/** Specifies how to filter by ID */
export type UploadIdFilter = {
  /** Search the asset with the specified ID */
  eq?: InputMaybe<Scalars['UploadId']['input']>;
  /** Search assets with the specified IDs */
  in?: InputMaybe<Array<InputMaybe<Scalars['UploadId']['input']>>>;
  /** Exclude the asset with the specified ID */
  neq?: InputMaybe<Scalars['UploadId']['input']>;
  /** Search assets that do not have the specified IDs */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['UploadId']['input']>>>;
};

/** Specifies how to filter by MD5 */
export type UploadMd5Filter = {
  /** Search the asset with the specified MD5 */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Search assets with the specified MD5s */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Exclude the asset with the specified MD5 */
  neq?: InputMaybe<Scalars['String']['input']>;
  /** Search assets that do not have the specified MD5s */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** Specifies how to filter by mime type */
export type UploadMimeTypeFilter = {
  /** Search the asset with the specified mime type */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Search assets with the specified mime types */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Filter uploads based on a regular expression */
  matches?: InputMaybe<StringMatchesFilter>;
  /** Exclude the asset with the specified mime type */
  neq?: InputMaybe<Scalars['String']['input']>;
  /** Search assets that do not have the specified mime types */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Exclude uploads based on a regular expression */
  notMatches?: InputMaybe<StringMatchesFilter>;
};

/** Specifies how to filter by notes */
export type UploadNotesFilter = {
  /** Filter records with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Filter uploads based on a regular expression */
  matches?: InputMaybe<StringMatchesFilter>;
  /** Exclude uploads based on a regular expression */
  notMatches?: InputMaybe<StringMatchesFilter>;
};

export enum UploadOrderBy {
  _createdAt_ASC = '_createdAt_ASC',
  _createdAt_DESC = '_createdAt_DESC',
  _updatedAt_ASC = '_updatedAt_ASC',
  _updatedAt_DESC = '_updatedAt_DESC',
  basename_ASC = 'basename_ASC',
  basename_DESC = 'basename_DESC',
  filename_ASC = 'filename_ASC',
  filename_DESC = 'filename_DESC',
  format_ASC = 'format_ASC',
  format_DESC = 'format_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  mimeType_ASC = 'mimeType_ASC',
  mimeType_DESC = 'mimeType_DESC',
  resolution_ASC = 'resolution_ASC',
  resolution_DESC = 'resolution_DESC',
  size_ASC = 'size_ASC',
  size_DESC = 'size_DESC'
}

export enum UploadOrientation {
  landscape = 'landscape',
  portrait = 'portrait',
  square = 'square'
}

/** Specifies how to filter by size */
export type UploadSizeFilter = {
  /** Search assets with the specified size (in bytes) */
  eq?: InputMaybe<Scalars['IntType']['input']>;
  /** Search all assets larger than the specified size (in bytes) */
  gt?: InputMaybe<Scalars['IntType']['input']>;
  /** Search all assets larger or equal to the specified size (in bytes) */
  gte?: InputMaybe<Scalars['IntType']['input']>;
  /** Search all assets smaller than the specified size (in bytes) */
  lt?: InputMaybe<Scalars['IntType']['input']>;
  /** Search all assets larger or equal to the specified size (in bytes) */
  lte?: InputMaybe<Scalars['IntType']['input']>;
  /** Search assets that do not have the specified size (in bytes) */
  neq?: InputMaybe<Scalars['IntType']['input']>;
};

/** Specifies how to filter by tags */
export type UploadTagsFilter = {
  /** Filter uploads linked to all of the specified tags */
  allIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter uploads linked to at least one of the specified tags */
  anyIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter uploads linked to the specified tag */
  contains?: InputMaybe<Scalars['String']['input']>;
  /** Search for uploads with an exact match */
  eq?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter uploads not linked to any of the specified tags */
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Specifies how to filter by default title */
export type UploadTitleFilter = {
  /** Search the asset with the specified title */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Filter assets with the specified field defined (i.e. with any value) or not */
  exists?: InputMaybe<Scalars['BooleanType']['input']>;
  /** Search assets with the specified as default title */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Filter uploads based on a regular expression */
  matches?: InputMaybe<StringMatchesFilter>;
  /** Exclude the asset with the specified title */
  neq?: InputMaybe<Scalars['String']['input']>;
  /** Search assets that do not have the specified as default title */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Exclude uploads based on a regular expression */
  notMatches?: InputMaybe<StringMatchesFilter>;
};

export enum UploadType {
  archive = 'archive',
  audio = 'audio',
  image = 'image',
  pdfdocument = 'pdfdocument',
  presentation = 'presentation',
  richtext = 'richtext',
  spreadsheet = 'spreadsheet',
  video = 'video'
}

/** Specifies how to filter by update datetime */
export type UploadUpdatedAtFilter = {
  /** Search for uploads with an exact match */
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter uploads with a value that's strictly greater than the one specified */
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter uploads with a value that's greater than or equal to the one specified */
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter uploads with a value that's less than the one specified */
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter uploads with a value that's less or equal than the one specified */
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Exclude uploads with an exact match */
  neq?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UploadVideoField = {
  __typename: 'UploadVideoField';
  alt: Maybe<Scalars['String']['output']>;
  blurUpThumb: Maybe<Scalars['String']['output']>;
  blurhash: Maybe<Scalars['String']['output']>;
  duration: Maybe<Scalars['Int']['output']>;
  framerate: Maybe<Scalars['Int']['output']>;
  height: Scalars['IntType']['output'];
  mp4Url: Maybe<Scalars['String']['output']>;
  muxAssetId: Scalars['String']['output'];
  muxPlaybackId: Scalars['String']['output'];
  streamingUrl: Scalars['String']['output'];
  thumbhash: Maybe<Scalars['String']['output']>;
  thumbnailUrl: Scalars['String']['output'];
  title: Maybe<Scalars['String']['output']>;
  width: Scalars['IntType']['output'];
};


export type UploadVideoFieldAltArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


export type UploadVideoFieldBlurUpThumbArgs = {
  imgixParams: InputMaybe<ImgixParams>;
  punch?: Scalars['Float']['input'];
  quality?: Scalars['Int']['input'];
  size?: Scalars['Int']['input'];
};


export type UploadVideoFieldMp4UrlArgs = {
  exactRes: InputMaybe<VideoMp4Res>;
  res: InputMaybe<VideoMp4Res>;
};


export type UploadVideoFieldThumbnailUrlArgs = {
  format?: InputMaybe<MuxThumbnailFormatType>;
};


export type UploadVideoFieldTitleArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};

/** Specifies how to filter by width */
export type UploadWidthFilter = {
  /** Search assets with the specified width */
  eq?: InputMaybe<Scalars['IntType']['input']>;
  /** Search all assets larger than the specified width */
  gt?: InputMaybe<Scalars['IntType']['input']>;
  /** Search all assets larger or equal to the specified width */
  gte?: InputMaybe<Scalars['IntType']['input']>;
  /** Search all assets smaller than the specified width */
  lt?: InputMaybe<Scalars['IntType']['input']>;
  /** Search all assets larger or equal to the specified width */
  lte?: InputMaybe<Scalars['IntType']['input']>;
  /** Search assets that do not have the specified width */
  neq?: InputMaybe<Scalars['IntType']['input']>;
};

/** Block of type [User Action Section] Item (user_action_section_item) */
export type UserActionSectionItemRecord = RecordInterface & {
  __typename: 'UserActionSectionItemRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  icon: IconReferenceRecord;
  id: Scalars['ItemId']['output'];
  text: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type [User Action Section] Item (user_action_section_item) */
export type UserActionSectionItemRecord_SeoMetaTagsArgs = {
  locale: InputMaybe<SiteLocale>;
};


/** Block of type [User Action Section] Item (user_action_section_item) */
export type UserActionSectionItemRecordTextArgs = {
  markdown: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserActionSectionModelUserActionsField = InlineLinkButtonRecord | InlineModalButtonRecord | UserActionSectionItemRecord;

/** Block of type User Action Section (user_action_section) */
export type UserActionSectionRecord = RecordInterface & {
  __typename: 'UserActionSectionRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  headline: Maybe<Scalars['String']['output']>;
  id: Scalars['ItemId']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userActions: Array<UserActionSectionModelUserActionsField>;
};


/** Block of type User Action Section (user_action_section) */
export type UserActionSectionRecord_SeoMetaTagsArgs = {
  locale: InputMaybe<SiteLocale>;
};

/** Block of type Video Collection Column (video_collection_column) */
export type VideoCollectionColumnRecord = RecordInterface & {
  __typename: 'VideoCollectionColumnRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  items: Array<VideoCollectionItemRecord>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Video Collection Column (video_collection_column) */
export type VideoCollectionColumnRecord_SeoMetaTagsArgs = {
  locale: InputMaybe<SiteLocale>;
};

/** Block of type Video Collection Item (video_collection_item) */
export type VideoCollectionItemRecord = RecordInterface & {
  __typename: 'VideoCollectionItemRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  subline: Maybe<Scalars['String']['output']>;
  thumbnail: Maybe<FileField>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  video: VideoFileField;
};


/** Block of type Video Collection Item (video_collection_item) */
export type VideoCollectionItemRecord_SeoMetaTagsArgs = {
  locale: InputMaybe<SiteLocale>;
};


/** Block of type Video Collection Item (video_collection_item) */
export type VideoCollectionItemRecordSublineArgs = {
  markdown: InputMaybe<Scalars['Boolean']['input']>;
};

export type VideoCollectionModelIntroBlocksField = InlineAssetRecord | InlineLinkButtonRecord | InlineModalButtonRecord;

export type VideoCollectionModelIntroField = {
  __typename: 'VideoCollectionModelIntroField';
  blocks: Array<VideoCollectionModelIntroBlocksField>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

/** Block of type Video Collection (video_collection) */
export type VideoCollectionRecord = RecordInterface & {
  __typename: 'VideoCollectionRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  columns: Array<VideoCollectionColumnRecord>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ItemId']['output'];
  intro: Maybe<VideoCollectionModelIntroField>;
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type Video Collection (video_collection) */
export type VideoCollectionRecord_SeoMetaTagsArgs = {
  locale: InputMaybe<SiteLocale>;
};

export type VideoFileField = FileFieldInterface & {
  __typename: 'VideoFileField';
  _createdAt: Scalars['DateTime']['output'];
  /** The DatoCMS URL where you can edit this entity. To use this field, you need to set a X-Base-Editing-Url header in the request */
  _editingUrl: Maybe<Scalars['String']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  alt: Maybe<Scalars['String']['output']>;
  author: Maybe<Scalars['String']['output']>;
  basename: Scalars['String']['output'];
  blurUpThumb: Maybe<Scalars['String']['output']>;
  blurhash: Maybe<Scalars['String']['output']>;
  colors: Array<ColorField>;
  copyright: Maybe<Scalars['String']['output']>;
  customData: Scalars['CustomData']['output'];
  exifInfo: Scalars['CustomData']['output'];
  filename: Scalars['String']['output'];
  focalPoint: Maybe<FocalPoint>;
  format: Scalars['String']['output'];
  height: Scalars['IntType']['output'];
  id: Scalars['UploadId']['output'];
  md5: Scalars['String']['output'];
  mimeType: Scalars['String']['output'];
  notes: Maybe<Scalars['String']['output']>;
  responsiveImage: Maybe<ResponsiveImage>;
  size: Scalars['IntType']['output'];
  smartTags: Array<Scalars['String']['output']>;
  tags: Array<Scalars['String']['output']>;
  thumbhash: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
  video: UploadVideoField;
  width: Scalars['IntType']['output'];
};


export type VideoFileFieldAltArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


export type VideoFileFieldBlurUpThumbArgs = {
  imgixParams: InputMaybe<ImgixParams>;
  punch?: Scalars['Float']['input'];
  quality?: Scalars['Int']['input'];
  size?: Scalars['Int']['input'];
};


export type VideoFileFieldCustomDataArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


export type VideoFileFieldFocalPointArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


export type VideoFileFieldResponsiveImageArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  imgixParams: InputMaybe<ImgixParams>;
  locale: InputMaybe<SiteLocale>;
  sizes: InputMaybe<Scalars['String']['input']>;
};


export type VideoFileFieldTitleArgs = {
  fallbackLocales: InputMaybe<Array<SiteLocale>>;
  locale: InputMaybe<SiteLocale>;
};


export type VideoFileFieldUrlArgs = {
  imgixParams: InputMaybe<ImgixParams>;
};

export enum VideoMp4Res {
  high = 'high',
  low = 'low',
  medium = 'medium'
}

export type VideoSectionModelButtonField = InlineLinkButtonRecord | InlineModalButtonRecord;

export type VideoSectionModelTextBlocksField = InlineLinkButtonRecord | InlineModalButtonRecord;

export type VideoSectionModelTextField = {
  __typename: 'VideoSectionModelTextField';
  blocks: Array<VideoSectionModelTextBlocksField>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

export type VideoSectionModelTopicSublineBlocksField = InlineLinkButtonRecord | InlineModalButtonRecord;

export type VideoSectionModelTopicSublineField = {
  __typename: 'VideoSectionModelTopicSublineField';
  blocks: Array<VideoSectionModelTopicSublineBlocksField>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

export type VideoSectionPersonaModelTextBlocksField = InlineLinkButtonRecord | InlineModalButtonRecord;

export type VideoSectionPersonaModelTextField = {
  __typename: 'VideoSectionPersonaModelTextField';
  blocks: Array<VideoSectionPersonaModelTextBlocksField>;
  inlineBlocks: Array<Scalars['String']['output']>;
  links: Array<Scalars['String']['output']>;
  value: Scalars['JsonField']['output'];
};

/** Block of type [Video Section] Persona (video_section_persona) */
export type VideoSectionPersonaRecord = RecordInterface & {
  __typename: 'VideoSectionPersonaRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  icon: FileField;
  id: Scalars['ItemId']['output'];
  text: VideoSectionPersonaModelTextField;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


/** Block of type [Video Section] Persona (video_section_persona) */
export type VideoSectionPersonaRecord_SeoMetaTagsArgs = {
  locale: InputMaybe<SiteLocale>;
};

/** Block of type [Section] Video (video_section) */
export type VideoSectionRecord = RecordInterface & {
  __typename: 'VideoSectionRecord';
  _createdAt: Scalars['DateTime']['output'];
  /** Editing URL */
  _editingUrl: Maybe<Scalars['String']['output']>;
  _firstPublishedAt: Scalars['DateTime']['output'];
  _isValid: Scalars['BooleanType']['output'];
  _modelApiKey: Scalars['String']['output'];
  _publicationScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _publishedAt: Scalars['DateTime']['output'];
  /** Generates SEO and Social card meta tags to be used in your frontend */
  _seoMetaTags: Array<Tag>;
  _status: ItemStatus;
  _unpublishingScheduledAt: Maybe<Scalars['DateTime']['output']>;
  _updatedAt: Scalars['DateTime']['output'];
  asset: FileField;
  button: Maybe<VideoSectionModelButtonField>;
  createdAt: Scalars['DateTime']['output'];
  fullBleed: Maybe<Scalars['BooleanType']['output']>;
  id: Scalars['ItemId']['output'];
  persona: Maybe<VideoSectionPersonaRecord>;
  text: VideoSectionModelTextField;
  title: Maybe<Scalars['String']['output']>;
  topic: Maybe<Scalars['String']['output']>;
  topicSubline: Maybe<VideoSectionModelTopicSublineField>;
  topline: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  variant: Scalars['String']['output'];
};


/** Block of type [Section] Video (video_section) */
export type VideoSectionRecord_SeoMetaTagsArgs = {
  locale: InputMaybe<SiteLocale>;
};

export type FocalPoint = {
  __typename: 'focalPoint';
  x: Scalars['FloatType']['output'];
  y: Scalars['FloatType']['output'];
};

export type GetAllBlogpostsForBlogSectionQueryVariables = Exact<{
  locale: SiteLocale;
}>;


export type GetAllBlogpostsForBlogSectionQuery = { __typename: 'Query', allBlogposts: Array<{ __typename: 'BlogpostRecord', id: string, title: string, slug: string, date: any, teaserText: string, allSlugLocales: Array<{ __typename: 'StringNonNullMultiLocaleField', locale: SiteLocale | null, value: string }> | null, productFamily: { __typename: 'InsuranceProductFamilyRecord', name: string, slug: string, color: { __typename: 'ColorField', hex: string } }, teaserImage: { __typename: 'FileField', _updatedAt: any, url: string, format: string, alt: string | null, width: number | null, height: number | null, responsiveImage: { __typename: 'ResponsiveImage', aspectRatio: number, alt: string | null, base64: string | null, height: number, src: string, title: string | null, width: number } | null }, brands: Array<{ __typename: 'BrandRecord', slug: string }> }> };

export type GetFaviconQueryVariables = Exact<{
  locale: SiteLocale;
  brandSlug: Scalars['String']['input'];
}>;


export type GetFaviconQuery = { __typename: 'Query', brand: { __typename: 'BrandRecord', favicon: { __typename: 'FileField', url: string } } | null };

export type GenericAssetFragmentFragment = { __typename: 'FileField', _updatedAt: any, url: string, format: string, alt: string | null, width: number | null, height: number | null };

export type ResponsiveImageFragmentFragment = { __typename: 'ResponsiveImage', aspectRatio: number, alt: string | null, base64: string | null, height: number, src: string, title: string | null, width: number };

export type OfferSingleBlockFragment = { __typename: 'OfferSingleRecord', id: string, text: string | null, title: string, icon: { __typename: 'FileField', _updatedAt: any, url: string, format: string, alt: string | null, width: number | null, height: number | null }, link: Array<{ __typename: 'InlineLinkButtonRecord', id: string, url: string | null, label: string, linkType: string, linkStyle: string, jumpMark: string | null, analyticsId: string, text: string | null, title: string | null, internal: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | { __typename: 'PageRecord', slug: string } | null, leftIcon: { __typename: 'IconReferenceRecord', name: string } | null, rightIcon: { __typename: 'IconReferenceRecord', name: string } | null }> };

export type PersonaFactSingleBlockFragment = { __typename: 'PersonaFactRecord', id: string, name: string, value: string };

export type TextSectionFragment = { __typename: 'TextSectionRecord', style: string, showArrow: boolean | null, sectionText: { __typename: 'TextSectionModelTextField', value: DatoJsonField, blocks: Array<{ __typename: 'InlineAssetGalleryRecord', id: string, assets: Array<{ __typename: 'FileField', _updatedAt: any, url: string, format: string, alt: string | null, basename: string, width: number | null, height: number | null, video: { __typename: 'UploadVideoField', streamingUrl: string, thumbnailUrl: string } | null, responsiveImage: { __typename: 'ResponsiveImage', aspectRatio: number, alt: string | null, base64: string | null, height: number, src: string, title: string | null, width: number } | null }> } | { __typename: 'InlineAssetRecord', id: string, limitWidth: string | null, asset: { __typename: 'FileField', _updatedAt: any, url: string, format: string, alt: string | null, basename: string, width: number | null, height: number | null, video: { __typename: 'UploadVideoField', streamingUrl: string, thumbnailUrl: string } | null, responsiveImage: { __typename: 'ResponsiveImage', aspectRatio: number, alt: string | null, base64: string | null, height: number, src: string, title: string | null, width: number } | null } } | { __typename: 'InlineLinkButtonRecord', id: string, url: string | null, label: string, linkType: string, linkStyle: string, jumpMark: string | null, analyticsId: string, text: string | null, title: string | null, internal: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | { __typename: 'PageRecord', slug: string } | null, leftIcon: { __typename: 'IconReferenceRecord', name: string } | null, rightIcon: { __typename: 'IconReferenceRecord', name: string } | null } | { __typename: 'InlineModalButtonRecord', id: string, label: string, linkStyle: string, modalName: string, analyticsId: string, enablePrefill: boolean | null, text: string | null, leftIcon: { __typename: 'IconReferenceRecord', name: string } | null, rightIcon: { __typename: 'IconReferenceRecord', name: string } | null, product: { __typename: 'InsuranceProductRecord', slug: string, externalProvider: string | null, productCode: DatoJsonField, targetGroup: { __typename: 'TargetGroupRecord', id: string, slug: string } | null, productFamily: { __typename: 'InsuranceProductFamilyRecord', id: string, slug: string } } | null } | { __typename: 'ResponsiveSvgRecord', id: string, alternativeText: string, baseAsset: { __typename: 'FileField', id: any, height: number | null, width: number | null, url: string, alt: string | null }, steps: Array<{ __typename: 'ResponsiveSvgStepRecord', breakpoint: string, asset: { __typename: 'FileField', id: any, height: number | null, width: number | null, url: string, alt: string | null } }> } | { __typename: 'TextSectionTableRecord', id: string, columns: Array<{ __typename: 'TextSectionTableColumnRecord', id: string, heading: string, icon: { __typename: 'FileField', _updatedAt: any, url: string, format: string, alt: string | null, width: number | null, height: number | null, responsiveImage: { __typename: 'ResponsiveImage', aspectRatio: number, alt: string | null, base64: string | null, height: number, src: string, title: string | null, width: number } | null } | null, items: Array<{ __typename: 'TextSectionTableItemRecord', id: string, text: string, icon: { __typename: 'IconReferenceRecord', name: string } }> }> }> }, backgroundColor: { __typename: 'ColorField', hex: string }, fontColor: { __typename: 'ColorField', hex: string } };

export type TextSectionTableFragment = { __typename: 'TextSectionTableRecord', id: string, columns: Array<{ __typename: 'TextSectionTableColumnRecord', id: string, heading: string, icon: { __typename: 'FileField', _updatedAt: any, url: string, format: string, alt: string | null, width: number | null, height: number | null, responsiveImage: { __typename: 'ResponsiveImage', aspectRatio: number, alt: string | null, base64: string | null, height: number, src: string, title: string | null, width: number } | null } | null, items: Array<{ __typename: 'TextSectionTableItemRecord', id: string, text: string, icon: { __typename: 'IconReferenceRecord', name: string } }> }> };

export type FaqSectionFragment = { __typename: 'FaqSectionRecord', hasSearch: boolean | null, sectionTitle: string | null, sectionSubtitle: string | null, faqSectionText: string | null, faqs: Array<{ __typename: 'FaqRecord', id: string, title: string | null, subtitle: string | null, questions: Array<{ __typename: 'QuestionAnswerRecord', id: string, number: string | null, question: string, answer: string }>, insuranceProductFamilies: Array<{ __typename: 'InsuranceProductFamilyRecord', name: string, slug: string, color: { __typename: 'ColorField', hex: string } }> }> };

export type FaqsFragment = { __typename: 'FaqRecord', id: string, title: string | null, subtitle: string | null, questions: Array<{ __typename: 'QuestionAnswerRecord', id: string, number: string | null, question: string, answer: string }>, insuranceProductFamilies: Array<{ __typename: 'InsuranceProductFamilyRecord', name: string, slug: string, color: { __typename: 'ColorField', hex: string } }> };

export type CustomerReviewSectionFragment = { __typename: 'CustomerReviewsSectionRecord', title: string, reviews: Array<{ __typename: 'CustomerReviewRecord', id: string, name: string, role: string | null, quote: string, photo: { __typename: 'FileField', _updatedAt: any, url: string, format: string, alt: string | null, width: number | null, height: number | null, responsiveImage: { __typename: 'ResponsiveImage', aspectRatio: number, alt: string | null, base64: string | null, height: number, src: string, title: string | null, width: number } | null } }> };

export type CtaSectionFragment = { __typename: 'CtaSectionRecord', title: string, description: string | null, linkButtons: Array<{ __typename: 'InlineLinkButtonRecord', id: string, url: string | null, label: string, linkType: string, linkStyle: string, jumpMark: string | null, analyticsId: string, text: string | null, title: string | null, internal: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | { __typename: 'PageRecord', slug: string } | null, leftIcon: { __typename: 'IconReferenceRecord', name: string } | null, rightIcon: { __typename: 'IconReferenceRecord', name: string } | null } | { __typename: 'InlineModalButtonRecord', id: string, label: string, linkStyle: string, modalName: string, analyticsId: string, enablePrefill: boolean | null, text: string | null, leftIcon: { __typename: 'IconReferenceRecord', name: string } | null, rightIcon: { __typename: 'IconReferenceRecord', name: string } | null, product: { __typename: 'InsuranceProductRecord', slug: string, externalProvider: string | null, productCode: DatoJsonField, targetGroup: { __typename: 'TargetGroupRecord', id: string, slug: string } | null, productFamily: { __typename: 'InsuranceProductFamilyRecord', id: string, slug: string } } | null }> };

export type ContactInfoFragment = { __typename: 'ContactRecord', id: string, name: string, availability: string, phoneNumber: string, email: string, modalText: string | null, text: string | null };

export type ContactSectionFragment = { __typename: 'ContactSectionRecord', title: string, subtitle: string, contact: { __typename: 'ContactRecord', id: string, name: string, availability: string, phoneNumber: string, email: string, modalText: string | null, text: string | null } };

export type DemoSectionFragment = { __typename: 'DemoSectionRecord', title: string, subtitle: string, demoText: string, contact: { __typename: 'ContactRecord', id: string, name: string, availability: string, phoneNumber: string, email: string, modalText: string | null, text: string | null } };

export type LogoWallSectionFragment = { __typename: 'LogoWallSectionRecord', title: string, logos: Array<{ __typename: 'FileField', _updatedAt: any, url: string, format: string, alt: string | null, width: number | null, height: number | null, responsiveImage: { __typename: 'ResponsiveImage', aspectRatio: number, alt: string | null, base64: string | null, height: number, src: string, title: string | null, width: number } | null }> };

export type NewsletterSectionFragment = { __typename: 'NewsletterSectionRecord', topContent: { __typename: 'NewsletterSectionModelTopContentField', blocks: Array<string>, links: Array<string>, value: DatoJsonField }, bottomContent: { __typename: 'NewsletterSectionModelBottomContentField', blocks: Array<string>, links: Array<string>, value: DatoJsonField } };

export type InlineLinkButtonFragment = { __typename: 'InlineLinkButtonRecord', id: string, url: string | null, label: string, linkType: string, linkStyle: string, jumpMark: string | null, analyticsId: string, text: string | null, title: string | null, internal: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | { __typename: 'PageRecord', slug: string } | null, leftIcon: { __typename: 'IconReferenceRecord', name: string } | null, rightIcon: { __typename: 'IconReferenceRecord', name: string } | null };

export type InlineModalButtonFragment = { __typename: 'InlineModalButtonRecord', id: string, label: string, linkStyle: string, modalName: string, analyticsId: string, enablePrefill: boolean | null, text: string | null, leftIcon: { __typename: 'IconReferenceRecord', name: string } | null, rightIcon: { __typename: 'IconReferenceRecord', name: string } | null, product: { __typename: 'InsuranceProductRecord', slug: string, externalProvider: string | null, productCode: DatoJsonField, targetGroup: { __typename: 'TargetGroupRecord', id: string, slug: string } | null, productFamily: { __typename: 'InsuranceProductFamilyRecord', id: string, slug: string } } | null };

export type InlineAssetFragment = { __typename: 'InlineAssetRecord', id: string, limitWidth: string | null, asset: { __typename: 'FileField', _updatedAt: any, url: string, format: string, alt: string | null, basename: string, width: number | null, height: number | null, video: { __typename: 'UploadVideoField', streamingUrl: string, thumbnailUrl: string } | null, responsiveImage: { __typename: 'ResponsiveImage', aspectRatio: number, alt: string | null, base64: string | null, height: number, src: string, title: string | null, width: number } | null } };

export type InlineAssetGalleryFragment = { __typename: 'InlineAssetGalleryRecord', id: string, assets: Array<{ __typename: 'FileField', _updatedAt: any, url: string, format: string, alt: string | null, basename: string, width: number | null, height: number | null, video: { __typename: 'UploadVideoField', streamingUrl: string, thumbnailUrl: string } | null, responsiveImage: { __typename: 'ResponsiveImage', aspectRatio: number, alt: string | null, base64: string | null, height: number, src: string, title: string | null, width: number } | null }> };

export type InlineResponsiveSvgFragment = { __typename: 'ResponsiveSvgRecord', id: string, alternativeText: string, baseAsset: { __typename: 'FileField', id: any, height: number | null, width: number | null, url: string, alt: string | null }, steps: Array<{ __typename: 'ResponsiveSvgStepRecord', breakpoint: string, asset: { __typename: 'FileField', id: any, height: number | null, width: number | null, url: string, alt: string | null } }> };

export type ProductSingleBlockFragment = { __typename: 'ProductRecord', id: string, title: string, headerAlignment: string, startingPrice: number | null, priceDescription: string | null, icon: { __typename: 'FileField', _updatedAt: any, url: string, format: string, alt: string | null, width: number | null, height: number | null } | null, description: { __typename: 'ProductModelDescriptionField', value: DatoJsonField, blocks: Array<{ __typename: 'InlineLinkButtonRecord', id: string, url: string | null, label: string, linkType: string, linkStyle: string, jumpMark: string | null, analyticsId: string, text: string | null, title: string | null, internal: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | { __typename: 'PageRecord', slug: string } | null, leftIcon: { __typename: 'IconReferenceRecord', name: string } | null, rightIcon: { __typename: 'IconReferenceRecord', name: string } | null } | { __typename: 'InlineModalButtonRecord', id: string, label: string, linkStyle: string, modalName: string, analyticsId: string, enablePrefill: boolean | null, text: string | null, leftIcon: { __typename: 'IconReferenceRecord', name: string } | null, rightIcon: { __typename: 'IconReferenceRecord', name: string } | null, product: { __typename: 'InsuranceProductRecord', slug: string, externalProvider: string | null, productCode: DatoJsonField, targetGroup: { __typename: 'TargetGroupRecord', id: string, slug: string } | null, productFamily: { __typename: 'InsuranceProductFamilyRecord', id: string, slug: string } } | null }> }, linkedProduct: { __typename: 'InsuranceProductRecord', id: string, name: string, slug: string, productCode: DatoJsonField, productName: DatoJsonField, externalProvider: string | null, showContactForm: boolean | null, showTariffCalculator: boolean | null, showMenu: boolean | null, isOnlineApplication: boolean | null, sendinblueFormUrl: string | null, demoFormSlug: string | null, messageFormSlug: string | null, callbackFormSlug: string | null, productGroupName: string | null, productGroupDescription: string | null, contact: { __typename: 'ContactRecord', id: string, name: string, availability: string, phoneNumber: string, email: string, modalText: string | null, text: string | null } | null, targetGroup: { __typename: 'TargetGroupRecord', id: string, name: string, slug: string, showContactForm: boolean | null, sendinblueFormUrl: string | null, demoFormSlug: string | null, messageFormSlug: string | null, callbackFormSlug: string | null, contact: { __typename: 'ContactRecord', id: string, name: string, availability: string, phoneNumber: string, email: string, modalText: string | null, text: string | null } } | null, currentVersion: { __typename: 'InsuranceProductVersionRecord', price: number | null, priceDescription: string | null, productDescription: string, overviewFacts: { __typename: 'InsuranceProductVersionModelOverviewFactsField', value: DatoJsonField } | null }, image: { __typename: 'FileField', _updatedAt: any, url: string, format: string, alt: string | null, width: number | null, height: number | null, responsiveImage: { __typename: 'ResponsiveImage', aspectRatio: number, alt: string | null, base64: string | null, height: number, src: string, title: string | null, width: number } | null } | null, productFamily: { __typename: 'InsuranceProductFamilyRecord', name: string, slug: string, color: { __typename: 'ColorField', hex: string } } } | null };

export type HeaderDropdownFragment = { __typename: 'HeaderDropdownRecord', label: string, analyticsId: string, dropdownItems: Array<{ __typename: 'FamilyHeaderItemRecord', id: string, family: { __typename: 'InsuranceProductFamilyRecord', id: string, name: string, slug: string, color: { __typename: 'ColorField', hex: string } }, products: Array<{ __typename: 'ProductHeaderItemRecord', id: string, label: string | null, link: { __typename: 'InsuranceProductFamilyRecord', id: string, name: string, slug: string } | { __typename: 'InsuranceProductRecord', id: string, name: string, slug: string, currentVersion: { __typename: 'InsuranceProductVersionRecord', externalLink: string | null } } | { __typename: 'PageRecord', id: string, name: string, slug: string }, targetGroups: Array<{ __typename: 'TargetGroupHeaderItemRecord', id: string, label: string | null, link: { __typename: 'InsuranceProductFamilyRecord', id: string, name: string, slug: string } | { __typename: 'PageRecord', id: string, name: string, slug: string } | { __typename: 'TargetGroupRecord', id: string, name: string, slug: string } }> }> } | { __typename: 'HeaderItemRecord', id: string, page: { __typename: 'PageRecord', id: string, name: string, slug: string } }> };

export type ProductHeaderItemFragment = { __typename: 'ProductHeaderItemRecord', id: string, label: string | null, link: { __typename: 'InsuranceProductFamilyRecord', id: string, name: string, slug: string } | { __typename: 'InsuranceProductRecord', id: string, name: string, slug: string, currentVersion: { __typename: 'InsuranceProductVersionRecord', externalLink: string | null } } | { __typename: 'PageRecord', id: string, name: string, slug: string }, targetGroups: Array<{ __typename: 'TargetGroupHeaderItemRecord', id: string, label: string | null, link: { __typename: 'InsuranceProductFamilyRecord', id: string, name: string, slug: string } | { __typename: 'PageRecord', id: string, name: string, slug: string } | { __typename: 'TargetGroupRecord', id: string, name: string, slug: string } }> };

export type TargetGroupHeaderItemFragment = { __typename: 'TargetGroupHeaderItemRecord', id: string, label: string | null, link: { __typename: 'InsuranceProductFamilyRecord', id: string, name: string, slug: string } | { __typename: 'PageRecord', id: string, name: string, slug: string } | { __typename: 'TargetGroupRecord', id: string, name: string, slug: string } };

export type ModularContentServiceBenefitFragment = { __typename: 'ServiceBenefitRecord', id: string, title: string, iconPosition: string, benefits: Array<{ __typename: 'BenefitRecord', id: string, title: string, text: string, icon: { __typename: 'FileField', url: string, _updatedAt: any, format: string, alt: string | null, width: number | null, height: number | null } }> };

export type ModularContentHeroFragment = { __typename: 'HeroRecord', id: string, title: string, subline: string | null, priceTagText: string | null, startingPrice: number | null, style: string, text: { __typename: 'HeroModelTextField', value: DatoJsonField, blocks: Array<{ __typename: 'InlineLinkButtonRecord', id: string, url: string | null, label: string, linkType: string, linkStyle: string, jumpMark: string | null, analyticsId: string, text: string | null, title: string | null, internal: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | { __typename: 'PageRecord', slug: string } | null, leftIcon: { __typename: 'IconReferenceRecord', name: string } | null, rightIcon: { __typename: 'IconReferenceRecord', name: string } | null } | { __typename: 'InlineModalButtonRecord', id: string, label: string, linkStyle: string, modalName: string, analyticsId: string, enablePrefill: boolean | null, text: string | null, leftIcon: { __typename: 'IconReferenceRecord', name: string } | null, rightIcon: { __typename: 'IconReferenceRecord', name: string } | null, product: { __typename: 'InsuranceProductRecord', slug: string, externalProvider: string | null, productCode: DatoJsonField, targetGroup: { __typename: 'TargetGroupRecord', id: string, slug: string } | null, productFamily: { __typename: 'InsuranceProductFamilyRecord', id: string, slug: string } } | null }> } | null, cta: Array<{ __typename: 'InlineLinkButtonRecord', id: string, url: string | null, label: string, linkType: string, linkStyle: string, jumpMark: string | null, analyticsId: string, text: string | null, title: string | null, internal: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | { __typename: 'PageRecord', slug: string } | null, leftIcon: { __typename: 'IconReferenceRecord', name: string } | null, rightIcon: { __typename: 'IconReferenceRecord', name: string } | null } | { __typename: 'InlineModalButtonRecord', id: string, label: string, linkStyle: string, modalName: string, analyticsId: string, enablePrefill: boolean | null, text: string | null, leftIcon: { __typename: 'IconReferenceRecord', name: string } | null, rightIcon: { __typename: 'IconReferenceRecord', name: string } | null, product: { __typename: 'InsuranceProductRecord', slug: string, externalProvider: string | null, productCode: DatoJsonField, targetGroup: { __typename: 'TargetGroupRecord', id: string, slug: string } | null, productFamily: { __typename: 'InsuranceProductFamilyRecord', id: string, slug: string } } | null }>, background: { __typename: 'FileField', _updatedAt: any, url: string, format: string, alt: string | null, width: number | null, height: number | null, responsiveImage: { __typename: 'ResponsiveImage', aspectRatio: number, alt: string | null, base64: string | null, height: number, src: string, title: string | null, width: number } | null } };

export type ModularContentHeroSliderFragment = { __typename: 'HeroSliderRecord', id: string, slides: Array<{ __typename: 'HeroRecord', id: string, title: string, subline: string | null, priceTagText: string | null, startingPrice: number | null, style: string, text: { __typename: 'HeroModelTextField', value: DatoJsonField, blocks: Array<{ __typename: 'InlineLinkButtonRecord', id: string, url: string | null, label: string, linkType: string, linkStyle: string, jumpMark: string | null, analyticsId: string, text: string | null, title: string | null, internal: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | { __typename: 'PageRecord', slug: string } | null, leftIcon: { __typename: 'IconReferenceRecord', name: string } | null, rightIcon: { __typename: 'IconReferenceRecord', name: string } | null } | { __typename: 'InlineModalButtonRecord', id: string, label: string, linkStyle: string, modalName: string, analyticsId: string, enablePrefill: boolean | null, text: string | null, leftIcon: { __typename: 'IconReferenceRecord', name: string } | null, rightIcon: { __typename: 'IconReferenceRecord', name: string } | null, product: { __typename: 'InsuranceProductRecord', slug: string, externalProvider: string | null, productCode: DatoJsonField, targetGroup: { __typename: 'TargetGroupRecord', id: string, slug: string } | null, productFamily: { __typename: 'InsuranceProductFamilyRecord', id: string, slug: string } } | null }> } | null, cta: Array<{ __typename: 'InlineLinkButtonRecord', id: string, url: string | null, label: string, linkType: string, linkStyle: string, jumpMark: string | null, analyticsId: string, text: string | null, title: string | null, internal: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | { __typename: 'PageRecord', slug: string } | null, leftIcon: { __typename: 'IconReferenceRecord', name: string } | null, rightIcon: { __typename: 'IconReferenceRecord', name: string } | null } | { __typename: 'InlineModalButtonRecord', id: string, label: string, linkStyle: string, modalName: string, analyticsId: string, enablePrefill: boolean | null, text: string | null, leftIcon: { __typename: 'IconReferenceRecord', name: string } | null, rightIcon: { __typename: 'IconReferenceRecord', name: string } | null, product: { __typename: 'InsuranceProductRecord', slug: string, externalProvider: string | null, productCode: DatoJsonField, targetGroup: { __typename: 'TargetGroupRecord', id: string, slug: string } | null, productFamily: { __typename: 'InsuranceProductFamilyRecord', id: string, slug: string } } | null }>, background: { __typename: 'FileField', _updatedAt: any, url: string, format: string, alt: string | null, width: number | null, height: number | null, responsiveImage: { __typename: 'ResponsiveImage', aspectRatio: number, alt: string | null, base64: string | null, height: number, src: string, title: string | null, width: number } | null } }> };

export type ModularContentPersonaFragment = { __typename: 'PersonaRecord', id: string, recommendationIcon: { __typename: 'FileField', _updatedAt: any, url: string, format: string, alt: string | null, width: number | null, height: number | null }, content: { __typename: 'PersonaModelContentField', value: DatoJsonField, blocks: Array<{ __typename: 'PersonaFactRecord', id: string, name: string, value: string }> }, video: { __typename: 'VideoFileField', video: { __typename: 'UploadVideoField', streamingUrl: string, thumbnailUrl: string } } };

export type ModularContentPremiumCalcHeroFragment = { __typename: 'PremiumCalcHeroRecord', id: string, title: string, subline: string | null, video: { __typename: 'VideoFileField', video: { __typename: 'UploadVideoField', streamingUrl: string, thumbnailUrl: string } } };

export type ModularContentMissionFragment = { __typename: 'MissionRecord', id: string, style: string, text: { __typename: 'MissionModelTextField', value: DatoJsonField } | null, image: { __typename: 'FileField', _updatedAt: any, url: string, format: string, alt: string | null, width: number | null, height: number | null, responsiveImage: { __typename: 'ResponsiveImage', aspectRatio: number, alt: string | null, base64: string | null, height: number, src: string, title: string | null, width: number } | null } | null };

export type ModularContentMissionSliderFragment = { __typename: 'MissionSliderRecord', id: string, slides: Array<{ __typename: 'MissionRecord', id: string, style: string, text: { __typename: 'MissionModelTextField', value: DatoJsonField } | null, image: { __typename: 'FileField', _updatedAt: any, url: string, format: string, alt: string | null, width: number | null, height: number | null, responsiveImage: { __typename: 'ResponsiveImage', aspectRatio: number, alt: string | null, base64: string | null, height: number, src: string, title: string | null, width: number } | null } | null }> };

export type ModularContentImageTextSectionFragment = { __typename: 'ImageTextSectionRecord', id: string, imageTextSectionText: { __typename: 'ImageTextSectionModelTextField', value: DatoJsonField, blocks: Array<{ __typename: 'InlineLinkButtonRecord', id: string, url: string | null, label: string, linkType: string, linkStyle: string, jumpMark: string | null, analyticsId: string, text: string | null, title: string | null, internal: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | { __typename: 'PageRecord', slug: string } | null, leftIcon: { __typename: 'IconReferenceRecord', name: string } | null, rightIcon: { __typename: 'IconReferenceRecord', name: string } | null } | { __typename: 'InlineModalButtonRecord', id: string, label: string, linkStyle: string, modalName: string, analyticsId: string, enablePrefill: boolean | null, text: string | null, leftIcon: { __typename: 'IconReferenceRecord', name: string } | null, rightIcon: { __typename: 'IconReferenceRecord', name: string } | null, product: { __typename: 'InsuranceProductRecord', slug: string, externalProvider: string | null, productCode: DatoJsonField, targetGroup: { __typename: 'TargetGroupRecord', id: string, slug: string } | null, productFamily: { __typename: 'InsuranceProductFamilyRecord', id: string, slug: string } } | null }> }, imageTextSectionImage: { __typename: 'FileField', _updatedAt: any, url: string, format: string, alt: string | null, width: number | null, height: number | null, responsiveImage: { __typename: 'ResponsiveImage', aspectRatio: number, alt: string | null, base64: string | null, height: number, src: string, title: string | null, width: number } | null } };

export type ModularContentBlogpostSectionFragment = { __typename: 'BlogpostSectionRecord', id: string, topicSelector: boolean | null, topicSelectorText: string | null, introText: { __typename: 'BlogpostSectionModelIntroField', value: DatoJsonField, links: Array<string>, blocks: Array<{ __typename: 'InlineLinkButtonRecord', id: string, url: string | null, label: string, linkType: string, linkStyle: string, jumpMark: string | null, analyticsId: string, text: string | null, title: string | null, internal: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | { __typename: 'PageRecord', slug: string } | null, leftIcon: { __typename: 'IconReferenceRecord', name: string } | null, rightIcon: { __typename: 'IconReferenceRecord', name: string } | null }> } | null };

export type UserActionSectionItemFragment = { __typename: 'UserActionSectionItemRecord', id: string, itemTitle: string, itemText: string, icon: { __typename: 'IconReferenceRecord', name: string } };

export type ModularContentUserActionSectionFragment = { __typename: 'UserActionSectionRecord', id: string, headline: string | null, userActions: Array<{ __typename: 'InlineLinkButtonRecord', id: string, url: string | null, label: string, linkType: string, linkStyle: string, jumpMark: string | null, analyticsId: string, text: string | null, title: string | null, internal: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | { __typename: 'PageRecord', slug: string } | null, leftIcon: { __typename: 'IconReferenceRecord', name: string } | null, rightIcon: { __typename: 'IconReferenceRecord', name: string } | null } | { __typename: 'InlineModalButtonRecord', id: string, label: string, linkStyle: string, modalName: string, analyticsId: string, enablePrefill: boolean | null, text: string | null, leftIcon: { __typename: 'IconReferenceRecord', name: string } | null, rightIcon: { __typename: 'IconReferenceRecord', name: string } | null, product: { __typename: 'InsuranceProductRecord', slug: string, externalProvider: string | null, productCode: DatoJsonField, targetGroup: { __typename: 'TargetGroupRecord', id: string, slug: string } | null, productFamily: { __typename: 'InsuranceProductFamilyRecord', id: string, slug: string } } | null } | { __typename: 'UserActionSectionItemRecord', id: string, itemTitle: string, itemText: string, icon: { __typename: 'IconReferenceRecord', name: string } }> };

export type ModularContentonNewsletterSignupFragment = { __typename: 'NewsletterSignupRecord', id: string, action: string, title: string, intro: string };

export type ModularContentOffersFragment = { __typename: 'OffersBlockRecord', id: string, offerText: { __typename: 'OffersBlockModelTextField', value: DatoJsonField, blocks: Array<{ __typename: 'OfferSingleRecord', id: string, text: string | null, title: string, icon: { __typename: 'FileField', _updatedAt: any, url: string, format: string, alt: string | null, width: number | null, height: number | null }, link: Array<{ __typename: 'InlineLinkButtonRecord', id: string, url: string | null, label: string, linkType: string, linkStyle: string, jumpMark: string | null, analyticsId: string, text: string | null, title: string | null, internal: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | { __typename: 'PageRecord', slug: string } | null, leftIcon: { __typename: 'IconReferenceRecord', name: string } | null, rightIcon: { __typename: 'IconReferenceRecord', name: string } | null }> }> } };

export type ModularContentTextSectionFragment = { __typename: 'TextSectionRecord', id: string, style: string, showArrow: boolean | null, sectionText: { __typename: 'TextSectionModelTextField', value: DatoJsonField, blocks: Array<{ __typename: 'InlineAssetGalleryRecord', id: string, assets: Array<{ __typename: 'FileField', _updatedAt: any, url: string, format: string, alt: string | null, basename: string, width: number | null, height: number | null, video: { __typename: 'UploadVideoField', streamingUrl: string, thumbnailUrl: string } | null, responsiveImage: { __typename: 'ResponsiveImage', aspectRatio: number, alt: string | null, base64: string | null, height: number, src: string, title: string | null, width: number } | null }> } | { __typename: 'InlineAssetRecord', id: string, limitWidth: string | null, asset: { __typename: 'FileField', _updatedAt: any, url: string, format: string, alt: string | null, basename: string, width: number | null, height: number | null, video: { __typename: 'UploadVideoField', streamingUrl: string, thumbnailUrl: string } | null, responsiveImage: { __typename: 'ResponsiveImage', aspectRatio: number, alt: string | null, base64: string | null, height: number, src: string, title: string | null, width: number } | null } } | { __typename: 'InlineLinkButtonRecord', id: string, url: string | null, label: string, linkType: string, linkStyle: string, jumpMark: string | null, analyticsId: string, text: string | null, title: string | null, internal: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | { __typename: 'PageRecord', slug: string } | null, leftIcon: { __typename: 'IconReferenceRecord', name: string } | null, rightIcon: { __typename: 'IconReferenceRecord', name: string } | null } | { __typename: 'InlineModalButtonRecord', id: string, label: string, linkStyle: string, modalName: string, analyticsId: string, enablePrefill: boolean | null, text: string | null, leftIcon: { __typename: 'IconReferenceRecord', name: string } | null, rightIcon: { __typename: 'IconReferenceRecord', name: string } | null, product: { __typename: 'InsuranceProductRecord', slug: string, externalProvider: string | null, productCode: DatoJsonField, targetGroup: { __typename: 'TargetGroupRecord', id: string, slug: string } | null, productFamily: { __typename: 'InsuranceProductFamilyRecord', id: string, slug: string } } | null } | { __typename: 'ResponsiveSvgRecord', id: string, alternativeText: string, baseAsset: { __typename: 'FileField', id: any, height: number | null, width: number | null, url: string, alt: string | null }, steps: Array<{ __typename: 'ResponsiveSvgStepRecord', breakpoint: string, asset: { __typename: 'FileField', id: any, height: number | null, width: number | null, url: string, alt: string | null } }> } | { __typename: 'TextSectionTableRecord', id: string, columns: Array<{ __typename: 'TextSectionTableColumnRecord', id: string, heading: string, icon: { __typename: 'FileField', _updatedAt: any, url: string, format: string, alt: string | null, width: number | null, height: number | null, responsiveImage: { __typename: 'ResponsiveImage', aspectRatio: number, alt: string | null, base64: string | null, height: number, src: string, title: string | null, width: number } | null } | null, items: Array<{ __typename: 'TextSectionTableItemRecord', id: string, text: string, icon: { __typename: 'IconReferenceRecord', name: string } }> }> }> }, backgroundColor: { __typename: 'ColorField', hex: string }, fontColor: { __typename: 'ColorField', hex: string } };

export type ModularContentFaqSectionFragment = { __typename: 'FaqSectionRecord', id: string, hasSearch: boolean | null, sectionTitle: string | null, sectionSubtitle: string | null, faqSectionText: string | null, faqs: Array<{ __typename: 'FaqRecord', id: string, title: string | null, subtitle: string | null, questions: Array<{ __typename: 'QuestionAnswerRecord', id: string, number: string | null, question: string, answer: string }>, insuranceProductFamilies: Array<{ __typename: 'InsuranceProductFamilyRecord', name: string, slug: string, color: { __typename: 'ColorField', hex: string } }> }> };

export type ModularContentAboutFragment = { __typename: 'AboutRecord', id: string, aboutSectionText: { __typename: 'AboutModelTextField', value: DatoJsonField, blocks: Array<{ __typename: 'InlineAssetRecord', id: string, limitWidth: string | null, asset: { __typename: 'FileField', _updatedAt: any, url: string, format: string, alt: string | null, basename: string, width: number | null, height: number | null, video: { __typename: 'UploadVideoField', streamingUrl: string, thumbnailUrl: string } | null, responsiveImage: { __typename: 'ResponsiveImage', aspectRatio: number, alt: string | null, base64: string | null, height: number, src: string, title: string | null, width: number } | null } } | { __typename: 'InlineLinkButtonRecord', id: string, url: string | null, label: string, linkType: string, linkStyle: string, jumpMark: string | null, analyticsId: string, text: string | null, title: string | null, internal: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | { __typename: 'PageRecord', slug: string } | null, leftIcon: { __typename: 'IconReferenceRecord', name: string } | null, rightIcon: { __typename: 'IconReferenceRecord', name: string } | null } | { __typename: 'InlineModalButtonRecord', id: string, label: string, linkStyle: string, modalName: string, analyticsId: string, enablePrefill: boolean | null, text: string | null, leftIcon: { __typename: 'IconReferenceRecord', name: string } | null, rightIcon: { __typename: 'IconReferenceRecord', name: string } | null, product: { __typename: 'InsuranceProductRecord', slug: string, externalProvider: string | null, productCode: DatoJsonField, targetGroup: { __typename: 'TargetGroupRecord', id: string, slug: string } | null, productFamily: { __typename: 'InsuranceProductFamilyRecord', id: string, slug: string } } | null }> } };

export type ModularContentLogoWallFragment = { __typename: 'LogoWallSectionRecord', id: string, title: string, logos: Array<{ __typename: 'FileField', _updatedAt: any, url: string, format: string, alt: string | null, width: number | null, height: number | null, responsiveImage: { __typename: 'ResponsiveImage', aspectRatio: number, alt: string | null, base64: string | null, height: number, src: string, title: string | null, width: number } | null }> };

export type ModularContentProductComparisonFragment = { __typename: 'ProductComparisonRecord', id: string, topicSelector: boolean | null, topicSelectorText: string | null, introAlignment: string, products: { __typename: 'ProductComparisonModelProductsField', value: DatoJsonField, blocks: Array<{ __typename: 'ProductRecord', id: string, title: string, headerAlignment: string, startingPrice: number | null, priceDescription: string | null, icon: { __typename: 'FileField', _updatedAt: any, url: string, format: string, alt: string | null, width: number | null, height: number | null } | null, description: { __typename: 'ProductModelDescriptionField', value: DatoJsonField, blocks: Array<{ __typename: 'InlineLinkButtonRecord', id: string, url: string | null, label: string, linkType: string, linkStyle: string, jumpMark: string | null, analyticsId: string, text: string | null, title: string | null, internal: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | { __typename: 'PageRecord', slug: string } | null, leftIcon: { __typename: 'IconReferenceRecord', name: string } | null, rightIcon: { __typename: 'IconReferenceRecord', name: string } | null } | { __typename: 'InlineModalButtonRecord', id: string, label: string, linkStyle: string, modalName: string, analyticsId: string, enablePrefill: boolean | null, text: string | null, leftIcon: { __typename: 'IconReferenceRecord', name: string } | null, rightIcon: { __typename: 'IconReferenceRecord', name: string } | null, product: { __typename: 'InsuranceProductRecord', slug: string, externalProvider: string | null, productCode: DatoJsonField, targetGroup: { __typename: 'TargetGroupRecord', id: string, slug: string } | null, productFamily: { __typename: 'InsuranceProductFamilyRecord', id: string, slug: string } } | null }> }, linkedProduct: { __typename: 'InsuranceProductRecord', id: string, name: string, slug: string, productCode: DatoJsonField, productName: DatoJsonField, externalProvider: string | null, showContactForm: boolean | null, showTariffCalculator: boolean | null, showMenu: boolean | null, isOnlineApplication: boolean | null, sendinblueFormUrl: string | null, demoFormSlug: string | null, messageFormSlug: string | null, callbackFormSlug: string | null, productGroupName: string | null, productGroupDescription: string | null, contact: { __typename: 'ContactRecord', id: string, name: string, availability: string, phoneNumber: string, email: string, modalText: string | null, text: string | null } | null, targetGroup: { __typename: 'TargetGroupRecord', id: string, name: string, slug: string, showContactForm: boolean | null, sendinblueFormUrl: string | null, demoFormSlug: string | null, messageFormSlug: string | null, callbackFormSlug: string | null, contact: { __typename: 'ContactRecord', id: string, name: string, availability: string, phoneNumber: string, email: string, modalText: string | null, text: string | null } } | null, currentVersion: { __typename: 'InsuranceProductVersionRecord', price: number | null, priceDescription: string | null, productDescription: string, overviewFacts: { __typename: 'InsuranceProductVersionModelOverviewFactsField', value: DatoJsonField } | null }, image: { __typename: 'FileField', _updatedAt: any, url: string, format: string, alt: string | null, width: number | null, height: number | null, responsiveImage: { __typename: 'ResponsiveImage', aspectRatio: number, alt: string | null, base64: string | null, height: number, src: string, title: string | null, width: number } | null } | null, productFamily: { __typename: 'InsuranceProductFamilyRecord', name: string, slug: string, color: { __typename: 'ColorField', hex: string } } } | null }> } };

export type ModularContentCustomerReviewsSectionFragment = { __typename: 'CustomerReviewsSectionRecord', id: string, title: string, reviews: Array<{ __typename: 'CustomerReviewRecord', id: string, name: string, role: string | null, quote: string, photo: { __typename: 'FileField', _updatedAt: any, url: string, format: string, alt: string | null, width: number | null, height: number | null, responsiveImage: { __typename: 'ResponsiveImage', aspectRatio: number, alt: string | null, base64: string | null, height: number, src: string, title: string | null, width: number } | null } }> };

export type ModularContentCtaSectionFragment = { __typename: 'CtaSectionRecord', id: string, title: string, description: string | null, linkButtons: Array<{ __typename: 'InlineLinkButtonRecord', id: string, url: string | null, label: string, linkType: string, linkStyle: string, jumpMark: string | null, analyticsId: string, text: string | null, title: string | null, internal: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | { __typename: 'PageRecord', slug: string } | null, leftIcon: { __typename: 'IconReferenceRecord', name: string } | null, rightIcon: { __typename: 'IconReferenceRecord', name: string } | null } | { __typename: 'InlineModalButtonRecord', id: string, label: string, linkStyle: string, modalName: string, analyticsId: string, enablePrefill: boolean | null, text: string | null, leftIcon: { __typename: 'IconReferenceRecord', name: string } | null, rightIcon: { __typename: 'IconReferenceRecord', name: string } | null, product: { __typename: 'InsuranceProductRecord', slug: string, externalProvider: string | null, productCode: DatoJsonField, targetGroup: { __typename: 'TargetGroupRecord', id: string, slug: string } | null, productFamily: { __typename: 'InsuranceProductFamilyRecord', id: string, slug: string } } | null }> };

export type ModularContentContactSectionFragment = { __typename: 'ContactSectionRecord', id: string, title: string, subtitle: string, contact: { __typename: 'ContactRecord', id: string, name: string, availability: string, phoneNumber: string, email: string, modalText: string | null, text: string | null } };

export type ModularContentDemoSectionFragment = { __typename: 'DemoSectionRecord', id: string, title: string, subtitle: string, demoText: string, contact: { __typename: 'ContactRecord', id: string, name: string, availability: string, phoneNumber: string, email: string, modalText: string | null, text: string | null } };

export type ModularContentVideoCollectionFragment = { __typename: 'VideoCollectionRecord', id: string, text: { __typename: 'VideoCollectionModelIntroField', value: DatoJsonField, links: Array<string>, blocks: Array<{ __typename: 'InlineAssetRecord', id: string, limitWidth: string | null, asset: { __typename: 'FileField', _updatedAt: any, url: string, format: string, alt: string | null, basename: string, width: number | null, height: number | null, video: { __typename: 'UploadVideoField', streamingUrl: string, thumbnailUrl: string } | null, responsiveImage: { __typename: 'ResponsiveImage', aspectRatio: number, alt: string | null, base64: string | null, height: number, src: string, title: string | null, width: number } | null } } | { __typename: 'InlineLinkButtonRecord', id: string, url: string | null, label: string, linkType: string, linkStyle: string, jumpMark: string | null, analyticsId: string, text: string | null, title: string | null, internal: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | { __typename: 'PageRecord', slug: string } | null, leftIcon: { __typename: 'IconReferenceRecord', name: string } | null, rightIcon: { __typename: 'IconReferenceRecord', name: string } | null } | { __typename: 'InlineModalButtonRecord', id: string, label: string, linkStyle: string, modalName: string, analyticsId: string, enablePrefill: boolean | null, text: string | null, leftIcon: { __typename: 'IconReferenceRecord', name: string } | null, rightIcon: { __typename: 'IconReferenceRecord', name: string } | null, product: { __typename: 'InsuranceProductRecord', slug: string, externalProvider: string | null, productCode: DatoJsonField, targetGroup: { __typename: 'TargetGroupRecord', id: string, slug: string } | null, productFamily: { __typename: 'InsuranceProductFamilyRecord', id: string, slug: string } } | null }> } | null, columns: Array<{ __typename: 'VideoCollectionColumnRecord', id: string, title: string, items: Array<{ __typename: 'VideoCollectionItemRecord', id: string, subline: string | null, title: string, thumbnail: { __typename: 'FileField', _updatedAt: any, url: string, format: string, alt: string | null, width: number | null, height: number | null, responsiveImage: { __typename: 'ResponsiveImage', aspectRatio: number, alt: string | null, base64: string | null, height: number, src: string, title: string | null, width: number } | null } | null, video: { __typename: 'VideoFileField', video: { __typename: 'UploadVideoField', streamingUrl: string, thumbnailUrl: string } } }> }> };

export type ModularContentFunctionalityCollectionFragment = { __typename: 'FunctionalityCollectionRecord', id: string, text: { __typename: 'FunctionalityCollectionModelIntroField', value: DatoJsonField, links: Array<string>, blocks: Array<{ __typename: 'InlineAssetRecord', id: string, limitWidth: string | null, asset: { __typename: 'FileField', _updatedAt: any, url: string, format: string, alt: string | null, basename: string, width: number | null, height: number | null, video: { __typename: 'UploadVideoField', streamingUrl: string, thumbnailUrl: string } | null, responsiveImage: { __typename: 'ResponsiveImage', aspectRatio: number, alt: string | null, base64: string | null, height: number, src: string, title: string | null, width: number } | null } } | { __typename: 'InlineLinkButtonRecord', id: string, url: string | null, label: string, linkType: string, linkStyle: string, jumpMark: string | null, analyticsId: string, text: string | null, title: string | null, internal: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | { __typename: 'PageRecord', slug: string } | null, leftIcon: { __typename: 'IconReferenceRecord', name: string } | null, rightIcon: { __typename: 'IconReferenceRecord', name: string } | null }> } | null, columns: Array<{ __typename: 'FunctionalityCollectionColumnRecord', id: string, title: string, items: Array<{ __typename: 'FunctionalityCollectionItemRecord', title: string, id: string, text: string }> }> };

export type ModularContentNewsletterSectionFragment = { __typename: 'NewsletterSectionRecord', id: string, topContent: { __typename: 'NewsletterSectionModelTopContentField', blocks: Array<string>, links: Array<string>, value: DatoJsonField }, bottomContent: { __typename: 'NewsletterSectionModelBottomContentField', blocks: Array<string>, links: Array<string>, value: DatoJsonField } };

export type ModularContentFlipperSectionFragment = { __typename: 'FlipperSectionRecord', id: string, pageLimitMobile: number, text: { __typename: 'FlipperSectionModelIntroField', value: DatoJsonField, links: Array<string>, blocks: Array<{ __typename: 'InlineAssetRecord', id: string, limitWidth: string | null, asset: { __typename: 'FileField', _updatedAt: any, url: string, format: string, alt: string | null, basename: string, width: number | null, height: number | null, video: { __typename: 'UploadVideoField', streamingUrl: string, thumbnailUrl: string } | null, responsiveImage: { __typename: 'ResponsiveImage', aspectRatio: number, alt: string | null, base64: string | null, height: number, src: string, title: string | null, width: number } | null } } | { __typename: 'InlineLinkButtonRecord', id: string, url: string | null, label: string, linkType: string, linkStyle: string, jumpMark: string | null, analyticsId: string, text: string | null, title: string | null, internal: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | { __typename: 'PageRecord', slug: string } | null, leftIcon: { __typename: 'IconReferenceRecord', name: string } | null, rightIcon: { __typename: 'IconReferenceRecord', name: string } | null }> } | null, flippers: Array<{ __typename: 'FlipperRecord', text: string, title: string, id: string, icon: { __typename: 'FileField', _updatedAt: any, url: string, format: string, alt: string | null, width: number | null, height: number | null, responsiveImage: { __typename: 'ResponsiveImage', aspectRatio: number, alt: string | null, base64: string | null, height: number, src: string, title: string | null, width: number } | null } }> };

export type BreadcrumbFragment = { __typename: 'BreadcrumbRecord', name: string, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } };

export type HeaderFragment = { __typename: 'HeaderRecord', headerLogo: { __typename: 'FileField', _updatedAt: any, url: string, format: string, alt: string | null, width: number | null, height: number | null, responsiveImage: { __typename: 'ResponsiveImage', aspectRatio: number, alt: string | null, base64: string | null, height: number, src: string, title: string | null, width: number } | null } | null, links: Array<{ __typename: 'HeaderDropdownRecord', label: string, analyticsId: string, dropdownItems: Array<{ __typename: 'FamilyHeaderItemRecord', id: string, family: { __typename: 'InsuranceProductFamilyRecord', id: string, name: string, slug: string, color: { __typename: 'ColorField', hex: string } }, products: Array<{ __typename: 'ProductHeaderItemRecord', id: string, label: string | null, link: { __typename: 'InsuranceProductFamilyRecord', id: string, name: string, slug: string } | { __typename: 'InsuranceProductRecord', id: string, name: string, slug: string, currentVersion: { __typename: 'InsuranceProductVersionRecord', externalLink: string | null } } | { __typename: 'PageRecord', id: string, name: string, slug: string }, targetGroups: Array<{ __typename: 'TargetGroupHeaderItemRecord', id: string, label: string | null, link: { __typename: 'InsuranceProductFamilyRecord', id: string, name: string, slug: string } | { __typename: 'PageRecord', id: string, name: string, slug: string } | { __typename: 'TargetGroupRecord', id: string, name: string, slug: string } }> }> } | { __typename: 'HeaderItemRecord', id: string, page: { __typename: 'PageRecord', id: string, name: string, slug: string } }> } | { __typename: 'InlineLinkButtonRecord', id: string, url: string | null, label: string, linkType: string, linkStyle: string, jumpMark: string | null, analyticsId: string, text: string | null, title: string | null, internal: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | { __typename: 'PageRecord', slug: string } | null, leftIcon: { __typename: 'IconReferenceRecord', name: string } | null, rightIcon: { __typename: 'IconReferenceRecord', name: string } | null } | { __typename: 'InlineModalButtonRecord', id: string, label: string, linkStyle: string, modalName: string, analyticsId: string, enablePrefill: boolean | null, text: string | null, leftIcon: { __typename: 'IconReferenceRecord', name: string } | null, rightIcon: { __typename: 'IconReferenceRecord', name: string } | null, product: { __typename: 'InsuranceProductRecord', slug: string, externalProvider: string | null, productCode: DatoJsonField, targetGroup: { __typename: 'TargetGroupRecord', id: string, slug: string } | null, productFamily: { __typename: 'InsuranceProductFamilyRecord', id: string, slug: string } } | null }> };

export type OnboardingFragment = { __typename: 'OnboardingRecord', slides: Array<{ __typename: 'OnboardingSlideRecord', id: string, title: string, text: string, image: { __typename: 'FileField', _updatedAt: any, url: string, format: string, alt: string | null, width: number | null, height: number | null, responsiveImage: { __typename: 'ResponsiveImage', aspectRatio: number, alt: string | null, base64: string | null, height: number, src: string, title: string | null, width: number } | null } }> };

export type ModularContentNavigationSectionFragment = { __typename: 'NavigationSectionRecord', id: string, links: Array<{ __typename: 'InlineLinkButtonRecord', id: string, url: string | null, label: string, linkType: string, linkStyle: string, jumpMark: string | null, analyticsId: string, text: string | null, title: string | null, internal: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | { __typename: 'PageRecord', slug: string } | null, leftIcon: { __typename: 'IconReferenceRecord', name: string } | null, rightIcon: { __typename: 'IconReferenceRecord', name: string } | null }> };

export type ModularContentLinkCardsSectionFragment = { __typename: 'LinkCardsSectionRecord', id: string, cards: Array<{ __typename: 'LinkCardRecord', id: string, title: string, variant: string, image: { __typename: 'FileField', _updatedAt: any, url: string, format: string, alt: string | null, width: number | null, height: number | null, responsiveImage: { __typename: 'ResponsiveImage', aspectRatio: number, alt: string | null, base64: string | null, height: number, src: string, title: string | null, width: number } | null }, links: Array<{ __typename: 'InlineLinkButtonRecord', id: string, url: string | null, label: string, linkType: string, linkStyle: string, jumpMark: string | null, analyticsId: string, text: string | null, title: string | null, internal: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | { __typename: 'PageRecord', slug: string } | null, leftIcon: { __typename: 'IconReferenceRecord', name: string } | null, rightIcon: { __typename: 'IconReferenceRecord', name: string } | null }> }> };

export type EmailFragment = { __typename: 'EmailRecord', id: string, email: string };

export type HeadingFragment = { __typename: 'HeadingRecord', id: string, left: string, right: string };

export type ClaimModalFragment = { __typename: 'ClaimModalRecord', title: string | null, text: Array<{ __typename: 'ClaimTextRecord', variant: string | null, text: { __typename: 'ClaimTextModelTextField', value: DatoJsonField, blocks: Array<{ __typename: 'EmailRecord', id: string, email: string } | { __typename: 'HeadingRecord', id: string, left: string, right: string }> } }>, types: Array<{ __typename: 'ClaimTypeRecord', name: string, icon: { __typename: 'IconReferenceRecord', name: string } }> };

export type ModularContentVideoSectionFragment = { __typename: 'VideoSectionRecord', id: string, topline: string | null, fullBleed: boolean | null, topic: string | null, variant: string, introTitle: string | null, button: { __typename: 'InlineLinkButtonRecord', id: string, url: string | null, label: string, linkType: string, linkStyle: string, jumpMark: string | null, analyticsId: string, text: string | null, title: string | null, internal: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | { __typename: 'PageRecord', slug: string } | null, leftIcon: { __typename: 'IconReferenceRecord', name: string } | null, rightIcon: { __typename: 'IconReferenceRecord', name: string } | null } | { __typename: 'InlineModalButtonRecord', id: string, label: string, linkStyle: string, modalName: string, analyticsId: string, enablePrefill: boolean | null, text: string | null, leftIcon: { __typename: 'IconReferenceRecord', name: string } | null, rightIcon: { __typename: 'IconReferenceRecord', name: string } | null, product: { __typename: 'InsuranceProductRecord', slug: string, externalProvider: string | null, productCode: DatoJsonField, targetGroup: { __typename: 'TargetGroupRecord', id: string, slug: string } | null, productFamily: { __typename: 'InsuranceProductFamilyRecord', id: string, slug: string } } | null } | null, asset: { __typename: 'FileField', _updatedAt: any, url: string, format: string, alt: string | null, width: number | null, height: number | null, responsiveImage: { __typename: 'ResponsiveImage', aspectRatio: number, alt: string | null, base64: string | null, height: number, src: string, title: string | null, width: number } | null, video: { __typename: 'UploadVideoField', streamingUrl: string, thumbnailUrl: string } | null }, topicSubline: { __typename: 'VideoSectionModelTopicSublineField', value: DatoJsonField, blocks: Array<{ __typename: 'InlineLinkButtonRecord', id: string, url: string | null, label: string, linkType: string, linkStyle: string, jumpMark: string | null, analyticsId: string, text: string | null, title: string | null, internal: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | { __typename: 'PageRecord', slug: string } | null, leftIcon: { __typename: 'IconReferenceRecord', name: string } | null, rightIcon: { __typename: 'IconReferenceRecord', name: string } | null } | { __typename: 'InlineModalButtonRecord', id: string, label: string, linkStyle: string, modalName: string, analyticsId: string, enablePrefill: boolean | null, text: string | null, leftIcon: { __typename: 'IconReferenceRecord', name: string } | null, rightIcon: { __typename: 'IconReferenceRecord', name: string } | null, product: { __typename: 'InsuranceProductRecord', slug: string, externalProvider: string | null, productCode: DatoJsonField, targetGroup: { __typename: 'TargetGroupRecord', id: string, slug: string } | null, productFamily: { __typename: 'InsuranceProductFamilyRecord', id: string, slug: string } } | null }> } | null, topicText: { __typename: 'VideoSectionModelTextField', value: DatoJsonField, blocks: Array<{ __typename: 'InlineLinkButtonRecord', id: string, url: string | null, label: string, linkType: string, linkStyle: string, jumpMark: string | null, analyticsId: string, text: string | null, title: string | null, internal: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | { __typename: 'PageRecord', slug: string } | null, leftIcon: { __typename: 'IconReferenceRecord', name: string } | null, rightIcon: { __typename: 'IconReferenceRecord', name: string } | null } | { __typename: 'InlineModalButtonRecord', id: string, label: string, linkStyle: string, modalName: string, analyticsId: string, enablePrefill: boolean | null, text: string | null, leftIcon: { __typename: 'IconReferenceRecord', name: string } | null, rightIcon: { __typename: 'IconReferenceRecord', name: string } | null, product: { __typename: 'InsuranceProductRecord', slug: string, externalProvider: string | null, productCode: DatoJsonField, targetGroup: { __typename: 'TargetGroupRecord', id: string, slug: string } | null, productFamily: { __typename: 'InsuranceProductFamilyRecord', id: string, slug: string } } | null }> }, persona: { __typename: 'VideoSectionPersonaRecord', id: string, title: string, icon: { __typename: 'FileField', _updatedAt: any, url: string, format: string, alt: string | null, width: number | null, height: number | null }, text: { __typename: 'VideoSectionPersonaModelTextField', value: DatoJsonField, blocks: Array<{ __typename: 'InlineLinkButtonRecord', id: string, url: string | null, label: string, linkType: string, linkStyle: string, jumpMark: string | null, analyticsId: string, text: string | null, title: string | null, internal: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | { __typename: 'PageRecord', slug: string } | null, leftIcon: { __typename: 'IconReferenceRecord', name: string } | null, rightIcon: { __typename: 'IconReferenceRecord', name: string } | null } | { __typename: 'InlineModalButtonRecord', id: string, label: string, linkStyle: string, modalName: string, analyticsId: string, enablePrefill: boolean | null, text: string | null, leftIcon: { __typename: 'IconReferenceRecord', name: string } | null, rightIcon: { __typename: 'IconReferenceRecord', name: string } | null, product: { __typename: 'InsuranceProductRecord', slug: string, externalProvider: string | null, productCode: DatoJsonField, targetGroup: { __typename: 'TargetGroupRecord', id: string, slug: string } | null, productFamily: { __typename: 'InsuranceProductFamilyRecord', id: string, slug: string } } | null }> } } | null };

export type VideoSectionPersonaFragment = { __typename: 'VideoSectionPersonaRecord', id: string, title: string, icon: { __typename: 'FileField', _updatedAt: any, url: string, format: string, alt: string | null, width: number | null, height: number | null }, text: { __typename: 'VideoSectionPersonaModelTextField', value: DatoJsonField, blocks: Array<{ __typename: 'InlineLinkButtonRecord', id: string, url: string | null, label: string, linkType: string, linkStyle: string, jumpMark: string | null, analyticsId: string, text: string | null, title: string | null, internal: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | { __typename: 'PageRecord', slug: string } | null, leftIcon: { __typename: 'IconReferenceRecord', name: string } | null, rightIcon: { __typename: 'IconReferenceRecord', name: string } | null } | { __typename: 'InlineModalButtonRecord', id: string, label: string, linkStyle: string, modalName: string, analyticsId: string, enablePrefill: boolean | null, text: string | null, leftIcon: { __typename: 'IconReferenceRecord', name: string } | null, rightIcon: { __typename: 'IconReferenceRecord', name: string } | null, product: { __typename: 'InsuranceProductRecord', slug: string, externalProvider: string | null, productCode: DatoJsonField, targetGroup: { __typename: 'TargetGroupRecord', id: string, slug: string } | null, productFamily: { __typename: 'InsuranceProductFamilyRecord', id: string, slug: string } } | null }> } };

export type ModularContentServiceOverviewSectionFragment = { __typename: 'ServiceOverviewSectionRecord', id: string, title: string, items: Array<{ __typename: 'ServiceOverviewSectionItemRecord', id: string, service: string, description: { __typename: 'ServiceOverviewSectionItemModelDescriptionField', blocks: Array<string>, inlineBlocks: Array<string>, links: Array<string>, value: DatoJsonField } }> };

export type ModularContentActionTeaserSectionFragment = { __typename: 'ActionTeaserSectionRecord', id: string, title: string, subtitle: string, items: Array<{ __typename: 'ActionTeaserSectionItemRecord', id: string, label: string, image: { __typename: 'FileField', _updatedAt: any, url: string, format: string, alt: string | null, width: number | null, height: number | null, responsiveImage: { __typename: 'ResponsiveImage', aspectRatio: number, alt: string | null, base64: string | null, height: number, src: string, title: string | null, width: number } | null } }>, modalButton: { __typename: 'InlineModalButtonRecord', id: string, label: string, linkStyle: string, modalName: string, analyticsId: string, enablePrefill: boolean | null, text: string | null, leftIcon: { __typename: 'IconReferenceRecord', name: string } | null, rightIcon: { __typename: 'IconReferenceRecord', name: string } | null, product: { __typename: 'InsuranceProductRecord', slug: string, externalProvider: string | null, productCode: DatoJsonField, targetGroup: { __typename: 'TargetGroupRecord', id: string, slug: string } | null, productFamily: { __typename: 'InsuranceProductFamilyRecord', id: string, slug: string } } | null } };

export type GetInsuranceVersionTextByProductIdQueryVariables = Exact<{
  id: Scalars['ItemId']['input'];
  locale: SiteLocale;
}>;


export type GetInsuranceVersionTextByProductIdQuery = { __typename: 'Query', insuranceProduct: { __typename: 'InsuranceProductRecord', version: { __typename: 'InsuranceProductVersionRecord', price: number | null, externalClaimLink: string | null, text: { __typename: 'InsuranceProductVersionModelCoverageTextField', value: DatoJsonField, blocks: Array<{ __typename: 'InlineAssetRecord', id: string, limitWidth: string | null, asset: { __typename: 'FileField', _updatedAt: any, url: string, format: string, alt: string | null, basename: string, width: number | null, height: number | null, video: { __typename: 'UploadVideoField', streamingUrl: string, thumbnailUrl: string } | null, responsiveImage: { __typename: 'ResponsiveImage', aspectRatio: number, alt: string | null, base64: string | null, height: number, src: string, title: string | null, width: number } | null } } | { __typename: 'InlineLinkButtonRecord', id: string, url: string | null, label: string, linkType: string, linkStyle: string, jumpMark: string | null, analyticsId: string, text: string | null, title: string | null, internal: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | { __typename: 'PageRecord', slug: string } | null, leftIcon: { __typename: 'IconReferenceRecord', name: string } | null, rightIcon: { __typename: 'IconReferenceRecord', name: string } | null } | { __typename: 'InlineModalButtonRecord', id: string, label: string, linkStyle: string, modalName: string, analyticsId: string, enablePrefill: boolean | null, text: string | null, leftIcon: { __typename: 'IconReferenceRecord', name: string } | null, rightIcon: { __typename: 'IconReferenceRecord', name: string } | null, product: { __typename: 'InsuranceProductRecord', slug: string, externalProvider: string | null, productCode: DatoJsonField, targetGroup: { __typename: 'TargetGroupRecord', id: string, slug: string } | null, productFamily: { __typename: 'InsuranceProductFamilyRecord', id: string, slug: string } } | null }> } } } | null };

export type GetAllInsuranceProductsForPortalQueryVariables = Exact<{
  locale: SiteLocale;
}>;


export type GetAllInsuranceProductsForPortalQuery = { __typename: 'Query', allInsuranceProducts: Array<{ __typename: 'InsuranceProductRecord', id: string, name: string, slug: string, insurer: string, productCode: DatoJsonField, productName: DatoJsonField, embedUrl: DatoJsonField, userActions: DatoJsonField, externalProvider: string | null, showContactForm: boolean | null, showTariffCalculator: boolean | null, showMenu: boolean | null, isOnlineApplication: boolean | null, sendinblueFormUrl: string | null, demoFormSlug: string | null, messageFormSlug: string | null, callbackFormSlug: string | null, contact: { __typename: 'ContactRecord', id: string, name: string, availability: string, phoneNumber: string, email: string, modalText: string | null, text: string | null } | null, targetGroup: { __typename: 'TargetGroupRecord', id: string, name: string, slug: string, tagline: string | null, showContactForm: boolean | null, demoFormSlug: string | null, messageFormSlug: string | null, callbackFormSlug: string | null, sendinblueFormUrl: string | null, contact: { __typename: 'ContactRecord', id: string, name: string, availability: string, phoneNumber: string, email: string, modalText: string | null, text: string | null } } | null, _seoMetaTags: Array<{ __typename: 'Tag', attributes: any | null, content: string | null, tag: string }>, seo: { __typename: 'SeoField', description: string | null, title: string | null, twitterCard: string | null } | null, currentVersion: { __typename: 'InsuranceProductVersionRecord', price: number | null }, productFamily: { __typename: 'InsuranceProductFamilyRecord', slug: string, color: { __typename: 'ColorField', hex: string } } }> };

export type GetInsuranceProductsByTargetGroupQueryVariables = Exact<{
  targetGroupId: Scalars['ItemId']['input'];
  locale: SiteLocale;
}>;


export type GetInsuranceProductsByTargetGroupQuery = { __typename: 'Query', allInsuranceProducts: Array<{ __typename: 'InsuranceProductRecord', name: string, productCode: DatoJsonField, productName: DatoJsonField, slug: string, currentVersion: { __typename: 'InsuranceProductVersionRecord', productDescription: string, priceDescription: string | null, price: number | null } }> };

export type GetAllInsuranceProductsQueryVariables = Exact<{
  locale: SiteLocale;
}>;


export type GetAllInsuranceProductsQuery = { __typename: 'Query', allInsuranceProducts: Array<{ __typename: 'InsuranceProductRecord', id: string, name: string, slug: string, productCode: DatoJsonField, productName: DatoJsonField, sendinblueFormUrl: string | null, showContactForm: boolean | null, showTariffCalculator: boolean | null, showMenu: boolean | null, isOnlineApplication: boolean | null, demoFormSlug: string | null, messageFormSlug: string | null, callbackFormSlug: string | null, productGroupName: string | null, productGroupDescription: string | null, externalProvider: string | null, productFamily: { __typename: 'InsuranceProductFamilyRecord', name: string, slug: string, color: { __typename: 'ColorField', hex: string } }, contact: { __typename: 'ContactRecord', id: string, name: string, availability: string, phoneNumber: string, email: string, modalText: string | null, text: string | null } | null, targetGroup: { __typename: 'TargetGroupRecord', id: string, name: string, slug: string, sendinblueFormUrl: string | null, showContactForm: boolean | null, demoFormSlug: string | null, messageFormSlug: string | null, callbackFormSlug: string | null, contact: { __typename: 'ContactRecord', id: string, name: string, availability: string, phoneNumber: string, email: string, modalText: string | null, text: string | null } } | null, currentVersion: { __typename: 'InsuranceProductVersionRecord', price: number | null, priceDescription: string | null, productDescription: string, externalLink: string | null, externalLinkText: string | null, overviewFacts: { __typename: 'InsuranceProductVersionModelOverviewFactsField', value: DatoJsonField } | null }, image: { __typename: 'FileField', _updatedAt: any, url: string, format: string, alt: string | null, width: number | null, height: number | null, responsiveImage: { __typename: 'ResponsiveImage', aspectRatio: number, alt: string | null, base64: string | null, height: number, src: string, title: string | null, width: number } | null } | null }> };

export type GetInsuranceProductsByFamilyIdQueryVariables = Exact<{
  familyId: Scalars['ItemId']['input'];
  locale: SiteLocale;
}>;


export type GetInsuranceProductsByFamilyIdQuery = { __typename: 'Query', allInsuranceProducts: Array<{ __typename: 'InsuranceProductRecord', id: string, name: string, slug: string, productCode: DatoJsonField, productName: DatoJsonField, externalProvider: string | null, showContactForm: boolean | null, showTariffCalculator: boolean | null, showMenu: boolean | null, isOnlineApplication: boolean | null, sendinblueFormUrl: string | null, demoFormSlug: string | null, messageFormSlug: string | null, callbackFormSlug: string | null, productGroupName: string | null, productGroupDescription: string | null, contact: { __typename: 'ContactRecord', id: string, name: string, availability: string, phoneNumber: string, email: string, modalText: string | null, text: string | null } | null, targetGroup: { __typename: 'TargetGroupRecord', id: string, name: string, slug: string, showContactForm: boolean | null, sendinblueFormUrl: string | null, demoFormSlug: string | null, messageFormSlug: string | null, callbackFormSlug: string | null, contact: { __typename: 'ContactRecord', id: string, name: string, availability: string, phoneNumber: string, email: string, modalText: string | null, text: string | null } } | null, currentVersion: { __typename: 'InsuranceProductVersionRecord', price: number | null, priceDescription: string | null, productDescription: string, externalLink: string | null, externalLinkText: string | null, overviewFacts: { __typename: 'InsuranceProductVersionModelOverviewFactsField', value: DatoJsonField } | null }, image: { __typename: 'FileField', _updatedAt: any, url: string, format: string, alt: string | null, width: number | null, height: number | null, responsiveImage: { __typename: 'ResponsiveImage', aspectRatio: number, alt: string | null, base64: string | null, height: number, src: string, title: string | null, width: number } | null } | null, productFamily: { __typename: 'InsuranceProductFamilyRecord', name: string, slug: string, color: { __typename: 'ColorField', hex: string } } }> };

export type GetInsuranceProductsBySlugQueryVariables = Exact<{
  slugs: Array<Scalars['String']['input']> | Scalars['String']['input'];
  locale: SiteLocale;
}>;


export type GetInsuranceProductsBySlugQuery = { __typename: 'Query', allInsuranceProducts: Array<{ __typename: 'InsuranceProductRecord', id: string, name: string, slug: string, productCode: DatoJsonField, productName: DatoJsonField, externalProvider: string | null, showContactForm: boolean | null, showTariffCalculator: boolean | null, showMenu: boolean | null, isOnlineApplication: boolean | null, sendinblueFormUrl: string | null, demoFormSlug: string | null, messageFormSlug: string | null, callbackFormSlug: string | null, productGroupName: string | null, productGroupDescription: string | null, contact: { __typename: 'ContactRecord', id: string, name: string, availability: string, phoneNumber: string, email: string, modalText: string | null, text: string | null } | null, targetGroup: { __typename: 'TargetGroupRecord', id: string, name: string, slug: string, showContactForm: boolean | null, sendinblueFormUrl: string | null, demoFormSlug: string | null, messageFormSlug: string | null, callbackFormSlug: string | null, contact: { __typename: 'ContactRecord', id: string, name: string, availability: string, phoneNumber: string, email: string, modalText: string | null, text: string | null } } | null, currentVersion: { __typename: 'InsuranceProductVersionRecord', price: number | null, priceDescription: string | null, productDescription: string, externalLink: string | null, externalLinkText: string | null, overviewFacts: { __typename: 'InsuranceProductVersionModelOverviewFactsField', value: DatoJsonField } | null }, image: { __typename: 'FileField', _updatedAt: any, url: string, format: string, alt: string | null, width: number | null, height: number | null, responsiveImage: { __typename: 'ResponsiveImage', aspectRatio: number, alt: string | null, base64: string | null, height: number, src: string, title: string | null, width: number } | null } | null, productFamily: { __typename: 'InsuranceProductFamilyRecord', name: string, slug: string, color: { __typename: 'ColorField', hex: string } } }> };

export type GetAllInsuranceProductsForPremiumCalcQueryVariables = Exact<{
  locale: SiteLocale;
  brandSlug: Scalars['String']['input'];
}>;


export type GetAllInsuranceProductsForPremiumCalcQuery = { __typename: 'Query', allBrands: Array<{ __typename: 'BrandRecord', _allReferencingInsuranceProducts: Array<{ __typename: 'InsuranceProductRecord', id: string, name: string, slug: string, productCode: DatoJsonField, productName: DatoJsonField, embedUrl: DatoJsonField, externalProvider: string | null, disabled: boolean | null, sendinblueFormUrl: string | null, showContactForm: boolean | null, showTariffCalculator: boolean | null, showMenu: boolean | null, isOnlineApplication: boolean | null, demoFormSlug: string | null, messageFormSlug: string | null, callbackFormSlug: string | null, productGroupName: string | null, productGroupDescription: string | null, contact: { __typename: 'ContactRecord', id: string, name: string, availability: string, phoneNumber: string, email: string, modalText: string | null, text: string | null } | null, productFamily: { __typename: 'InsuranceProductFamilyRecord', name: string, slug: string, color: { __typename: 'ColorField', hex: string } }, targetGroup: { __typename: 'TargetGroupRecord', id: string, name: string, slug: string, tagline: string | null, showContactForm: boolean | null, sendinblueFormUrl: string | null, demoFormSlug: string | null, messageFormSlug: string | null, callbackFormSlug: string | null, contact: { __typename: 'ContactRecord', id: string, name: string, availability: string, phoneNumber: string, email: string, modalText: string | null, text: string | null }, header: { __typename: 'HeaderRecord', headerLogo: { __typename: 'FileField', _updatedAt: any, url: string, format: string, alt: string | null, width: number | null, height: number | null, responsiveImage: { __typename: 'ResponsiveImage', aspectRatio: number, alt: string | null, base64: string | null, height: number, src: string, title: string | null, width: number } | null } | null, links: Array<{ __typename: 'HeaderDropdownRecord', label: string, analyticsId: string, dropdownItems: Array<{ __typename: 'FamilyHeaderItemRecord', id: string, family: { __typename: 'InsuranceProductFamilyRecord', id: string, name: string, slug: string, color: { __typename: 'ColorField', hex: string } }, products: Array<{ __typename: 'ProductHeaderItemRecord', id: string, label: string | null, link: { __typename: 'InsuranceProductFamilyRecord', id: string, name: string, slug: string } | { __typename: 'InsuranceProductRecord', id: string, name: string, slug: string, currentVersion: { __typename: 'InsuranceProductVersionRecord', externalLink: string | null } } | { __typename: 'PageRecord', id: string, name: string, slug: string }, targetGroups: Array<{ __typename: 'TargetGroupHeaderItemRecord', id: string, label: string | null, link: { __typename: 'InsuranceProductFamilyRecord', id: string, name: string, slug: string } | { __typename: 'PageRecord', id: string, name: string, slug: string } | { __typename: 'TargetGroupRecord', id: string, name: string, slug: string } }> }> } | { __typename: 'HeaderItemRecord', id: string, page: { __typename: 'PageRecord', id: string, name: string, slug: string } }> } | { __typename: 'InlineLinkButtonRecord', id: string, url: string | null, label: string, linkType: string, linkStyle: string, jumpMark: string | null, analyticsId: string, text: string | null, title: string | null, internal: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | { __typename: 'PageRecord', slug: string } | null, leftIcon: { __typename: 'IconReferenceRecord', name: string } | null, rightIcon: { __typename: 'IconReferenceRecord', name: string } | null } | { __typename: 'InlineModalButtonRecord', id: string, label: string, linkStyle: string, modalName: string, analyticsId: string, enablePrefill: boolean | null, text: string | null, leftIcon: { __typename: 'IconReferenceRecord', name: string } | null, rightIcon: { __typename: 'IconReferenceRecord', name: string } | null, product: { __typename: 'InsuranceProductRecord', slug: string, externalProvider: string | null, productCode: DatoJsonField, targetGroup: { __typename: 'TargetGroupRecord', id: string, slug: string } | null, productFamily: { __typename: 'InsuranceProductFamilyRecord', id: string, slug: string } } | null }> } | null, _seoMetaTags: Array<{ __typename: 'Tag', attributes: any | null, content: string | null, tag: string }>, breadcrumbs: Array<{ __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } }> } | null, currentVersion: { __typename: 'InsuranceProductVersionRecord', price: number | null, priceDescription: string | null, productDescription: string, externalLink: string | null, externalLinkText: string | null, overviewFacts: { __typename: 'InsuranceProductVersionModelOverviewFactsField', value: DatoJsonField } | null }, image: { __typename: 'FileField', _updatedAt: any, url: string, format: string, alt: string | null, width: number | null, height: number | null, responsiveImage: { __typename: 'ResponsiveImage', aspectRatio: number, alt: string | null, base64: string | null, height: number, src: string, title: string | null, width: number } | null } | null }> }> };

export type GetAllInsuranceProductsForPremiumCalcBySlugQueryVariables = Exact<{
  locale: SiteLocale;
  slug: Scalars['String']['input'];
}>;


export type GetAllInsuranceProductsForPremiumCalcBySlugQuery = { __typename: 'Query', allInsuranceProducts: Array<{ __typename: 'InsuranceProductRecord', id: string, name: string, slug: string, productCode: DatoJsonField, productName: DatoJsonField, embedUrl: DatoJsonField, externalProvider: string | null, disabled: boolean | null, sendinblueFormUrl: string | null, showContactForm: boolean | null, showTariffCalculator: boolean | null, showMenu: boolean | null, isOnlineApplication: boolean | null, demoFormSlug: string | null, messageFormSlug: string | null, callbackFormSlug: string | null, productGroupName: string | null, productGroupDescription: string | null, contact: { __typename: 'ContactRecord', id: string, name: string, availability: string, phoneNumber: string, email: string, modalText: string | null, text: string | null } | null, productFamily: { __typename: 'InsuranceProductFamilyRecord', name: string, slug: string, color: { __typename: 'ColorField', hex: string } }, header: { __typename: 'HeaderRecord', headerLogo: { __typename: 'FileField', _updatedAt: any, url: string, format: string, alt: string | null, width: number | null, height: number | null, responsiveImage: { __typename: 'ResponsiveImage', aspectRatio: number, alt: string | null, base64: string | null, height: number, src: string, title: string | null, width: number } | null } | null, links: Array<{ __typename: 'HeaderDropdownRecord', label: string, analyticsId: string, dropdownItems: Array<{ __typename: 'FamilyHeaderItemRecord', id: string, family: { __typename: 'InsuranceProductFamilyRecord', id: string, name: string, slug: string, color: { __typename: 'ColorField', hex: string } }, products: Array<{ __typename: 'ProductHeaderItemRecord', id: string, label: string | null, link: { __typename: 'InsuranceProductFamilyRecord', id: string, name: string, slug: string } | { __typename: 'InsuranceProductRecord', id: string, name: string, slug: string, currentVersion: { __typename: 'InsuranceProductVersionRecord', externalLink: string | null } } | { __typename: 'PageRecord', id: string, name: string, slug: string }, targetGroups: Array<{ __typename: 'TargetGroupHeaderItemRecord', id: string, label: string | null, link: { __typename: 'InsuranceProductFamilyRecord', id: string, name: string, slug: string } | { __typename: 'PageRecord', id: string, name: string, slug: string } | { __typename: 'TargetGroupRecord', id: string, name: string, slug: string } }> }> } | { __typename: 'HeaderItemRecord', id: string, page: { __typename: 'PageRecord', id: string, name: string, slug: string } }> } | { __typename: 'InlineLinkButtonRecord', id: string, url: string | null, label: string, linkType: string, linkStyle: string, jumpMark: string | null, analyticsId: string, text: string | null, title: string | null, internal: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | { __typename: 'PageRecord', slug: string } | null, leftIcon: { __typename: 'IconReferenceRecord', name: string } | null, rightIcon: { __typename: 'IconReferenceRecord', name: string } | null } | { __typename: 'InlineModalButtonRecord', id: string, label: string, linkStyle: string, modalName: string, analyticsId: string, enablePrefill: boolean | null, text: string | null, leftIcon: { __typename: 'IconReferenceRecord', name: string } | null, rightIcon: { __typename: 'IconReferenceRecord', name: string } | null, product: { __typename: 'InsuranceProductRecord', slug: string, externalProvider: string | null, productCode: DatoJsonField, targetGroup: { __typename: 'TargetGroupRecord', id: string, slug: string } | null, productFamily: { __typename: 'InsuranceProductFamilyRecord', id: string, slug: string } } | null }> } | null, targetGroup: { __typename: 'TargetGroupRecord', id: string, name: string, slug: string, tagline: string | null, showContactForm: boolean | null, sendinblueFormUrl: string | null, demoFormSlug: string | null, messageFormSlug: string | null, callbackFormSlug: string | null, contact: { __typename: 'ContactRecord', id: string, name: string, availability: string, phoneNumber: string, email: string, modalText: string | null, text: string | null }, header: { __typename: 'HeaderRecord', headerLogo: { __typename: 'FileField', _updatedAt: any, url: string, format: string, alt: string | null, width: number | null, height: number | null, responsiveImage: { __typename: 'ResponsiveImage', aspectRatio: number, alt: string | null, base64: string | null, height: number, src: string, title: string | null, width: number } | null } | null, links: Array<{ __typename: 'HeaderDropdownRecord', label: string, analyticsId: string, dropdownItems: Array<{ __typename: 'FamilyHeaderItemRecord', id: string, family: { __typename: 'InsuranceProductFamilyRecord', id: string, name: string, slug: string, color: { __typename: 'ColorField', hex: string } }, products: Array<{ __typename: 'ProductHeaderItemRecord', id: string, label: string | null, link: { __typename: 'InsuranceProductFamilyRecord', id: string, name: string, slug: string } | { __typename: 'InsuranceProductRecord', id: string, name: string, slug: string, currentVersion: { __typename: 'InsuranceProductVersionRecord', externalLink: string | null } } | { __typename: 'PageRecord', id: string, name: string, slug: string }, targetGroups: Array<{ __typename: 'TargetGroupHeaderItemRecord', id: string, label: string | null, link: { __typename: 'InsuranceProductFamilyRecord', id: string, name: string, slug: string } | { __typename: 'PageRecord', id: string, name: string, slug: string } | { __typename: 'TargetGroupRecord', id: string, name: string, slug: string } }> }> } | { __typename: 'HeaderItemRecord', id: string, page: { __typename: 'PageRecord', id: string, name: string, slug: string } }> } | { __typename: 'InlineLinkButtonRecord', id: string, url: string | null, label: string, linkType: string, linkStyle: string, jumpMark: string | null, analyticsId: string, text: string | null, title: string | null, internal: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | { __typename: 'PageRecord', slug: string } | null, leftIcon: { __typename: 'IconReferenceRecord', name: string } | null, rightIcon: { __typename: 'IconReferenceRecord', name: string } | null } | { __typename: 'InlineModalButtonRecord', id: string, label: string, linkStyle: string, modalName: string, analyticsId: string, enablePrefill: boolean | null, text: string | null, leftIcon: { __typename: 'IconReferenceRecord', name: string } | null, rightIcon: { __typename: 'IconReferenceRecord', name: string } | null, product: { __typename: 'InsuranceProductRecord', slug: string, externalProvider: string | null, productCode: DatoJsonField, targetGroup: { __typename: 'TargetGroupRecord', id: string, slug: string } | null, productFamily: { __typename: 'InsuranceProductFamilyRecord', id: string, slug: string } } | null }> } | null, _seoMetaTags: Array<{ __typename: 'Tag', attributes: any | null, content: string | null, tag: string }>, breadcrumbs: Array<{ __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } }> } | null, currentVersion: { __typename: 'InsuranceProductVersionRecord', price: number | null, priceDescription: string | null, productDescription: string, externalLink: string | null, externalLinkText: string | null, overviewFacts: { __typename: 'InsuranceProductVersionModelOverviewFactsField', value: DatoJsonField } | null }, image: { __typename: 'FileField', _updatedAt: any, url: string, format: string, alt: string | null, width: number | null, height: number | null, responsiveImage: { __typename: 'ResponsiveImage', aspectRatio: number, alt: string | null, base64: string | null, height: number, src: string, title: string | null, width: number } | null } | null }> };

export type GetTargetGroupBySlugQueryVariables = Exact<{
  locale: SiteLocale;
  targetGroupSlug: Scalars['String']['input'];
}>;


export type GetTargetGroupBySlugQuery = { __typename: 'Query', targetGroup: { __typename: 'TargetGroupRecord', id: string, name: string, slug: string, tagline: string | null, showContactForm: boolean | null, sendinblueFormUrl: string | null, demoFormSlug: string | null, messageFormSlug: string | null, callbackFormSlug: string | null, allSlugLocales: Array<{ __typename: 'StringNonNullMultiLocaleField', locale: SiteLocale | null, value: string }> | null, contact: { __typename: 'ContactRecord', id: string, name: string, availability: string, phoneNumber: string, email: string, modalText: string | null, text: string | null }, header: { __typename: 'HeaderRecord', headerLogo: { __typename: 'FileField', _updatedAt: any, url: string, format: string, alt: string | null, width: number | null, height: number | null, responsiveImage: { __typename: 'ResponsiveImage', aspectRatio: number, alt: string | null, base64: string | null, height: number, src: string, title: string | null, width: number } | null } | null, links: Array<{ __typename: 'HeaderDropdownRecord', label: string, analyticsId: string, dropdownItems: Array<{ __typename: 'FamilyHeaderItemRecord', id: string, family: { __typename: 'InsuranceProductFamilyRecord', id: string, name: string, slug: string, color: { __typename: 'ColorField', hex: string } }, products: Array<{ __typename: 'ProductHeaderItemRecord', id: string, label: string | null, link: { __typename: 'InsuranceProductFamilyRecord', id: string, name: string, slug: string } | { __typename: 'InsuranceProductRecord', id: string, name: string, slug: string, currentVersion: { __typename: 'InsuranceProductVersionRecord', externalLink: string | null } } | { __typename: 'PageRecord', id: string, name: string, slug: string }, targetGroups: Array<{ __typename: 'TargetGroupHeaderItemRecord', id: string, label: string | null, link: { __typename: 'InsuranceProductFamilyRecord', id: string, name: string, slug: string } | { __typename: 'PageRecord', id: string, name: string, slug: string } | { __typename: 'TargetGroupRecord', id: string, name: string, slug: string } }> }> } | { __typename: 'HeaderItemRecord', id: string, page: { __typename: 'PageRecord', id: string, name: string, slug: string } }> } | { __typename: 'InlineLinkButtonRecord', id: string, url: string | null, label: string, linkType: string, linkStyle: string, jumpMark: string | null, analyticsId: string, text: string | null, title: string | null, internal: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | { __typename: 'PageRecord', slug: string } | null, leftIcon: { __typename: 'IconReferenceRecord', name: string } | null, rightIcon: { __typename: 'IconReferenceRecord', name: string } | null } | { __typename: 'InlineModalButtonRecord', id: string, label: string, linkStyle: string, modalName: string, analyticsId: string, enablePrefill: boolean | null, text: string | null, leftIcon: { __typename: 'IconReferenceRecord', name: string } | null, rightIcon: { __typename: 'IconReferenceRecord', name: string } | null, product: { __typename: 'InsuranceProductRecord', slug: string, externalProvider: string | null, productCode: DatoJsonField, targetGroup: { __typename: 'TargetGroupRecord', id: string, slug: string } | null, productFamily: { __typename: 'InsuranceProductFamilyRecord', id: string, slug: string } } | null }> } | null, _seoMetaTags: Array<{ __typename: 'Tag', attributes: any | null, content: string | null, tag: string }>, breadcrumbs: Array<{ __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, parent: { __typename: 'BreadcrumbRecord', name: string, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } } | null, target: { __typename: 'InsuranceProductFamilyRecord', slug: string } | { __typename: 'InsuranceProductRecord', slug: string } | { __typename: 'PageRecord', slug: string } | { __typename: 'TargetGroupRecord', slug: string } }> } | null };

export type GetAllTargetGroupsQueryVariables = Exact<{
  locale: SiteLocale;
}>;


export type GetAllTargetGroupsQuery = { __typename: 'Query', allTargetGroups: Array<{ __typename: 'TargetGroupRecord', id: string, name: string, slug: string, showContactForm: boolean | null, sendinblueFormUrl: string | null, demoFormSlug: string | null, messageFormSlug: string | null, callbackFormSlug: string | null, contact: { __typename: 'ContactRecord', id: string, name: string, availability: string, phoneNumber: string, email: string, modalText: string | null, text: string | null } }> };

export type GetContactImageQueryVariables = Exact<{
  locale: SiteLocale;
  id: Scalars['ItemId']['input'];
  contactImage: ImgixParams;
}>;


export type GetContactImageQuery = { __typename: 'Query', contact: { __typename: 'ContactRecord', photo: { __typename: 'FileField', _updatedAt: any, url: string, format: string, alt: string | null, width: number | null, height: number | null, responsiveImage: { __typename: 'ResponsiveImage', aspectRatio: number, alt: string | null, base64: string | null, height: number, src: string, title: string | null, width: number } | null } } | null };


export const GenericAssetFragmentFragmentDoc = `
    fragment GenericAssetFragment on FileField {
  __typename
  _updatedAt
  url
  format
  alt
  width
  height
}
    `;
export const ModularContentServiceBenefitFragmentDoc = `
    fragment ModularContentServiceBenefit on ServiceBenefitRecord {
  id
  title
  iconPosition
  benefits {
    id
    title
    text
    icon {
      ...GenericAssetFragment
      url
    }
  }
}
    `;
export const BreadcrumbFragmentDoc = `
    fragment Breadcrumb on BreadcrumbRecord {
  name
  target {
    ... on InsuranceProductFamilyRecord {
      __typename
      slug
    }
    ... on InsuranceProductRecord {
      __typename
      slug
    }
    ... on TargetGroupRecord {
      __typename
      slug
    }
    ... on PageRecord {
      __typename
      slug
    }
  }
}
    `;
export const InlineLinkButtonFragmentDoc = `
    fragment InlineLinkButton on InlineLinkButtonRecord {
  __typename
  id
  url
  label
  linkType
  linkStyle
  jumpMark
  analyticsId
  internal {
    __typename
    ... on PageRecord {
      slug
    }
    ... on BreadcrumbRecord {
      ...Breadcrumb
      parent {
        ...Breadcrumb
        parent {
          ...Breadcrumb
          parent {
            ...Breadcrumb
            parent {
              ...Breadcrumb
            }
          }
        }
      }
    }
  }
  leftIcon {
    name
  }
  rightIcon {
    name
  }
  text
  title
}
    `;
export const InlineModalButtonFragmentDoc = `
    fragment InlineModalButton on InlineModalButtonRecord {
  __typename
  id
  label
  linkStyle
  modalName
  analyticsId
  enablePrefill
  leftIcon {
    name
  }
  rightIcon {
    name
  }
  product {
    slug
    externalProvider
    productCode
    targetGroup {
      id
      slug
    }
    productFamily {
      id
      slug
    }
  }
  text
}
    `;
export const ResponsiveImageFragmentFragmentDoc = `
    fragment ResponsiveImageFragment on ResponsiveImage {
  __typename
  aspectRatio
  alt
  base64
  height
  src
  title
  width
}
    `;
export const ModularContentHeroFragmentDoc = `
    fragment ModularContentHero on HeroRecord {
  id
  title
  subline
  text {
    __typename
    blocks {
      ...InlineLinkButton
      ...InlineModalButton
    }
    value
  }
  priceTagText
  startingPrice
  style
  cta {
    ...InlineLinkButton
    ...InlineModalButton
  }
  background {
    ...GenericAssetFragment
    responsiveImage(imgixParams: $contentImage) {
      ...ResponsiveImageFragment
    }
  }
}
    `;
export const ModularContentHeroSliderFragmentDoc = `
    fragment ModularContentHeroSlider on HeroSliderRecord {
  id
  slides {
    id
    title
    subline
    text {
      __typename
      blocks {
        ...InlineLinkButton
        ...InlineModalButton
      }
      value
    }
    priceTagText
    startingPrice
    style
    cta {
      ...InlineLinkButton
      ...InlineModalButton
    }
    background {
      ...GenericAssetFragment
      responsiveImage(imgixParams: $heroSlideImage) {
        ...ResponsiveImageFragment
      }
    }
  }
}
    `;
export const PersonaFactSingleBlockFragmentDoc = `
    fragment PersonaFactSingleBlock on PersonaFactRecord {
  __typename
  id
  name
  value
}
    `;
export const ModularContentPersonaFragmentDoc = `
    fragment ModularContentPersona on PersonaRecord {
  id
  recommendationIcon {
    ...GenericAssetFragment
  }
  content {
    blocks {
      ...PersonaFactSingleBlock
    }
    value
  }
  video {
    video {
      streamingUrl
      thumbnailUrl
    }
  }
}
    `;
export const ModularContentPremiumCalcHeroFragmentDoc = `
    fragment ModularContentPremiumCalcHero on PremiumCalcHeroRecord {
  id
  title
  subline
  video {
    video {
      streamingUrl
      thumbnailUrl
    }
  }
}
    `;
export const ModularContentMissionFragmentDoc = `
    fragment ModularContentMission on MissionRecord {
  id
  text {
    value
  }
  image {
    ...GenericAssetFragment
    responsiveImage(imgixParams: $contentImage) {
      ...ResponsiveImageFragment
    }
  }
  style
}
    `;
export const ModularContentMissionSliderFragmentDoc = `
    fragment ModularContentMissionSlider on MissionSliderRecord {
  id
  slides {
    id
    text {
      value
    }
    image {
      ...GenericAssetFragment
      responsiveImage(imgixParams: $contentImage) {
        ...ResponsiveImageFragment
      }
    }
    style
  }
}
    `;
export const ModularContentImageTextSectionFragmentDoc = `
    fragment ModularContentImageTextSection on ImageTextSectionRecord {
  id
  imageTextSectionText: text {
    __typename
    blocks {
      ...InlineLinkButton
      ...InlineModalButton
    }
    value
  }
  imageTextSectionImage: image {
    ...GenericAssetFragment
    responsiveImage(imgixParams: $contentWideImage) {
      ...ResponsiveImageFragment
    }
  }
}
    `;
export const ModularContentBlogpostSectionFragmentDoc = `
    fragment ModularContentBlogpostSection on BlogpostSectionRecord {
  id
  introText: intro {
    value
    links
    blocks {
      ... on InlineLinkButtonRecord {
        ...InlineLinkButton
      }
    }
  }
  topicSelector
  topicSelectorText
}
    `;
export const UserActionSectionItemFragmentDoc = `
    fragment UserActionSectionItem on UserActionSectionItemRecord {
  __typename
  id
  itemTitle: title
  itemText: text
  icon {
    name
  }
}
    `;
export const ModularContentUserActionSectionFragmentDoc = `
    fragment ModularContentUserActionSection on UserActionSectionRecord {
  id
  __typename
  headline
  userActions {
    ... on InlineLinkButtonRecord {
      ...InlineLinkButton
    }
    ... on InlineModalButtonRecord {
      ...InlineModalButton
    }
    ... on UserActionSectionItemRecord {
      ...UserActionSectionItem
    }
  }
}
    `;
export const ModularContentonNewsletterSignupFragmentDoc = `
    fragment ModularContentonNewsletterSignup on NewsletterSignupRecord {
  id
  __typename
  action
  title
  intro
}
    `;
export const OfferSingleBlockFragmentDoc = `
    fragment OfferSingleBlock on OfferSingleRecord {
  __typename
  id
  icon {
    ...GenericAssetFragment
  }
  text
  title
  link {
    ...InlineLinkButton
  }
}
    `;
export const ModularContentOffersFragmentDoc = `
    fragment ModularContentOffers on OffersBlockRecord {
  id
  offerText: text {
    value
    blocks {
      ...OfferSingleBlock
    }
  }
}
    `;
export const InlineAssetFragmentDoc = `
    fragment InlineAsset on InlineAssetRecord {
  __typename
  id
  limitWidth
  asset {
    __typename
    _updatedAt
    url
    format
    alt
    basename
    width
    height
    video {
      streamingUrl
      thumbnailUrl
    }
    responsiveImage(imgixParams: {fit: clip, auto: [format, compress]}) {
      ...ResponsiveImageFragment
    }
  }
}
    `;
export const InlineResponsiveSvgFragmentDoc = `
    fragment InlineResponsiveSvg on ResponsiveSvgRecord {
  __typename
  id
  alternativeText
  baseAsset {
    id
    height
    width
    url
    alt
  }
  steps {
    breakpoint
    asset {
      id
      height
      width
      url
      alt
    }
  }
}
    `;
export const InlineAssetGalleryFragmentDoc = `
    fragment InlineAssetGallery on InlineAssetGalleryRecord {
  __typename
  id
  assets {
    __typename
    _updatedAt
    url
    format
    alt
    basename
    width
    height
    video {
      streamingUrl
      thumbnailUrl
    }
    responsiveImage(imgixParams: {fit: clip, auto: [format, compress]}) {
      ...ResponsiveImageFragment
    }
  }
}
    `;
export const TextSectionTableFragmentDoc = `
    fragment TextSectionTable on TextSectionTableRecord {
  __typename
  id
  columns {
    id
    heading
    icon {
      ...GenericAssetFragment
      responsiveImage(
        imgixParams: {fit: clip, auto: [format, compress], w: 60, h: 60}
      ) {
        ...ResponsiveImageFragment
      }
    }
    items {
      id
      text
      icon {
        name
      }
    }
  }
}
    `;
export const TextSectionFragmentDoc = `
    fragment TextSection on TextSectionRecord {
  sectionText: text {
    value
    blocks {
      ...InlineLinkButton
      ...InlineModalButton
      ...InlineAsset
      ...InlineResponsiveSvg
      ...InlineAssetGallery
      ...TextSectionTable
    }
  }
  style
  showArrow
  backgroundColor {
    hex
  }
  fontColor {
    hex
  }
}
    `;
export const ModularContentTextSectionFragmentDoc = `
    fragment ModularContentTextSection on TextSectionRecord {
  id
  __typename
  ...TextSection
}
    `;
export const FaqsFragmentDoc = `
    fragment Faqs on FaqRecord {
  id
  title
  subtitle
  questions {
    id
    number
    question
    answer
  }
  insuranceProductFamilies {
    name
    slug
    color {
      hex
    }
  }
}
    `;
export const FaqSectionFragmentDoc = `
    fragment FaqSection on FaqSectionRecord {
  hasSearch
  sectionTitle: title
  sectionSubtitle: subtitle
  faqSectionText: text
  faqs {
    ...Faqs
  }
}
    `;
export const ModularContentFaqSectionFragmentDoc = `
    fragment ModularContentFaqSection on FaqSectionRecord {
  id
  __typename
  ...FaqSection
}
    `;
export const ModularContentAboutFragmentDoc = `
    fragment ModularContentAbout on AboutRecord {
  id
  __typename
  aboutSectionText: text {
    __typename
    blocks {
      ...InlineLinkButton
      ...InlineModalButton
      ...InlineAsset
    }
    value
  }
}
    `;
export const LogoWallSectionFragmentDoc = `
    fragment LogoWallSection on LogoWallSectionRecord {
  title
  logos {
    ...GenericAssetFragment
    responsiveImage(imgixParams: {fit: clip, auto: [format, compress]}) {
      ...ResponsiveImageFragment
    }
  }
}
    `;
export const ModularContentLogoWallFragmentDoc = `
    fragment ModularContentLogoWall on LogoWallSectionRecord {
  id
  __typename
  ...LogoWallSection
}
    `;
export const ContactInfoFragmentDoc = `
    fragment ContactInfo on ContactRecord {
  id
  name
  availability
  phoneNumber
  email
  modalText
  text
}
    `;
export const ProductSingleBlockFragmentDoc = `
    fragment ProductSingleBlock on ProductRecord {
  __typename
  id
  icon {
    ...GenericAssetFragment
  }
  title
  headerAlignment
  startingPrice
  priceDescription
  description {
    blocks {
      ...InlineLinkButton
      ...InlineModalButton
    }
    value
  }
  linkedProduct {
    id
    name
    slug
    productCode
    productName
    externalProvider
    showContactForm
    showTariffCalculator
    showMenu
    isOnlineApplication
    sendinblueFormUrl
    demoFormSlug
    messageFormSlug
    callbackFormSlug
    contact {
      ...ContactInfo
    }
    targetGroup {
      id
      name
      slug
      showContactForm
      sendinblueFormUrl
      demoFormSlug
      messageFormSlug
      callbackFormSlug
      contact {
        ...ContactInfo
      }
    }
    currentVersion {
      price
      priceDescription
      productDescription
      overviewFacts {
        value
      }
    }
    image {
      ...GenericAssetFragment
      responsiveImage(imgixParams: {fit: clip, w: 720, auto: [format, compress]}) {
        ...ResponsiveImageFragment
      }
    }
    productGroupName
    productGroupDescription
    productFamily {
      name
      slug
      color {
        hex
      }
    }
  }
}
    `;
export const ModularContentProductComparisonFragmentDoc = `
    fragment ModularContentProductComparison on ProductComparisonRecord {
  id
  __typename
  products {
    value
    blocks {
      ...ProductSingleBlock
    }
  }
  topicSelector
  topicSelectorText
  introAlignment
}
    `;
export const CustomerReviewSectionFragmentDoc = `
    fragment CustomerReviewSection on CustomerReviewsSectionRecord {
  title
  reviews {
    id
    name
    role
    quote
    photo {
      ...GenericAssetFragment
      responsiveImage(imgixParams: $contactImage) {
        ...ResponsiveImageFragment
      }
    }
  }
}
    `;
export const ModularContentCustomerReviewsSectionFragmentDoc = `
    fragment ModularContentCustomerReviewsSection on CustomerReviewsSectionRecord {
  id
  __typename
  ...CustomerReviewSection
}
    `;
export const CtaSectionFragmentDoc = `
    fragment CtaSection on CtaSectionRecord {
  title
  description: text
  linkButtons {
    ...InlineLinkButton
    ...InlineModalButton
  }
}
    `;
export const ModularContentCtaSectionFragmentDoc = `
    fragment ModularContentCtaSection on CtaSectionRecord {
  id
  __typename
  ...CtaSection
}
    `;
export const ContactSectionFragmentDoc = `
    fragment ContactSection on ContactSectionRecord {
  title
  subtitle
  contact {
    ...ContactInfo
  }
}
    `;
export const ModularContentContactSectionFragmentDoc = `
    fragment ModularContentContactSection on ContactSectionRecord {
  id
  __typename
  ...ContactSection
}
    `;
export const DemoSectionFragmentDoc = `
    fragment DemoSection on DemoSectionRecord {
  title
  subtitle
  demoText: text
  contact {
    ...ContactInfo
  }
}
    `;
export const ModularContentDemoSectionFragmentDoc = `
    fragment ModularContentDemoSection on DemoSectionRecord {
  id
  __typename
  ...DemoSection
}
    `;
export const ModularContentVideoCollectionFragmentDoc = `
    fragment ModularContentVideoCollection on VideoCollectionRecord {
  id
  __typename
  text: intro {
    value
    links
    blocks {
      ... on InlineAssetRecord {
        ...InlineAsset
      }
      ... on InlineLinkButtonRecord {
        ...InlineLinkButton
      }
      ... on InlineModalButtonRecord {
        ...InlineModalButton
      }
    }
  }
  columns {
    id
    title
    items {
      id
      subline
      title
      thumbnail {
        ...GenericAssetFragment
        responsiveImage(imgixParams: $videoThumbnailImage) {
          ...ResponsiveImageFragment
        }
      }
      video {
        video {
          streamingUrl
          thumbnailUrl
        }
      }
    }
  }
}
    `;
export const ModularContentFunctionalityCollectionFragmentDoc = `
    fragment ModularContentFunctionalityCollection on FunctionalityCollectionRecord {
  id
  __typename
  text: intro {
    value
    links
    blocks {
      ... on InlineAssetRecord {
        ...InlineAsset
      }
      ... on InlineLinkButtonRecord {
        ...InlineLinkButton
      }
    }
  }
  columns {
    id
    title
    items {
      title
      id
      text
    }
  }
}
    `;
export const NewsletterSectionFragmentDoc = `
    fragment NewsletterSection on NewsletterSectionRecord {
  topContent {
    blocks
    links
    value
  }
  bottomContent {
    blocks
    links
    value
  }
}
    `;
export const ModularContentNewsletterSectionFragmentDoc = `
    fragment ModularContentNewsletterSection on NewsletterSectionRecord {
  id
  __typename
  ...NewsletterSection
}
    `;
export const ModularContentFlipperSectionFragmentDoc = `
    fragment ModularContentFlipperSection on FlipperSectionRecord {
  id
  __typename
  pageLimitMobile
  text: intro {
    value
    links
    blocks {
      ... on InlineAssetRecord {
        ...InlineAsset
      }
      ... on InlineLinkButtonRecord {
        ...InlineLinkButton
      }
    }
  }
  flippers {
    text
    title
    id
    icon {
      ...GenericAssetFragment
      responsiveImage(imgixParams: $contentImage) {
        ...ResponsiveImageFragment
      }
    }
  }
}
    `;
export const TargetGroupHeaderItemFragmentDoc = `
    fragment TargetGroupHeaderItem on TargetGroupHeaderItemRecord {
  id
  __typename
  label
  link {
    ... on PageRecord {
      id
      __typename
      name
      slug
    }
    ... on TargetGroupRecord {
      id
      __typename
      name
      slug
    }
    ... on InsuranceProductFamilyRecord {
      id
      __typename
      name
      slug
    }
  }
}
    `;
export const ProductHeaderItemFragmentDoc = `
    fragment ProductHeaderItem on ProductHeaderItemRecord {
  id
  __typename
  label
  link {
    ... on InsuranceProductRecord {
      id
      __typename
      name
      slug
      currentVersion {
        externalLink
      }
    }
    ... on PageRecord {
      id
      __typename
      name
      slug
    }
    ... on InsuranceProductFamilyRecord {
      id
      __typename
      name
      slug
    }
  }
  targetGroups {
    ...TargetGroupHeaderItem
  }
}
    `;
export const HeaderDropdownFragmentDoc = `
    fragment HeaderDropdown on HeaderDropdownRecord {
  __typename
  label
  analyticsId
  dropdownItems {
    ... on FamilyHeaderItemRecord {
      id
      __typename
      family {
        id
        __typename
        name
        slug
        color {
          hex
        }
      }
      products {
        ...ProductHeaderItem
      }
    }
    ... on HeaderItemRecord {
      id
      __typename
      page {
        ... on PageRecord {
          id
          __typename
          name
          slug
        }
      }
    }
  }
}
    `;
export const HeaderFragmentDoc = `
    fragment Header on HeaderRecord {
  headerLogo {
    ...GenericAssetFragment
    responsiveImage(
      imgixParams: {fit: clip, w: 80, h: 80, auto: [format, compress]}
    ) {
      ...ResponsiveImageFragment
    }
  }
  links {
    ...InlineLinkButton
    ...InlineModalButton
    ...HeaderDropdown
  }
}
    `;
export const OnboardingFragmentDoc = `
    fragment Onboarding on OnboardingRecord {
  slides {
    id
    title
    text
    image {
      ...GenericAssetFragment
      responsiveImage(imgixParams: {fit: clip, w: 720, auto: [format, compress]}) {
        ...ResponsiveImageFragment
      }
    }
  }
}
    `;
export const ModularContentNavigationSectionFragmentDoc = `
    fragment ModularContentNavigationSection on NavigationSectionRecord {
  id
  __typename
  links {
    ... on InlineLinkButtonRecord {
      ...InlineLinkButton
    }
  }
}
    `;
export const ModularContentLinkCardsSectionFragmentDoc = `
    fragment ModularContentLinkCardsSection on LinkCardsSectionRecord {
  __typename
  id
  cards {
    __typename
    id
    image {
      ...GenericAssetFragment
      responsiveImage(imgixParams: {fit: clip, w: 480, auto: [format, compress]}) {
        ...ResponsiveImageFragment
      }
    }
    title
    variant
    links {
      ...InlineLinkButton
    }
  }
}
    `;
export const EmailFragmentDoc = `
    fragment Email on EmailRecord {
  id
  __typename
  email
}
    `;
export const HeadingFragmentDoc = `
    fragment Heading on HeadingRecord {
  id
  __typename
  left
  right
}
    `;
export const ClaimModalFragmentDoc = `
    fragment ClaimModal on ClaimModalRecord {
  title
  text {
    variant
    text {
      value
      blocks {
        ...Email
        ...Heading
      }
    }
  }
  types {
    icon {
      name
    }
    name
  }
}
    `;
export const VideoSectionPersonaFragmentDoc = `
    fragment VideoSectionPersona on VideoSectionPersonaRecord {
  __typename
  id
  icon {
    ...GenericAssetFragment
  }
  title
  text {
    __typename
    blocks {
      ...InlineLinkButton
      ...InlineModalButton
    }
    value
  }
}
    `;
export const ModularContentVideoSectionFragmentDoc = `
    fragment ModularContentVideoSection on VideoSectionRecord {
  __typename
  id
  topline
  introTitle: title
  button {
    ...InlineLinkButton
    ...InlineModalButton
  }
  fullBleed
  asset {
    ...GenericAssetFragment
    responsiveImage(imgixParams: {fit: clip, w: 1440, auto: [format, compress]}) {
      ...ResponsiveImageFragment
    }
    video {
      streamingUrl
      thumbnailUrl
    }
  }
  topic
  topicSubline {
    __typename
    value
    blocks {
      ...InlineLinkButton
      ...InlineModalButton
    }
  }
  topicText: text {
    __typename
    blocks {
      ...InlineLinkButton
      ...InlineModalButton
    }
    value
  }
  variant
  persona {
    ...VideoSectionPersona
  }
}
    `;
export const ModularContentServiceOverviewSectionFragmentDoc = `
    fragment ModularContentServiceOverviewSection on ServiceOverviewSectionRecord {
  id
  __typename
  title
  items {
    id
    service
    description {
      blocks
      inlineBlocks
      links
      value
    }
  }
}
    `;
export const ModularContentActionTeaserSectionFragmentDoc = `
    fragment ModularContentActionTeaserSection on ActionTeaserSectionRecord {
  id
  __typename
  title
  subtitle
  items {
    id
    label
    image {
      ...GenericAssetFragment
      responsiveImage(imgixParams: {fit: clip, w: 80, auto: [format, compress]}) {
        ...ResponsiveImageFragment
      }
    }
  }
  modalButton: button {
    ...InlineModalButton
  }
}
    `;
export const GetAllBlogpostsForBlogSectionDocument = `
    query getAllBlogpostsForBlogSection($locale: SiteLocale!) {
  allBlogposts(locale: $locale, fallbackLocales: [de], orderBy: date_DESC) {
    allSlugLocales: _allSlugLocales {
      locale
      value
    }
    id
    title
    slug
    date
    productFamily: topic {
      name
      slug
      color {
        hex
      }
    }
    teaserText
    teaserImage {
      ...GenericAssetFragment
      responsiveImage(imgixParams: {fit: clip, w: 480, auto: [format, compress]}) {
        ...ResponsiveImageFragment
      }
    }
    brands {
      slug
    }
  }
}
    ${GenericAssetFragmentFragmentDoc}
${ResponsiveImageFragmentFragmentDoc}`;

export const useGetAllBlogpostsForBlogSectionQuery = <
      TData = GetAllBlogpostsForBlogSectionQuery,
      TError = unknown
    >(
      variables: GetAllBlogpostsForBlogSectionQueryVariables,
      options?: Omit<UseQueryOptions<GetAllBlogpostsForBlogSectionQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetAllBlogpostsForBlogSectionQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetAllBlogpostsForBlogSectionQuery, TError, TData>(
      {
    queryKey: ['getAllBlogpostsForBlogSection', variables],
    queryFn: fetcher<GetAllBlogpostsForBlogSectionQuery, GetAllBlogpostsForBlogSectionQueryVariables>(GetAllBlogpostsForBlogSectionDocument, variables),
    ...options
  }
    )};

export const GetFaviconDocument = `
    query getFavicon($locale: SiteLocale!, $brandSlug: String!) {
  brand(locale: $locale, fallbackLocales: [de], filter: {slug: {eq: $brandSlug}}) {
    favicon {
      url
    }
  }
}
    `;

export const useGetFaviconQuery = <
      TData = GetFaviconQuery,
      TError = unknown
    >(
      variables: GetFaviconQueryVariables,
      options?: Omit<UseQueryOptions<GetFaviconQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetFaviconQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetFaviconQuery, TError, TData>(
      {
    queryKey: ['getFavicon', variables],
    queryFn: fetcher<GetFaviconQuery, GetFaviconQueryVariables>(GetFaviconDocument, variables),
    ...options
  }
    )};

export const GetInsuranceVersionTextByProductIdDocument = `
    query getInsuranceVersionTextByProductId($id: ItemId!, $locale: SiteLocale!) {
  insuranceProduct(
    filter: {id: {eq: $id}}
    locale: $locale
    fallbackLocales: [de]
  ) {
    version: currentVersion {
      text: coverageText {
        value
        blocks {
          ... on InlineAssetRecord {
            ...InlineAsset
          }
          ... on InlineLinkButtonRecord {
            ...InlineLinkButton
          }
          ... on InlineModalButtonRecord {
            ...InlineModalButton
          }
        }
      }
      price
      externalClaimLink
    }
  }
}
    ${InlineAssetFragmentDoc}
${ResponsiveImageFragmentFragmentDoc}
${InlineLinkButtonFragmentDoc}
${BreadcrumbFragmentDoc}
${InlineModalButtonFragmentDoc}`;

export const useGetInsuranceVersionTextByProductIdQuery = <
      TData = GetInsuranceVersionTextByProductIdQuery,
      TError = unknown
    >(
      variables: GetInsuranceVersionTextByProductIdQueryVariables,
      options?: Omit<UseQueryOptions<GetInsuranceVersionTextByProductIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetInsuranceVersionTextByProductIdQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetInsuranceVersionTextByProductIdQuery, TError, TData>(
      {
    queryKey: ['getInsuranceVersionTextByProductId', variables],
    queryFn: fetcher<GetInsuranceVersionTextByProductIdQuery, GetInsuranceVersionTextByProductIdQueryVariables>(GetInsuranceVersionTextByProductIdDocument, variables),
    ...options
  }
    )};

export const GetAllInsuranceProductsForPortalDocument = `
    query getAllInsuranceProductsForPortal($locale: SiteLocale!) {
  allInsuranceProducts(orderBy: name_ASC, locale: $locale, fallbackLocales: [de]) {
    id
    name
    slug
    insurer
    productCode
    productName
    embedUrl
    userActions
    externalProvider
    showContactForm
    showTariffCalculator
    showMenu
    isOnlineApplication
    sendinblueFormUrl
    demoFormSlug
    messageFormSlug
    callbackFormSlug
    contact {
      ...ContactInfo
    }
    targetGroup {
      id
      name
      slug
      tagline
      showContactForm
      demoFormSlug
      messageFormSlug
      callbackFormSlug
      sendinblueFormUrl
      contact {
        ...ContactInfo
      }
    }
    _seoMetaTags {
      attributes
      content
      tag
    }
    seo {
      description
      title
      twitterCard
    }
    currentVersion {
      price
    }
    productFamily {
      slug
      color {
        hex
      }
    }
  }
}
    ${ContactInfoFragmentDoc}`;

export const useGetAllInsuranceProductsForPortalQuery = <
      TData = GetAllInsuranceProductsForPortalQuery,
      TError = unknown
    >(
      variables: GetAllInsuranceProductsForPortalQueryVariables,
      options?: Omit<UseQueryOptions<GetAllInsuranceProductsForPortalQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetAllInsuranceProductsForPortalQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetAllInsuranceProductsForPortalQuery, TError, TData>(
      {
    queryKey: ['getAllInsuranceProductsForPortal', variables],
    queryFn: fetcher<GetAllInsuranceProductsForPortalQuery, GetAllInsuranceProductsForPortalQueryVariables>(GetAllInsuranceProductsForPortalDocument, variables),
    ...options
  }
    )};

export const GetInsuranceProductsByTargetGroupDocument = `
    query getInsuranceProductsByTargetGroup($targetGroupId: ItemId!, $locale: SiteLocale!) {
  allInsuranceProducts(
    filter: {targetGroup: {eq: $targetGroupId}}
    locale: $locale
    fallbackLocales: [de]
  ) {
    name
    productCode
    productName
    slug
    currentVersion {
      productDescription
      priceDescription
      price
    }
  }
}
    `;

export const useGetInsuranceProductsByTargetGroupQuery = <
      TData = GetInsuranceProductsByTargetGroupQuery,
      TError = unknown
    >(
      variables: GetInsuranceProductsByTargetGroupQueryVariables,
      options?: Omit<UseQueryOptions<GetInsuranceProductsByTargetGroupQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetInsuranceProductsByTargetGroupQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetInsuranceProductsByTargetGroupQuery, TError, TData>(
      {
    queryKey: ['getInsuranceProductsByTargetGroup', variables],
    queryFn: fetcher<GetInsuranceProductsByTargetGroupQuery, GetInsuranceProductsByTargetGroupQueryVariables>(GetInsuranceProductsByTargetGroupDocument, variables),
    ...options
  }
    )};

export const GetAllInsuranceProductsDocument = `
    query getAllInsuranceProducts($locale: SiteLocale!) {
  allInsuranceProducts(locale: $locale, fallbackLocales: [de], orderBy: name_ASC) {
    id
    name
    slug
    productCode
    productName
    productFamily {
      name
      slug
      color {
        hex
      }
    }
    sendinblueFormUrl
    showContactForm
    showTariffCalculator
    showMenu
    isOnlineApplication
    demoFormSlug
    messageFormSlug
    callbackFormSlug
    contact {
      ...ContactInfo
    }
    targetGroup {
      id
      name
      slug
      sendinblueFormUrl
      showContactForm
      demoFormSlug
      messageFormSlug
      callbackFormSlug
      contact {
        ...ContactInfo
      }
    }
    currentVersion {
      price
      priceDescription
      productDescription
      overviewFacts {
        value
      }
      externalLink
      externalLinkText
    }
    image {
      ...GenericAssetFragment
      responsiveImage(imgixParams: {fit: clip, w: 720, auto: [format, compress]}) {
        ...ResponsiveImageFragment
      }
    }
    productGroupName
    productGroupDescription
    externalProvider
  }
}
    ${ContactInfoFragmentDoc}
${GenericAssetFragmentFragmentDoc}
${ResponsiveImageFragmentFragmentDoc}`;

export const useGetAllInsuranceProductsQuery = <
      TData = GetAllInsuranceProductsQuery,
      TError = unknown
    >(
      variables: GetAllInsuranceProductsQueryVariables,
      options?: Omit<UseQueryOptions<GetAllInsuranceProductsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetAllInsuranceProductsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetAllInsuranceProductsQuery, TError, TData>(
      {
    queryKey: ['getAllInsuranceProducts', variables],
    queryFn: fetcher<GetAllInsuranceProductsQuery, GetAllInsuranceProductsQueryVariables>(GetAllInsuranceProductsDocument, variables),
    ...options
  }
    )};

export const GetInsuranceProductsByFamilyIdDocument = `
    query getInsuranceProductsByFamilyId($familyId: ItemId!, $locale: SiteLocale!) {
  allInsuranceProducts(
    locale: $locale
    fallbackLocales: [de]
    filter: {productFamily: {eq: $familyId}}
    orderBy: name_ASC
  ) {
    id
    name
    slug
    productCode
    productName
    externalProvider
    showContactForm
    showTariffCalculator
    showMenu
    isOnlineApplication
    sendinblueFormUrl
    demoFormSlug
    messageFormSlug
    callbackFormSlug
    contact {
      ...ContactInfo
    }
    targetGroup {
      id
      name
      slug
      showContactForm
      sendinblueFormUrl
      demoFormSlug
      messageFormSlug
      callbackFormSlug
      contact {
        ...ContactInfo
      }
    }
    currentVersion {
      price
      priceDescription
      productDescription
      overviewFacts {
        value
      }
      externalLink
      externalLinkText
    }
    image {
      ...GenericAssetFragment
      responsiveImage(imgixParams: {fit: clip, w: 720, auto: [format, compress]}) {
        ...ResponsiveImageFragment
      }
    }
    productGroupName
    productGroupDescription
    productFamily {
      name
      slug
      color {
        hex
      }
    }
  }
}
    ${ContactInfoFragmentDoc}
${GenericAssetFragmentFragmentDoc}
${ResponsiveImageFragmentFragmentDoc}`;

export const useGetInsuranceProductsByFamilyIdQuery = <
      TData = GetInsuranceProductsByFamilyIdQuery,
      TError = unknown
    >(
      variables: GetInsuranceProductsByFamilyIdQueryVariables,
      options?: Omit<UseQueryOptions<GetInsuranceProductsByFamilyIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetInsuranceProductsByFamilyIdQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetInsuranceProductsByFamilyIdQuery, TError, TData>(
      {
    queryKey: ['getInsuranceProductsByFamilyId', variables],
    queryFn: fetcher<GetInsuranceProductsByFamilyIdQuery, GetInsuranceProductsByFamilyIdQueryVariables>(GetInsuranceProductsByFamilyIdDocument, variables),
    ...options
  }
    )};

export const GetInsuranceProductsBySlugDocument = `
    query getInsuranceProductsBySlug($slugs: [String!]!, $locale: SiteLocale!) {
  allInsuranceProducts(
    locale: $locale
    fallbackLocales: [de]
    filter: {slug: {in: $slugs}}
    orderBy: name_ASC
  ) {
    id
    name
    slug
    productCode
    productName
    externalProvider
    showContactForm
    showTariffCalculator
    showMenu
    isOnlineApplication
    sendinblueFormUrl
    demoFormSlug
    messageFormSlug
    callbackFormSlug
    contact {
      ...ContactInfo
    }
    targetGroup {
      id
      name
      slug
      showContactForm
      sendinblueFormUrl
      demoFormSlug
      messageFormSlug
      callbackFormSlug
      contact {
        ...ContactInfo
      }
    }
    currentVersion {
      price
      priceDescription
      productDescription
      overviewFacts {
        value
      }
      externalLink
      externalLinkText
    }
    image {
      ...GenericAssetFragment
      responsiveImage(imgixParams: {fit: clip, w: 720, auto: [format, compress]}) {
        ...ResponsiveImageFragment
      }
    }
    productGroupName
    productGroupDescription
    productFamily {
      name
      slug
      color {
        hex
      }
    }
  }
}
    ${ContactInfoFragmentDoc}
${GenericAssetFragmentFragmentDoc}
${ResponsiveImageFragmentFragmentDoc}`;

export const useGetInsuranceProductsBySlugQuery = <
      TData = GetInsuranceProductsBySlugQuery,
      TError = unknown
    >(
      variables: GetInsuranceProductsBySlugQueryVariables,
      options?: Omit<UseQueryOptions<GetInsuranceProductsBySlugQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetInsuranceProductsBySlugQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetInsuranceProductsBySlugQuery, TError, TData>(
      {
    queryKey: ['getInsuranceProductsBySlug', variables],
    queryFn: fetcher<GetInsuranceProductsBySlugQuery, GetInsuranceProductsBySlugQueryVariables>(GetInsuranceProductsBySlugDocument, variables),
    ...options
  }
    )};

export const GetAllInsuranceProductsForPremiumCalcDocument = `
    query getAllInsuranceProductsForPremiumCalc($locale: SiteLocale!, $brandSlug: String!) {
  allBrands(filter: {slug: {eq: $brandSlug}}) {
    _allReferencingInsuranceProducts(
      locale: $locale
      fallbackLocales: [de]
      orderBy: name_ASC
    ) {
      id
      name
      slug
      productCode
      productName
      embedUrl
      externalProvider
      disabled
      sendinblueFormUrl
      showContactForm
      showTariffCalculator
      showMenu
      isOnlineApplication
      demoFormSlug
      messageFormSlug
      callbackFormSlug
      contact {
        ...ContactInfo
      }
      productFamily {
        name
        slug
        color {
          hex
        }
      }
      targetGroup {
        id
        name
        slug
        tagline
        showContactForm
        sendinblueFormUrl
        demoFormSlug
        messageFormSlug
        callbackFormSlug
        contact {
          ...ContactInfo
        }
        header {
          ...Header
        }
        _seoMetaTags {
          attributes
          content
          tag
        }
        breadcrumbs {
          ...Breadcrumb
          parent {
            ...Breadcrumb
            parent {
              ...Breadcrumb
              parent {
                ...Breadcrumb
                parent {
                  ...Breadcrumb
                }
              }
            }
          }
        }
      }
      currentVersion {
        price
        priceDescription
        productDescription
        overviewFacts {
          value
        }
        externalLink
        externalLinkText
      }
      image {
        ...GenericAssetFragment
        responsiveImage(imgixParams: {fit: clip, w: 720, auto: [format, compress]}) {
          ...ResponsiveImageFragment
        }
      }
      productGroupName
      productGroupDescription
    }
  }
}
    ${ContactInfoFragmentDoc}
${HeaderFragmentDoc}
${GenericAssetFragmentFragmentDoc}
${ResponsiveImageFragmentFragmentDoc}
${InlineLinkButtonFragmentDoc}
${BreadcrumbFragmentDoc}
${InlineModalButtonFragmentDoc}
${HeaderDropdownFragmentDoc}
${ProductHeaderItemFragmentDoc}
${TargetGroupHeaderItemFragmentDoc}`;

export const useGetAllInsuranceProductsForPremiumCalcQuery = <
      TData = GetAllInsuranceProductsForPremiumCalcQuery,
      TError = unknown
    >(
      variables: GetAllInsuranceProductsForPremiumCalcQueryVariables,
      options?: Omit<UseQueryOptions<GetAllInsuranceProductsForPremiumCalcQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetAllInsuranceProductsForPremiumCalcQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetAllInsuranceProductsForPremiumCalcQuery, TError, TData>(
      {
    queryKey: ['getAllInsuranceProductsForPremiumCalc', variables],
    queryFn: fetcher<GetAllInsuranceProductsForPremiumCalcQuery, GetAllInsuranceProductsForPremiumCalcQueryVariables>(GetAllInsuranceProductsForPremiumCalcDocument, variables),
    ...options
  }
    )};

export const GetAllInsuranceProductsForPremiumCalcBySlugDocument = `
    query getAllInsuranceProductsForPremiumCalcBySlug($locale: SiteLocale!, $slug: String!) {
  allInsuranceProducts(
    locale: $locale
    filter: {slug: {eq: $slug}}
    fallbackLocales: [de]
    orderBy: name_ASC
  ) {
    id
    name
    slug
    productCode
    productName
    embedUrl
    externalProvider
    disabled
    sendinblueFormUrl
    showContactForm
    showTariffCalculator
    showMenu
    isOnlineApplication
    demoFormSlug
    messageFormSlug
    callbackFormSlug
    contact {
      ...ContactInfo
    }
    productFamily {
      name
      slug
      color {
        hex
      }
    }
    header {
      ...Header
    }
    targetGroup {
      id
      name
      slug
      tagline
      showContactForm
      sendinblueFormUrl
      demoFormSlug
      messageFormSlug
      callbackFormSlug
      contact {
        ...ContactInfo
      }
      header {
        ...Header
      }
      _seoMetaTags {
        attributes
        content
        tag
      }
      breadcrumbs {
        ...Breadcrumb
        parent {
          ...Breadcrumb
          parent {
            ...Breadcrumb
            parent {
              ...Breadcrumb
              parent {
                ...Breadcrumb
              }
            }
          }
        }
      }
    }
    currentVersion {
      price
      priceDescription
      productDescription
      overviewFacts {
        value
      }
      externalLink
      externalLinkText
    }
    image {
      ...GenericAssetFragment
      responsiveImage(imgixParams: {fit: clip, w: 720, auto: [format, compress]}) {
        ...ResponsiveImageFragment
      }
    }
    productGroupName
    productGroupDescription
  }
}
    ${ContactInfoFragmentDoc}
${HeaderFragmentDoc}
${GenericAssetFragmentFragmentDoc}
${ResponsiveImageFragmentFragmentDoc}
${InlineLinkButtonFragmentDoc}
${BreadcrumbFragmentDoc}
${InlineModalButtonFragmentDoc}
${HeaderDropdownFragmentDoc}
${ProductHeaderItemFragmentDoc}
${TargetGroupHeaderItemFragmentDoc}`;

export const useGetAllInsuranceProductsForPremiumCalcBySlugQuery = <
      TData = GetAllInsuranceProductsForPremiumCalcBySlugQuery,
      TError = unknown
    >(
      variables: GetAllInsuranceProductsForPremiumCalcBySlugQueryVariables,
      options?: Omit<UseQueryOptions<GetAllInsuranceProductsForPremiumCalcBySlugQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetAllInsuranceProductsForPremiumCalcBySlugQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetAllInsuranceProductsForPremiumCalcBySlugQuery, TError, TData>(
      {
    queryKey: ['getAllInsuranceProductsForPremiumCalcBySlug', variables],
    queryFn: fetcher<GetAllInsuranceProductsForPremiumCalcBySlugQuery, GetAllInsuranceProductsForPremiumCalcBySlugQueryVariables>(GetAllInsuranceProductsForPremiumCalcBySlugDocument, variables),
    ...options
  }
    )};

export const GetTargetGroupBySlugDocument = `
    query getTargetGroupBySlug($locale: SiteLocale!, $targetGroupSlug: String!) {
  targetGroup(
    locale: $locale
    fallbackLocales: [de]
    filter: {slug: {eq: $targetGroupSlug}}
  ) {
    allSlugLocales: _allSlugLocales {
      locale
      value
    }
    id
    name
    slug
    tagline
    showContactForm
    sendinblueFormUrl
    demoFormSlug
    messageFormSlug
    callbackFormSlug
    contact {
      ...ContactInfo
    }
    header {
      ...Header
    }
    _seoMetaTags {
      attributes
      content
      tag
    }
    breadcrumbs {
      ...Breadcrumb
      parent {
        ...Breadcrumb
        parent {
          ...Breadcrumb
          parent {
            ...Breadcrumb
            parent {
              ...Breadcrumb
            }
          }
        }
      }
    }
  }
}
    ${ContactInfoFragmentDoc}
${HeaderFragmentDoc}
${GenericAssetFragmentFragmentDoc}
${ResponsiveImageFragmentFragmentDoc}
${InlineLinkButtonFragmentDoc}
${BreadcrumbFragmentDoc}
${InlineModalButtonFragmentDoc}
${HeaderDropdownFragmentDoc}
${ProductHeaderItemFragmentDoc}
${TargetGroupHeaderItemFragmentDoc}`;

export const useGetTargetGroupBySlugQuery = <
      TData = GetTargetGroupBySlugQuery,
      TError = unknown
    >(
      variables: GetTargetGroupBySlugQueryVariables,
      options?: Omit<UseQueryOptions<GetTargetGroupBySlugQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetTargetGroupBySlugQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetTargetGroupBySlugQuery, TError, TData>(
      {
    queryKey: ['getTargetGroupBySlug', variables],
    queryFn: fetcher<GetTargetGroupBySlugQuery, GetTargetGroupBySlugQueryVariables>(GetTargetGroupBySlugDocument, variables),
    ...options
  }
    )};

export const GetAllTargetGroupsDocument = `
    query getAllTargetGroups($locale: SiteLocale!) {
  allTargetGroups(locale: $locale, fallbackLocales: [de], orderBy: name_ASC) {
    id
    name
    slug
    showContactForm
    sendinblueFormUrl
    demoFormSlug
    messageFormSlug
    callbackFormSlug
    contact {
      ...ContactInfo
    }
  }
}
    ${ContactInfoFragmentDoc}`;

export const useGetAllTargetGroupsQuery = <
      TData = GetAllTargetGroupsQuery,
      TError = unknown
    >(
      variables: GetAllTargetGroupsQueryVariables,
      options?: Omit<UseQueryOptions<GetAllTargetGroupsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetAllTargetGroupsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetAllTargetGroupsQuery, TError, TData>(
      {
    queryKey: ['getAllTargetGroups', variables],
    queryFn: fetcher<GetAllTargetGroupsQuery, GetAllTargetGroupsQueryVariables>(GetAllTargetGroupsDocument, variables),
    ...options
  }
    )};

export const GetContactImageDocument = `
    query getContactImage($locale: SiteLocale!, $id: ItemId!, $contactImage: ImgixParams!) {
  contact(locale: $locale, fallbackLocales: [de], filter: {id: {eq: $id}}) {
    photo {
      ...GenericAssetFragment
      responsiveImage(imgixParams: $contactImage) {
        ...ResponsiveImageFragment
      }
    }
  }
}
    ${GenericAssetFragmentFragmentDoc}
${ResponsiveImageFragmentFragmentDoc}`;

export const useGetContactImageQuery = <
      TData = GetContactImageQuery,
      TError = unknown
    >(
      variables: GetContactImageQueryVariables,
      options?: Omit<UseQueryOptions<GetContactImageQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetContactImageQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetContactImageQuery, TError, TData>(
      {
    queryKey: ['getContactImage', variables],
    queryFn: fetcher<GetContactImageQuery, GetContactImageQueryVariables>(GetContactImageDocument, variables),
    ...options
  }
    )};
